export default {
  'notice-of-carefirst-blackout': {
    metadata: {
        tags: [],
        concepts: []
    },
    sys: {
        id: "2APJfhtsXIvjm5cSy6I3uM",
        type: "Entry",
        createdAt: "2025-09-25T16:33:04.067Z",
        updatedAt: "2025-09-25T16:33:04.067Z",
        publishedVersion: 4,
        revision: 1,
        locale: "en-US"
    },
    fields: {
        description: "Notice of Blackout - Carefirst",
        default_content: {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                id: "pq3tJyMRKU1YoM3xTDw4K",
                type: "Entry",
                createdAt: "2025-09-25T16:33:04.107Z",
                updatedAt: "2025-09-25T16:33:04.107Z",
                publishedVersion: 8,
                revision: 1,
                locale: "en-US"
            },
            fields: {
                title: "HSA Blackout Banner Carefirst Text",
                helpContent: "You are currently in a blackout period as we transition your account(s) to the HealthEquity portal. While you can %hqySSOLink% on the HealthEquity portal, your HSA balance will not be available until %migrationWaveDate%. We apologize for any inconvenience.",
                helpContentSlug: "hsa-blackout-banner-carefirst-text"
            }
        },
        contentAreaSlug: "notice-of-blackout-carefirst"
    }
  },
  'hia-transition-banner-text': {
    metadata: {
        tags: [],
        concepts: []
    },
    sys: {
        id: "5b7miuQGtYpdtKD6ADilGS",
        type: "Entry",
        createdAt: "2025-09-25T16:33:04.215Z",
        updatedAt: "2025-09-25T16:33:04.215Z",
        publishedVersion: 4,
        revision: 1,
        locale: "en-US"
    },
    fields: {
        description: "HIA Transition Banner Text",
        default_content: {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                id: "1rTvuZeZwDweKwTiV0p3Aj",
                type: "Entry",
                createdAt: "2025-09-25T16:33:04.233Z",
                updatedAt: "2025-09-25T16:33:04.233Z",
                publishedVersion: 7,
                revision: 1,
                locale: "en-US"
            },
            fields: {
                title: "HIA Transition Banner Text",
                helpContent: "__Your HIA account will be transitioning to our HealthEquity portal on %hiaMigrationWaveDate%.__ As a result, there will be a blackout period beginning %hiaBlackoutStartDate% to transition your account.",
                helpContentSlug: "hia-transition-banner-text"
            }
        },
        contentAreaSlug: "hia-transition-banner-text"
    }
  },
  'hia-black-banner-text': {
    metadata: {
        tags: [],
        concepts: []
    },
    sys: {
        id: "PEeQjeeRiV96pu2nHz68v",
        type: "Entry",
        createdAt: "2025-09-25T16:33:04.172Z",
        updatedAt: "2025-09-25T16:33:04.172Z",
        publishedVersion: 5,
        revision: 1,
        locale: "en-US"
    },
    fields: {
        description: "HIA Blackout Banner Text",
        default_content: {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                id: "46zACJi6AoabT3bJEvjbf5",
                type: "Entry",
                createdAt: "2025-09-25T16:33:04.193Z",
                updatedAt: "2025-09-25T16:33:04.193Z",
                publishedVersion: 15,
                revision: 1,
                locale: "en-US"
            },
            fields: {
                title: "HIA Blackout Banner Text",
                helpContent: "__You are currently in a blackout period as we transition your HIA to the HealthEquity portal.__ While you can access your account on the HealthEquity portal, your HIA balance will not be available until %hiaMigrationWaveDate%. We apologize for any inconvenience.",
                helpContentSlug: "hia-blackout-banner-text"
            }
        },
        contentAreaSlug: "hia-blackout-banner-text"
    }
  },
  'update-password-error-age': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '7wp7KEB1gQ2TrOGm05atof',
      type: 'Entry',
      createdAt: '2025-04-25T16:13:47.394Z',
      updatedAt: '2025-04-25T16:13:47.394Z',
      publishedVersion: 4,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Update Password - Error Age',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5QaqpeeTaQwRORmVUfbO6p',
          type: 'Entry',
          createdAt: '2025-04-25T16:13:29.018Z',
          updatedAt: '2025-04-25T16:13:29.018Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Update Password - Error Age - Default',
          content:
            '## An error has occurred\nYour password cannot change more than once in 24 hours.',
        },
      },
      contentAreaSlug: 'update-password-error-age',
    },
  },
  'update-password-error-name': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '72sZEYT16XNfZZE0Xa1OQ',
      type: 'Entry',
      createdAt: '2025-04-25T16:12:37.645Z',
      updatedAt: '2025-04-25T16:12:37.645Z',
      publishedVersion: 3,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Update Password - Error Name',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '7hdm3o7kiJ0nekjSNMfnBb',
          type: 'Entry',
          createdAt: '2025-04-25T16:12:12.979Z',
          updatedAt: '2025-04-25T16:12:12.979Z',
          publishedVersion: 4,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Update Password - Error Name - Default',
          content:
            '## An error has occurred\nYour password cannot contain user ID, first name, or last name.',
        },
      },
      contentAreaSlug: 'update-password-error-name',
    },
  },
  'update-password-error-history': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '5ainyJS6IiCWouKWqZDVnA',
      type: 'Entry',
      createdAt: '2025-04-15T19:19:54.686Z',
      updatedAt: '2025-04-15T19:19:54.686Z',
      publishedVersion: 3,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Update Password - Error History',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'RHgLKIVmL368KJop7XWwu',
          type: 'Entry',
          createdAt: '2025-04-15T19:19:16.478Z',
          updatedAt: '2025-04-15T19:19:16.478Z',
          publishedVersion: 8,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Update Password - Error History - Default',
          content:
            '## An error has occurred\nThe password you entered has already been used. Please create a new password.',
        },
      },
      contentAreaSlug: 'update-password-error-history',
    },
  },
  'login-error-password-reset': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2EBMKgQ4kiekJqj8mVf5Q5',
      type: 'Entry',
      createdAt: '2025-04-15T18:31:28.037Z',
      updatedAt: '2025-04-15T18:31:28.037Z',
      publishedVersion: 7,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Login Error - Password Reset',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4IEdoPFk69z8Pa3YaVAv79',
          type: 'Entry',
          createdAt: '2025-04-15T18:30:55.232Z',
          updatedAt: '2025-04-16T14:51:18.018Z',
          publishedVersion: 9,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'Login Error - Password Reset',
          content:
            'Due to new security initiatives to strengthen our password policy, we have reset all passwords. If you have not yet set a new password, please do so now via the forgot password link below. You can also contact Customer Service at (800) 859-2144 for assistance.',
        },
      },
      contentAreaSlug: 'login-error-password-reset',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3A8qKyHSaybVftxqRme3cK',
          type: 'Entry',
          createdAt: '2025-04-15T18:31:20.284Z',
          updatedAt: '2025-04-16T14:48:24.130Z',
          publishedVersion: 8,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Login Error - Password Reset - Capital Blue',
          content:
            'Due to new security initiatives to strengthen our password policy, we have reset all passwords. If you have not yet set a new password, please do so now via the forgot password link below. You can also contact Customer Service at 877.293.7041 for assistance.',
        },
      },
    },
  },
  'hsa-blackout-banner-text': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '6OWN6DBwH5h0e4jwmv3OJ9',
      type: 'Entry',
      createdAt: '2023-11-28T19:51:05.846Z',
      updatedAt: '2023-11-28T19:51:05.846Z',
      publishedVersion: 4,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'HSA Blackout Banner Text',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6FiwSSLeWstr7BhkMlziNo',
          type: 'Entry',
          createdAt: '2023-11-28T19:50:44.194Z',
          updatedAt: '2023-12-01T17:18:11.542Z',
          publishedVersion: 31,
          revision: 4,
          locale: 'en-US',
        },
        fields: {
          title: 'HSA Blackout Banner Text',
          helpContent:
            'You are currently in a blackout period as we transition your HSA to the HealthEquity portal. While you can%hqySSOLink% on the HealthEquity portal, your HSA balance will not be available until %migrationWaveDate%. We apologize for any inconvenience.',
          helpContentSlug: 'hsa-blackout-banner-text',
        },
      },
      contentAreaSlug: 'hsa-blackout-banner-text',
    },
  },
  'hsa-transition-banner-text': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4kcCHNJekpQ04Of5PGOgKI',
      type: 'Entry',
      createdAt: '2023-11-28T19:49:11.509Z',
      updatedAt: '2023-11-28T19:49:11.509Z',
      publishedVersion: 4,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'HSA Transition Banner Text',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6O2jelPJ8O3UfcnKFTC8EC',
          type: 'Entry',
          createdAt: '2023-11-28T19:48:28.412Z',
          updatedAt: '2023-12-01T16:00:36.237Z',
          publishedVersion: 17,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'HSA Transition Banner Text',
          helpContent:
            'Your account will be transitioning to our HealthEquity portal on %migrationWaveDate%. As a result, there will be a blackout period beginning %blackoutStartDate% to transition your account.',
          helpContentSlug: 'hsa-transition-banner-text',
        },
      },
      contentAreaSlug: 'hsa-transition-banner-text',
    },
  },
  'announcement-banner-on-off-switch': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: 'pBIMEMJLApngSBpeCmVlB',
      type: 'Entry',
      createdAt: '2020-08-04T19:26:29.523Z',
      updatedAt: '2023-09-06T04:30:03.151Z',
      publishedVersion: 53,
      revision: 6,
      locale: 'en-US',
    },
    fields: {
      description: 'Announcement Banner On/Off Switch',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1MAENUIJQFMtKtfO3LN1vk',
          type: 'Entry',
          createdAt: '2020-08-04T19:10:28.014Z',
          updatedAt: '2020-08-04T19:43:00.510Z',
          publishedVersion: 6,
          revision: 2,
          locale: 'en-US',
        },
        fields: { recordName: 'Hide Announcement Banner', showhide: false },
      },
      contentAreaSlug: 'announcement-banner-on-off-switch',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1MAENUIJQFMtKtfO3LN1vk',
          type: 'Entry',
          createdAt: '2020-08-04T19:10:28.014Z',
          updatedAt: '2020-08-04T19:43:00.510Z',
          publishedVersion: 6,
          revision: 2,
          locale: 'en-US',
        },
        fields: { recordName: 'Hide Announcement Banner', showhide: false },
      },
      dpc_bchzn: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1MAENUIJQFMtKtfO3LN1vk',
          type: 'Entry',
          createdAt: '2020-08-04T19:10:28.014Z',
          updatedAt: '2020-08-04T19:43:00.510Z',
          publishedVersion: 6,
          revision: 2,
          locale: 'en-US',
        },
        fields: { recordName: 'Hide Announcement Banner', showhide: false },
      },
      dpc_bcvt: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1MAENUIJQFMtKtfO3LN1vk',
          type: 'Entry',
          createdAt: '2020-08-04T19:10:28.014Z',
          updatedAt: '2020-08-04T19:43:00.510Z',
          publishedVersion: 6,
          revision: 2,
          locale: 'en-US',
        },
        fields: { recordName: 'Hide Announcement Banner', showhide: false },
      },
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1MAENUIJQFMtKtfO3LN1vk',
          type: 'Entry',
          createdAt: '2020-08-04T19:10:28.014Z',
          updatedAt: '2020-08-04T19:43:00.510Z',
          publishedVersion: 6,
          revision: 2,
          locale: 'en-US',
        },
        fields: { recordName: 'Hide Announcement Banner', showhide: false },
      },
      dpc_bcla: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1MAENUIJQFMtKtfO3LN1vk',
          type: 'Entry',
          createdAt: '2020-08-04T19:10:28.014Z',
          updatedAt: '2020-08-04T19:43:00.510Z',
          publishedVersion: 6,
          revision: 2,
          locale: 'en-US',
        },
        fields: { recordName: 'Hide Announcement Banner', showhide: false },
      },
    },
  },
  'tra-hqy-no-sso': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '7pD3lbwHN0j92ZdfdTsDMC',
      type: 'Entry',
      createdAt: '2022-01-19T18:31:13.365Z',
      updatedAt: '2022-01-19T18:31:13.365Z',
      publishedVersion: 3,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'TRA HQY no SSO',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '2jwrsD2CiqyKTAPpS7fmF9',
          type: 'Entry',
          createdAt: '2022-01-19T18:30:38.376Z',
          updatedAt: '2022-01-19T18:30:38.376Z',
          publishedVersion: 4,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'TRA HQY no SSO',
          helpContent:
            '# Transportation Reimbursement Account\n\nStarting with the March 2022 benefit month, your commuter benefits will be administered by HealthEquity. [Click here](https://participant.wageworks.com/ "WageWorks") to access the HealthEquity portal. __You must register and log in to verify or change your election for transit and/or parking by 2/4 to participate going forward.__ We have created this [resource page](https://www2.healthequity.com/tra/members/ "Health Equity resource page") to get you up to speed on using the HealthEquity platform for your commuter benefits.\n\nQuestions? Contact [Member Services](route="contactUs" "Member Contact Page").\n',
          helpContentSlug: 'tra-hqy-no-sso',
        },
      },
      contentAreaSlug: 'tra-hqy-no-sso',
    },
  },
  'tra-hqy': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4EaucnhZFEnVo6OHkEE17C',
      type: 'Entry',
      createdAt: '2022-01-19T00:07:44.866Z',
      updatedAt: '2022-01-19T00:07:44.866Z',
      publishedVersion: 4,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'TRA HQY',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4FsQpPrLl5dOomBwLQrLbv',
          type: 'Entry',
          createdAt: '2022-01-19T00:07:24.955Z',
          updatedAt: '2022-01-19T00:07:24.955Z',
          publishedVersion: 22,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'TRA HQY',
          helpContent:
            '# Transportation Reimbursement Account\n\nStarting with the March 2022 benefit month, your commuter benefits will be administered by HealthEquity. [Click here](https://participant.wageworks.com/ "WageWorks") to access the HealthEquity portal. __You must register and log in to verify or change your election for transit and/or parking by 2/4 to participate going forward.__ We have created this [resource page](https://www2.healthequity.com/tra/members/ "Health Equity resource page") to get you up to speed on using the HealthEquity platform for your commuter benefits.\n\nTo manage any benefits ordered before January 21, 2022, [click here](action="wired-commute-sso" "SSO to Wired Commute").\n\nQuestions? Contact [Member Services](route="contactUs" "Member Contact Page").\n',
          helpContentSlug: 'tra-hqy',
        },
      },
      contentAreaSlug: 'tra-hqy',
    },
  },
  'announcement-banner-content': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '66ljhJkPwPyCpRK2dAqEua',
      type: 'Entry',
      createdAt: '2020-07-29T20:10:56.118Z',
      updatedAt: '2022-01-10T15:24:38.026Z',
      publishedVersion: 30,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Announcement Banner Content',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3U667vR79zk0d2x3UzMTUE',
          type: 'Entry',
          createdAt: '2022-01-10T15:24:28.738Z',
          updatedAt: '2023-06-01T05:00:13.272Z',
          publishedVersion: 44,
          revision: 11,
          locale: 'en-US',
        },
        fields: {
          headline: 'Amendment to Cash Supplement',
          content:
            'NOTICE OF AMENDMENT TO CASH SUPPLEMENT.\n\nEffective September 1, 2023 (and in accordance with the amendment procedures described in the Cash Supplement to Custodial Agreement), the reference to "top five HSA providers" in the definition of "Median Minimum Market Rate" will be changed to "top ten HSA providers". You can see the existing Cash Supplement in the Interest Rates section of your member portal.',
          type: 'Centered',
        },
      },
      contentAreaSlug: 'announcement-banner-content',
      notes:
        'Use the info card record type for this. You are not required to include an image or a link/possible action.',
    },
  },
  'get-sa-id-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '7iwJxnSQBSk6NsGwsFsTvF',
      type: 'Entry',
      createdAt: '2022-01-04T20:54:16.887Z',
      updatedAt: '2022-01-04T20:54:16.887Z',
      publishedVersion: 6,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Get SA ID - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'e5txzgaAb6E6ntSsl4CYQ',
          type: 'Entry',
          createdAt: '2022-01-04T20:54:05.794Z',
          updatedAt: '2022-01-04T21:13:10.187Z',
          publishedVersion: 14,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'Get SA ID - Success - Default',
          content: '## Success!\nYour Spending Account ID is:\n%saId%',
        },
      },
      contentAreaSlug: 'get-sa-id-success',
    },
  },
  'account-column-2': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: 'fPJXWSuNRQKoGKqUusEc8',
      type: 'Entry',
      createdAt: '2018-01-29T17:45:01.203Z',
      updatedAt: '2021-10-20T14:16:54.939Z',
      publishedVersion: 161,
      revision: 33,
      locale: 'en-US',
    },
    fields: {
      description: 'Account Column 2',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '2Wn5vwsxdoLDqdFhpCn0QJ',
          type: 'Entry',
          createdAt: '2020-03-12T18:51:30.935Z',
          updatedAt: '2020-03-12T18:51:53.309Z',
          publishedVersion: 42,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          headline: 'Virtual Care During COVID-19',
          content:
            'With Doctor on Demand, you can talk to a doctor using a live video chat instead of visiting in-person. This limits your exposure to others who may have the virus. Schedule a video visit today.',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '6aB1VpLhokeqUyuWm2sKyM',
              type: 'Asset',
              createdAt: '2018-03-15T23:31:36.808Z',
              updatedAt: '2018-03-22T14:40:24.733Z',
              publishedVersion: 32,
              revision: 4,
              locale: 'en-US',
            },
            fields: {
              title: 'Doctor on Demand',
              description: 'Doctor on Demand',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/6aB1VpLhokeqUyuWm2sKyM/0c89ee9758925ea61df5d5c0a5cc313b/doctor-on-demand.jpg',
                details: { size: 11212, image: { width: 315, height: 200 } },
                fileName: 'doctor-on-demand.jpg',
                contentType: 'image/jpeg',
              },
            },
          },
          infoCardNote: 'Further COVID-19 Doctor on Demand tile',
        },
      },
      contentAreaSlug: 'account-column-2',
      notes:
        'Normally Doctor on Demand, but reserve for announcements (e.g., portal updates)',
      group_005645: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1d9dGegH3Iyq4sKMMgQygG',
          type: 'Entry',
          createdAt: '2018-04-05T15:33:23.711Z',
          updatedAt: '2018-04-05T15:58:50.673Z',
          publishedVersion: 17,
          revision: 6,
          locale: 'en-US',
        },
        fields: {
          headline: 'Investing in your Account',
          content:
            'From minimum balances and basic investment accounts, to self-directed mutual fund options and asset classes, we introduce you to investment strategies that can help you grow your account.',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '6aB1VpLhokeqUyuWm2sKyM',
              type: 'Asset',
              createdAt: '2018-03-15T23:31:36.808Z',
              updatedAt: '2018-03-22T14:40:24.733Z',
              publishedVersion: 32,
              revision: 4,
              locale: 'en-US',
            },
            fields: {
              title: 'Doctor on Demand',
              description: 'Doctor on Demand',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/6aB1VpLhokeqUyuWm2sKyM/0c89ee9758925ea61df5d5c0a5cc313b/doctor-on-demand.jpg',
                details: { size: 11212, image: { width: 315, height: 200 } },
                fileName: 'doctor-on-demand.jpg',
                contentType: 'image/jpeg',
              },
            },
          },
        },
      },
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3kzw0sqsFWgKMM66km2WWW',
          type: 'Entry',
          createdAt: '2018-02-15T21:40:01.433Z',
          updatedAt: '2018-03-22T15:04:57.244Z',
          publishedVersion: 21,
          revision: 9,
          locale: 'en-US',
        },
        fields: {
          headline: 'Tips for Submitting Claims',
          content:
            'Use these tips to ensure you include complete information on your claim for fastest processing, putting money in your pocket faster.',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '66JK5h5avK2s2Uesu26C8M',
              type: 'Asset',
              createdAt: '2018-03-22T14:42:58.879Z',
              updatedAt: '2018-03-22T14:42:58.879Z',
              publishedVersion: 12,
              revision: 1,
              locale: 'en-US',
            },
            fields: {
              title: 'CareFirst Tips',
              description: 'CareFirst Tips',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/66JK5h5avK2s2Uesu26C8M/668463ecf14ab6a98d7c7a43061bf327/Tips.jpg',
                details: { size: 38992, image: { width: 400, height: 235 } },
                fileName: 'Tips.jpg',
                contentType: 'image/jpeg',
              },
            },
          },
        },
      },
      group_015273: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'NBzNDNKSaYyMiU0iYkI0y',
          type: 'Entry',
          createdAt: '2018-11-07T18:26:06.047Z',
          updatedAt: '2018-11-07T18:28:05.195Z',
          publishedVersion: 20,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          headline: 'Direct Deposit Available',
          content:
            'Why wait for your own money? Make sure you’re set up for direct deposit to get your reimbursements quickly and securely--no checks or mail required. ',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '4lofJdP7QQ4KKW6kSewSAW',
              type: 'Asset',
              createdAt: '2018-03-22T15:23:03.597Z',
              updatedAt: '2018-03-22T15:23:03.597Z',
              publishedVersion: 17,
              revision: 1,
              locale: 'en-US',
            },
            fields: {
              title: 'Pick Your Price CareFirst',
              description: 'Pick Your Price CareFirst',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/4lofJdP7QQ4KKW6kSewSAW/9e5fd7a5a98b6fe4927a6fc19e315ee9/price.jpg',
                details: { size: 55968, image: { width: 400, height: 235 } },
                fileName: 'price.jpg',
                contentType: 'image/jpeg',
              },
            },
          },
          infoCardNote: 'CareFirst Manage bank accounts route',
        },
      },
      dpc_bop: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'zIl0on1UvQi24qMQOI06s',
          type: 'Entry',
          createdAt: '2018-06-06T20:58:28.320Z',
          updatedAt: '2019-06-12T15:38:48.453Z',
          publishedVersion: 293,
          revision: 5,
          locale: 'en-US',
        },
        fields: {
          headline: 'My Records and Receipts',
          content:
            'Time to clean out that overstuffed filing cabinet. Now you can upload, store, and organize all your receipts and other expense documentation. ',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '4w9P6CQgiQwEeK2kCsiMgM',
              type: 'Asset',
              createdAt: '2018-06-11T14:19:33.840Z',
              updatedAt: '2018-06-11T20:05:08.151Z',
              publishedVersion: 6,
              revision: 2,
              locale: 'en-US',
            },
            fields: {
              title: 'MyReciepts-IconFurtherCard128px',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/4w9P6CQgiQwEeK2kCsiMgM/d52832db13e4f413292ec536a8dbcef2/Icon_Reciepts128px.jpg',
                details: { size: 5742, image: { width: 315, height: 200 } },
                fileName: 'Icon_Reciepts128px.jpg',
                contentType: 'image/jpeg',
              },
            },
          },
        },
      },
      dpc_bchzn: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4FW1a5vrPWQUs2cWCesuqW',
          type: 'Entry',
          createdAt: '2018-11-07T18:36:32.924Z',
          updatedAt: '2018-11-30T20:12:18.005Z',
          publishedVersion: 13,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          headline: 'Learning Center',
          content:
            'Have a question?  Search the Learning Center to find educational resources, tips, and more.',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: 'T1TR6emMyiOswQqi0C4sU',
              type: 'Asset',
              createdAt: '2018-11-30T20:10:54.874Z',
              updatedAt: '2018-11-30T20:10:54.874Z',
              publishedVersion: 2,
              revision: 1,
              locale: 'en-US',
            },
            fields: {
              title: 'Learn Site image 11.30.18',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/T1TR6emMyiOswQqi0C4sU/4408dd9af5965f0f5e915a31920e72bd/Learn_Site_image_11.30.18.png',
                details: { size: 189837, image: { width: 400, height: 239 } },
                fileName: 'Learn Site image 11.30.18.png',
                contentType: 'image/png',
              },
            },
          },
          infoCardNote: 'Horizon learning center link',
        },
      },
      group_600001: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4gjeOf0vMcIwmKyq20EIas',
          type: 'Entry',
          createdAt: '2018-12-20T03:02:28.576Z',
          updatedAt: '2018-12-20T03:15:05.549Z',
          publishedVersion: 29,
          revision: 4,
          locale: 'en-US',
        },
        fields: {
          headline: 'Forms',
          content:
            'Find forms for your Horizon MyWay℠ Flexible Spending Account (FSA) for Merck here.',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: 'T1TR6emMyiOswQqi0C4sU',
              type: 'Asset',
              createdAt: '2018-11-30T20:10:54.874Z',
              updatedAt: '2018-11-30T20:10:54.874Z',
              publishedVersion: 2,
              revision: 1,
              locale: 'en-US',
            },
            fields: {
              title: 'Learn Site image 11.30.18',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/T1TR6emMyiOswQqi0C4sU/4408dd9af5965f0f5e915a31920e72bd/Learn_Site_image_11.30.18.png',
                details: { size: 189837, image: { width: 400, height: 239 } },
                fileName: 'Learn Site image 11.30.18.png',
                contentType: 'image/png',
              },
            },
          },
          infoCardNote: 'This will link to Merck forms page',
        },
      },
      dpc_bckc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'zIl0on1UvQi24qMQOI06s',
          type: 'Entry',
          createdAt: '2018-06-06T20:58:28.320Z',
          updatedAt: '2019-06-12T15:38:48.453Z',
          publishedVersion: 293,
          revision: 5,
          locale: 'en-US',
        },
        fields: {
          headline: 'My Records and Receipts',
          content:
            'Time to clean out that overstuffed filing cabinet. Now you can upload, store, and organize all your receipts and other expense documentation. ',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '4w9P6CQgiQwEeK2kCsiMgM',
              type: 'Asset',
              createdAt: '2018-06-11T14:19:33.840Z',
              updatedAt: '2018-06-11T20:05:08.151Z',
              publishedVersion: 6,
              revision: 2,
              locale: 'en-US',
            },
            fields: {
              title: 'MyReciepts-IconFurtherCard128px',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/4w9P6CQgiQwEeK2kCsiMgM/d52832db13e4f413292ec536a8dbcef2/Icon_Reciepts128px.jpg',
                details: { size: 5742, image: { width: 315, height: 200 } },
                fileName: 'Icon_Reciepts128px.jpg',
                contentType: 'image/jpeg',
              },
            },
          },
        },
      },
      group_002477: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3QhA1JHSaEemNifP1FIBg',
          type: 'Entry',
          createdAt: '2019-05-31T13:33:28.800Z',
          updatedAt: '2019-05-31T13:33:28.800Z',
          publishedVersion: 91,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          headline: 'Ridgeview eCare',
          content:
            'This link will take you to a website Further does not own, which may have different privacy and security policies. We are not responsible for the content of available of this site and do not endorse their products or services. ',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '1snTJesUY8wWgA6yMMEa6C',
              type: 'Asset',
              createdAt: '2018-03-15T23:32:09.642Z',
              updatedAt: '2018-03-15T23:42:26.668Z',
              publishedVersion: 16,
              revision: 2,
              locale: 'en-US',
            },
            fields: {
              title: 'Calculator',
              description: 'Calculator',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/1snTJesUY8wWgA6yMMEa6C/9817ba7863ad49bbbc6a6a170623a984/calculator.jpg',
                details: { size: 8967, image: { width: 315, height: 200 } },
                fileName: 'calculator.jpg',
                contentType: 'image/jpeg',
              },
            },
          },
        },
      },
      group_019225: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'zIl0on1UvQi24qMQOI06s',
          type: 'Entry',
          createdAt: '2018-06-06T20:58:28.320Z',
          updatedAt: '2019-06-12T15:38:48.453Z',
          publishedVersion: 293,
          revision: 5,
          locale: 'en-US',
        },
        fields: {
          headline: 'My Records and Receipts',
          content:
            'Time to clean out that overstuffed filing cabinet. Now you can upload, store, and organize all your receipts and other expense documentation. ',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '4w9P6CQgiQwEeK2kCsiMgM',
              type: 'Asset',
              createdAt: '2018-06-11T14:19:33.840Z',
              updatedAt: '2018-06-11T20:05:08.151Z',
              publishedVersion: 6,
              revision: 2,
              locale: 'en-US',
            },
            fields: {
              title: 'MyReciepts-IconFurtherCard128px',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/4w9P6CQgiQwEeK2kCsiMgM/d52832db13e4f413292ec536a8dbcef2/Icon_Reciepts128px.jpg',
                details: { size: 5742, image: { width: 315, height: 200 } },
                fileName: 'Icon_Reciepts128px.jpg',
                contentType: 'image/jpeg',
              },
            },
          },
        },
      },
      dpc_bcvt: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '2JDqJl7YmBL9XbRY7ueVPI',
          type: 'Entry',
          createdAt: '2020-06-11T19:55:45.385Z',
          updatedAt: '2021-06-27T11:28:42.108Z',
          publishedVersion: 14,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          headline: 'Virtual Care During COVID-19',
          content:
            'With AmWell, you can talk to a doctor using a live video chat instead of visiting in-person. This limits your exposure to others who may have the virus. Schedule a video visit today.',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '5v2paj5IVbGLnDlQA79nhr',
              type: 'Asset',
              createdAt: '2020-06-11T19:53:39.082Z',
              updatedAt: '2020-06-11T19:53:39.082Z',
              publishedVersion: 6,
              revision: 1,
              locale: 'en-US',
            },
            fields: {
              title: 'AmWell for Vermont',
              description: 'AmWell for BCBS Vermont',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/5v2paj5IVbGLnDlQA79nhr/6a004dfec752ecd7bfbf1616bf3f6466/DAY_1_333.jpg',
                details: {
                  size: 5408432,
                  image: { width: 3600, height: 2405 },
                },
                fileName: 'DAY 1_333.jpg',
                contentType: 'image/jpeg',
              },
            },
          },
          infoCardNote: 'BCBS VT COVID-19 AmWell tile',
        },
      },
      dpc_mns: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6ZnhIBQWqkSyqr9z7yo43b',
          type: 'Entry',
          createdAt: '2021-10-04T15:04:20.656Z',
          updatedAt: '2021-10-04T15:04:20.656Z',
          publishedVersion: 8,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          headline: 'Manage your plan online',
          content:
            'Medica.com is your one-stop resource for information to help you manage your health plan benefits. Find out what your plan covers, search for providers and order IDs cards, and more.',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '7I1dxsxqqKLuM770NDAtOC',
              type: 'Asset',
              createdAt: '2021-08-05T20:54:02.821Z',
              updatedAt: '2021-10-12T13:30:03.986Z',
              publishedVersion: 10,
              revision: 2,
              locale: 'en-US',
            },
            fields: {
              title: 'MHC Logo for Medica',
              description:
                'This is the logo MHC provided for their Medica tile',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/7I1dxsxqqKLuM770NDAtOC/bcc901305cfa1eaa98b9587e41f1543b/icon-Medica.jpg',
                details: { size: 20295, image: { width: 315, height: 200 } },
                fileName: 'icon-Medica.jpg',
                contentType: 'image/jpeg',
              },
            },
          },
        },
      },
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '20FWszGWJd2WsswlD9pgwO',
          type: 'Entry',
          createdAt: '2021-06-27T16:06:26.884Z',
          updatedAt: '2021-06-27T16:06:26.884Z',
          publishedVersion: 13,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          headline: 'Tips for Submitting Claims',
          content:
            'Use these tips to ensure you include complete information on your claim for fastest processing, putting money in your pocket faster.',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '6GdY9IIWCNgSmeoJoK76jX',
              type: 'Asset',
              createdAt: '2021-05-31T22:40:16.189Z',
              updatedAt: '2021-05-31T22:40:16.189Z',
              publishedVersion: 7,
              revision: 1,
              locale: 'en-US',
            },
            fields: {
              title: 'CapBlue Submitting Claims Tile Photo',
              description: 'Photo of a couple outdoors with a dog ',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/6GdY9IIWCNgSmeoJoK76jX/39f20714e1c482d9ada6c6eeeeb0875f/Audience_tile_2.jpg',
                details: {
                  size: 3058561,
                  image: { width: 3300, height: 2200 },
                },
                fileName: 'Audience_tile_2.jpg',
                contentType: 'image/jpeg',
              },
            },
          },
          infoCardNote: 'Submitting Claims tile for CapBlue',
        },
      },
      dpc_bcla: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'wPZrUBFZj1iuavM2omU0Y',
          type: 'Entry',
          createdAt: '2021-10-20T14:13:18.601Z',
          updatedAt: '2021-10-20T14:15:44.842Z',
          publishedVersion: 12,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          headline: 'Learning Center',
          content:
            'Have a question?  Search the Learning Center to find educational resources, tips, and more.',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '3VY4M0eB1b2PASIJTevfHR',
              type: 'Asset',
              createdAt: '2019-02-08T17:07:46.094Z',
              updatedAt: '2019-02-08T17:07:46.094Z',
              publishedVersion: 25,
              revision: 1,
              locale: 'en-US',
            },
            fields: {
              title: 'Education icon',
              description: 'Use this instead of the books',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/3VY4M0eB1b2PASIJTevfHR/6cbf198746a18a7141b3c544750602f1/Education_icon.png',
                details: { size: 2694, image: { width: 315, height: 200 } },
                fileName: 'Education_icon.png',
                contentType: 'image/png',
              },
            },
          },
          infoCardNote: 'BCBSLA Learning center card',
        },
      },
    },
  },
  'hsa-plan-information-sidebar-header': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '6vS8bx3rzxamXVklCmxLDz',
      type: 'Entry',
      createdAt: '2021-10-13T15:34:48.259Z',
      updatedAt: '2021-10-13T15:34:48.259Z',
      publishedVersion: 9,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'HSA Plan Information Sidebar Header',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5mVxw2j4Hnaj4HcXaqUGZX',
          type: 'Entry',
          createdAt: '2021-09-22T15:38:53.642Z',
          updatedAt: '2021-09-22T15:38:53.642Z',
          publishedVersion: 4,
          revision: 1,
          locale: 'en-US',
        },
        fields: { key: 'account-hsainfo_sidebar-title', textValue: 'Terms' },
      },
      contentAreaSlug: 'hsa-plan-information-sidebar-header',
    },
  },
  'enrollment-footer-link-privacy-policy': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '7GWrB1hZ0XueKtlmxmVXIX',
      type: 'Entry',
      createdAt: '2021-10-12T18:29:43.583Z',
      updatedAt: '2021-10-12T18:29:43.583Z',
      publishedVersion: 3,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Enrollment - Footer Link - Privacy Policy',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5XSTDw09Fe0MGWmyUKGuwK',
          type: 'Entry',
          createdAt: '2018-03-22T19:20:12.114Z',
          updatedAt: '2021-10-27T18:41:21.541Z',
          publishedVersion: 21,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          actionDescription: 'Privacy Policy - Default',
          actionNote: 'Privacy policy on public site',
          actionValue: 'link="https://hellofurther.com/privacy-policy/"',
        },
      },
      contentAreaSlug: 'enrollment-footer-link-privacy-policy',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6LurYiz9WEUicES2m6K4Ao',
          type: 'Entry',
          createdAt: '2018-03-22T19:22:42.579Z',
          updatedAt: '2018-11-07T18:12:58.407Z',
          publishedVersion: 21,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          actionDescription: 'Privacy Policy - CareFirst',
          actionNote: 'CareFirst privacy link',
          actionValue:
            'link="https://member.carefirst.com/members/mandates-policies/members-privacy-policy.page"',
        },
      },
    },
  },
  'account-column-3': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4U7kB06LnOycOAqUeISgI6',
      type: 'Entry',
      createdAt: '2018-01-29T17:45:40.171Z',
      updatedAt: '2021-10-04T17:07:58.969Z',
      publishedVersion: 97,
      revision: 22,
      locale: 'en-US',
    },
    fields: {
      description: 'Account Column 3',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '30AyBbRjEQM6MaSkQku0uc',
          type: 'Entry',
          createdAt: '2018-10-09T13:44:09.460Z',
          updatedAt: '2018-10-09T13:44:09.460Z',
          publishedVersion: 33,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          headline: 'Direct Deposit Available',
          content:
            'Why wait for your own money? Make sure you’re set up for direct deposit to get your reimbursements quickly and securely--no checks or mail required. ',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '4w9P6CQgiQwEeK2kCsiMgM',
              type: 'Asset',
              createdAt: '2018-06-11T14:19:33.840Z',
              updatedAt: '2018-06-11T20:05:08.151Z',
              publishedVersion: 6,
              revision: 2,
              locale: 'en-US',
            },
            fields: {
              title: 'MyReciepts-IconFurtherCard128px',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/4w9P6CQgiQwEeK2kCsiMgM/d52832db13e4f413292ec536a8dbcef2/Icon_Reciepts128px.jpg',
                details: { size: 5742, image: { width: 315, height: 200 } },
                fileName: 'Icon_Reciepts128px.jpg',
                contentType: 'image/jpeg',
              },
            },
          },
        },
      },
      contentAreaSlug: 'account-column-3',
      notes: 'Use for cobranding, custom links, or other resources',
      group_012718: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '2YRMF7ON8I2scea8UuqcUO',
          type: 'Entry',
          createdAt: '2018-02-09T16:53:49.289Z',
          updatedAt: '2020-02-07T19:59:24.006Z',
          publishedVersion: 113,
          revision: 6,
          locale: 'en-US',
        },
        fields: {
          headline: 'City of Minneapolis',
          content:
            'To learn more about the HRA/VEBA account, flexible spending accounts, and the transportation plan, please visit the City of Minneapolis benefits page. ',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '1nHRdJxGmEoEu2M46aA0Ke',
              type: 'Asset',
              createdAt: '2018-02-22T20:00:53.768Z',
              updatedAt: '2018-02-22T20:00:53.768Z',
              publishedVersion: 10,
              revision: 1,
              locale: 'en-US',
            },
            fields: {
              title: 'City of Mpls Logo',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/1nHRdJxGmEoEu2M46aA0Ke/cef802bbb47dbf61102cbf63a10859fa/City_of_Minneapolis_logo_for_HR_Select_Account.png',
                details: { size: 14945, image: { width: 489, height: 285 } },
                fileName: 'City of Minneapolis logo for HR Select Account.png',
                contentType: 'image/png',
              },
            },
          },
        },
      },
      dpc_ecs2: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5hSVNBT1Ly4S66q68KcCOg',
          type: 'Entry',
          createdAt: '2018-02-09T19:24:50.438Z',
          updatedAt: '2020-02-07T19:59:52.152Z',
          publishedVersion: 74,
          revision: 5,
          locale: 'en-US',
        },
        fields: {
          headline: 'Lakes Country',
          content:
            'Working for your employer makes you a member of a MN Service Cooperative. Click to learn about member benefits',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '39ML6jisneqKok0CCGsKmQ',
              type: 'Asset',
              createdAt: '2018-02-22T20:03:53.312Z',
              updatedAt: '2018-02-22T20:03:53.312Z',
              publishedVersion: 17,
              revision: 1,
              locale: 'en-US',
            },
            fields: {
              title: 'Lakes Country logo',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/39ML6jisneqKok0CCGsKmQ/01fd5fe8f9b9a625f93e1541f0dd0e60/Lakes_Country_Logo.jpg',
                details: { size: 288775, image: { width: 844, height: 759 } },
                fileName: 'Lakes Country Logo.jpg',
                contentType: 'image/jpeg',
              },
            },
          },
        },
      },
      dpc_ecs1: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4jqQSRYTxY8A6mcg2u6wsq',
          type: 'Entry',
          createdAt: '2018-02-09T20:10:22.289Z',
          updatedAt: '2020-02-07T19:52:32.107Z',
          publishedVersion: 80,
          revision: 5,
          locale: 'en-US',
        },
        fields: {
          headline: 'NorthEast',
          content:
            'Working for your employer makes you a member of a MN Service Cooperative. Click to learn about member benefits.',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '191Hnxs2BS8UAE08suqAiE',
              type: 'Asset',
              createdAt: '2018-02-22T20:05:05.408Z',
              updatedAt: '2018-02-22T20:05:05.408Z',
              publishedVersion: 10,
              revision: 1,
              locale: 'en-US',
            },
            fields: {
              title: 'Northeast Logo',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/191Hnxs2BS8UAE08suqAiE/65dc8da4650718a12cc28ae12dd25384/NESC_LOGO.JPG',
                details: { size: 99011, image: { width: 2953, height: 750 } },
                fileName: 'NESC LOGO.JPG',
                contentType: 'image/jpeg',
              },
            },
          },
        },
      },
      dpc_ecs9: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3NQ7wmrAlqguKIGUGiKYGI',
          type: 'Entry',
          createdAt: '2018-02-09T20:11:57.861Z',
          updatedAt: '2020-02-07T19:53:15.016Z',
          publishedVersion: 26,
          revision: 5,
          locale: 'en-US',
        },
        fields: {
          headline: 'NorthWest',
          content:
            'Working for your employer makes you a member of a MN Service Cooperative. Click to learn about member benefits.',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '7d6YjxAbIsSQ4G6euooEQS',
              type: 'Asset',
              createdAt: '2018-02-22T20:06:07.968Z',
              updatedAt: '2018-02-22T20:06:07.968Z',
              publishedVersion: 8,
              revision: 1,
              locale: 'en-US',
            },
            fields: {
              title: 'Northwest Logo',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/7d6YjxAbIsSQ4G6euooEQS/aa955d491ee2e02cf462ca32572ec861/NW-Service-Coop-tran-png-8.png',
                details: { size: 25306, image: { width: 392, height: 419 } },
                fileName: 'NW-Service-Coop-tran-png-8.png',
                contentType: 'image/png',
              },
            },
          },
        },
      },
      group_005645: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '725J1vQhpu6iAO8soowy22',
          type: 'Entry',
          createdAt: '2018-02-09T20:13:39.298Z',
          updatedAt: '2018-04-19T15:02:57.078Z',
          publishedVersion: 46,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          headline: 'Portico',
          content:
            'Visit myPortico to get information about your benefits and manage your account. ',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '210kN79SdOO6QYAIU8CyeI',
              type: 'Asset',
              createdAt: '2018-04-19T15:02:24.531Z',
              updatedAt: '2018-04-19T15:02:24.531Z',
              publishedVersion: 12,
              revision: 1,
              locale: 'en-US',
            },
            fields: {
              title: 'New Portico Logo',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/210kN79SdOO6QYAIU8CyeI/3491d568a1273910c0d878715aa83313/Portico_Logo_Stacked_RGB.PNG',
                details: { size: 19616, image: { width: 375, height: 200 } },
                fileName: 'Portico Logo Stacked_RGB.PNG',
                contentType: 'image/png',
              },
            },
          },
        },
      },
      dpc_ecs8: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'bOxwBCT08EEmAmeMmqQIw',
          type: 'Entry',
          createdAt: '2018-02-09T20:18:47.394Z',
          updatedAt: '2020-02-07T19:54:46.868Z',
          publishedVersion: 33,
          revision: 5,
          locale: 'en-US',
        },
        fields: {
          headline: 'Resource',
          content:
            'Working for your employer makes you a member of a MN Service Cooperative. Click to learn about member benefits.',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '5AMpV0c0dUYgywSKAGaEKI',
              type: 'Asset',
              createdAt: '2018-02-22T20:11:25.575Z',
              updatedAt: '2018-02-22T20:11:25.575Z',
              publishedVersion: 10,
              revision: 1,
              locale: 'en-US',
            },
            fields: {
              title: 'Resource logo',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/5AMpV0c0dUYgywSKAGaEKI/4b9a92486039050924f8282aa57e0e10/Resource_202467.jpg',
                details: {
                  size: 1218716,
                  image: { width: 2924, height: 1254 },
                },
                fileName: 'Resource_202467.jpg',
                contentType: 'image/jpeg',
              },
            },
          },
          infoCardNote: 'Resource website linked',
        },
      },
      dpc_ecs3: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6hzlD1bPjyM8KEWU0WWoCi',
          type: 'Entry',
          createdAt: '2018-02-09T20:25:59.122Z',
          updatedAt: '2019-11-11T01:46:36.038Z',
          publishedVersion: 25,
          revision: 4,
          locale: 'en-US',
        },
        fields: {
          headline: 'South Central',
          content:
            'Working for your employer makes you a member of a MN Service Cooperative. Click to learn about member benefits.',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '3HIYLnYpMAISaiOAEMcA4k',
              type: 'Asset',
              createdAt: '2018-02-22T20:12:32.692Z',
              updatedAt: '2018-02-22T20:12:32.692Z',
              publishedVersion: 10,
              revision: 1,
              locale: 'en-US',
            },
            fields: {
              title: 'South Central logo',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/3HIYLnYpMAISaiOAEMcA4k/1a525d8fe04b6a9b051b03ebf4efbb0d/scsclogo_color_jan09_hr.jpg',
                details: { size: 419822, image: { width: 1149, height: 594 } },
                fileName: 'scsclogo_color_jan09_hr.jpg',
                contentType: 'image/jpeg',
              },
            },
          },
        },
      },
      dpc_ecs4: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4Di6YgCwJa4GekCWgkEGMq',
          type: 'Entry',
          createdAt: '2018-02-09T20:26:55.258Z',
          updatedAt: '2020-02-07T19:58:11.842Z',
          publishedVersion: 26,
          revision: 4,
          locale: 'en-US',
        },
        fields: {
          headline: 'SouthEast',
          content:
            'Working for your employer makes you a member of a MN Service Cooperative. Click to learn about member benefits.',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '4vwTR3NgBqMeaQeGKOqwKO',
              type: 'Asset',
              createdAt: '2018-02-22T20:14:37.982Z',
              updatedAt: '2018-02-22T20:14:37.982Z',
              publishedVersion: 13,
              revision: 1,
              locale: 'en-US',
            },
            fields: {
              title: 'Southeast logo',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/4vwTR3NgBqMeaQeGKOqwKO/d2cbfe93d14b4b0e65eedbb8e39dbf68/SSC-Transparent.png',
                details: { size: 50264, image: { width: 435, height: 651 } },
                fileName: 'SSC-Transparent.png',
                contentType: 'image/png',
              },
            },
          },
        },
      },
      dpc_ecs6: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4TjBypIgZicGECMMkOiUY0',
          type: 'Entry',
          createdAt: '2018-02-09T20:30:17.543Z',
          updatedAt: '2020-02-07T19:59:06.713Z',
          publishedVersion: 30,
          revision: 4,
          locale: 'en-US',
        },
        fields: {
          headline: 'SouthWest/West Central',
          content:
            'Working for your employer makes you a member of a MN Service Cooperative. Click to learn about member benefits.',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: 'o5OvIkvbCowUAiEQMA4Sm',
              type: 'Asset',
              createdAt: '2018-02-22T20:13:46.387Z',
              updatedAt: '2018-02-22T20:13:46.387Z',
              publishedVersion: 15,
              revision: 1,
              locale: 'en-US',
            },
            fields: {
              title: 'Southwest/West Central logo',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/o5OvIkvbCowUAiEQMA4Sm/9a0b65ad9649f845f6b448f22ff536c9/SWWC-Logo_275x121.jpg',
                details: { size: 13218, image: { width: 275, height: 121 } },
                fileName: 'SWWC-Logo_275x121.jpg',
                contentType: 'image/jpeg',
              },
            },
          },
        },
      },
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'NBzNDNKSaYyMiU0iYkI0y',
          type: 'Entry',
          createdAt: '2018-11-07T18:26:06.047Z',
          updatedAt: '2018-11-07T18:28:05.195Z',
          publishedVersion: 20,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          headline: 'Direct Deposit Available',
          content:
            'Why wait for your own money? Make sure you’re set up for direct deposit to get your reimbursements quickly and securely--no checks or mail required. ',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '4lofJdP7QQ4KKW6kSewSAW',
              type: 'Asset',
              createdAt: '2018-03-22T15:23:03.597Z',
              updatedAt: '2018-03-22T15:23:03.597Z',
              publishedVersion: 17,
              revision: 1,
              locale: 'en-US',
            },
            fields: {
              title: 'Pick Your Price CareFirst',
              description: 'Pick Your Price CareFirst',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/4lofJdP7QQ4KKW6kSewSAW/9e5fd7a5a98b6fe4927a6fc19e315ee9/price.jpg',
                details: { size: 55968, image: { width: 400, height: 235 } },
                fileName: 'price.jpg',
                contentType: 'image/jpeg',
              },
            },
          },
          infoCardNote: 'CareFirst Manage bank accounts route',
        },
      },
      group_015273: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '2omeNo2sXiUuYa0G8Ooocc',
          type: 'Entry',
          createdAt: '2018-06-26T13:16:07.383Z',
          updatedAt: '2018-06-26T13:27:24.632Z',
          publishedVersion: 168,
          revision: 4,
          locale: 'en-US',
        },
        fields: {
          headline: 'Sodexo Carefirst HRA Guide',
          content:
            'Find information about your plan, account online, prescription payment debit card, and FAQs. ',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '4lofJdP7QQ4KKW6kSewSAW',
              type: 'Asset',
              createdAt: '2018-03-22T15:23:03.597Z',
              updatedAt: '2018-03-22T15:23:03.597Z',
              publishedVersion: 17,
              revision: 1,
              locale: 'en-US',
            },
            fields: {
              title: 'Pick Your Price CareFirst',
              description: 'Pick Your Price CareFirst',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/4lofJdP7QQ4KKW6kSewSAW/9e5fd7a5a98b6fe4927a6fc19e315ee9/price.jpg',
                details: { size: 55968, image: { width: 400, height: 235 } },
                fileName: 'price.jpg',
                contentType: 'image/jpeg',
              },
            },
          },
        },
      },
      dpc_bop: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '2FwbpOPQKkqaQQm6GyaQAO',
          type: 'Entry',
          createdAt: '2018-09-06T15:49:31.753Z',
          updatedAt: '2019-02-08T18:20:27.765Z',
          publishedVersion: 31,
          revision: 5,
          locale: 'en-US',
        },
        fields: {
          headline: 'Learning Center',
          content:
            'Have a question?  Search the Learning Center to find educational resources, tips, and more.',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '3VY4M0eB1b2PASIJTevfHR',
              type: 'Asset',
              createdAt: '2019-02-08T17:07:46.094Z',
              updatedAt: '2019-02-08T17:07:46.094Z',
              publishedVersion: 25,
              revision: 1,
              locale: 'en-US',
            },
            fields: {
              title: 'Education icon',
              description: 'Use this instead of the books',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/3VY4M0eB1b2PASIJTevfHR/6cbf198746a18a7141b3c544750602f1/Education_icon.png',
                details: { size: 2694, image: { width: 315, height: 200 } },
                fileName: 'Education_icon.png',
                contentType: 'image/png',
              },
            },
          },
          actions: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '1jhMGaXWHuKeSY0Q0KMEqk',
              type: 'Entry',
              createdAt: '2018-09-06T15:47:23.943Z',
              updatedAt: '2018-11-07T18:05:53.357Z',
              publishedVersion: 33,
              revision: 2,
              locale: 'en-US',
            },
            fields: {
              actionDescription: 'Visit the Learning Center',
              actionNote: 'Board of Pensions learn link',
              actionValue:
                'link="https://learn.hellofurther.com/Landing_Pages/Board_of_Pensions"',
            },
          },
          infoCardNote: 'Board of Pensions LC card',
        },
      },
      dpc_bchzn: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6zhOhSzqusuoSCO88osGaK',
          type: 'Entry',
          createdAt: '2018-11-07T18:48:54.867Z',
          updatedAt: '2019-01-09T14:45:03.875Z',
          publishedVersion: 24,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          headline: 'Why wait for your money?',
          content:
            'Make sure you’re set up for direct deposit to get your reimbursements quickly and securely--no checks or mail needed. ',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '2qu72FdcscqoOeOAMeOC2',
              type: 'Asset',
              createdAt: '2018-11-30T20:10:40.671Z',
              updatedAt: '2018-11-30T20:10:40.671Z',
              publishedVersion: 2,
              revision: 1,
              locale: 'en-US',
            },
            fields: {
              title: 'familytablet',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/2qu72FdcscqoOeOAMeOC2/27fd07452f294a993b2915e52ccd5dd7/familytablet.png',
                details: { size: 204308, image: { width: 400, height: 239 } },
                fileName: 'familytablet.png',
                contentType: 'image/png',
              },
            },
          },
          infoCardNote: 'Horizon Manage bank accounts route',
        },
      },
      dpc_bckc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3ZTliu29PUxK9r3lw7frMP',
          type: 'Entry',
          createdAt: '2019-03-27T18:38:43.193Z',
          updatedAt: '2019-03-27T18:38:43.193Z',
          publishedVersion: 60,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          headline: 'Health Savings Account (HSA)',
          content: 'Learn more about HSAs by visiting the Learning Center.',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '3VY4M0eB1b2PASIJTevfHR',
              type: 'Asset',
              createdAt: '2019-02-08T17:07:46.094Z',
              updatedAt: '2019-02-08T17:07:46.094Z',
              publishedVersion: 25,
              revision: 1,
              locale: 'en-US',
            },
            fields: {
              title: 'Education icon',
              description: 'Use this instead of the books',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/3VY4M0eB1b2PASIJTevfHR/6cbf198746a18a7141b3c544750602f1/Education_icon.png',
                details: { size: 2694, image: { width: 315, height: 200 } },
                fileName: 'Education_icon.png',
                contentType: 'image/png',
              },
            },
          },
          infoCardNote:
            'This links to the HSA guide instead of the learning site home page',
        },
      },
      dpc_bcvt: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '2EewSTxFy3wlzfdafM6W8i',
          type: 'Entry',
          createdAt: '2020-06-15T18:25:23.440Z',
          updatedAt: '2021-06-27T11:29:02.965Z',
          publishedVersion: 23,
          revision: 4,
          locale: 'en-US',
        },
        fields: {
          headline: 'Cost Transparency Tool',
          content:
            'Log in to the Member Resource Center (MRC) to research and compare cost and quality of healthcare using our tool from Change Healthcare. ',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '31A2Bxg2tdhblb01ajr1S',
              type: 'Asset',
              createdAt: '2020-06-15T18:22:14.529Z',
              updatedAt: '2020-06-16T16:00:38.664Z',
              publishedVersion: 23,
              revision: 6,
              locale: 'en-US',
            },
            fields: {
              title: 'Vermont family',
              description:
                "Photo used for portal tile for Vermont's healthcare cost transparency tile",
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/31A2Bxg2tdhblb01ajr1S/71a9483b7d4c75d66da8bf20975cf774/bcbsvt-2018-0815-0040_50.jpg',
                details: { size: 777295, image: { width: 2494, height: 1671 } },
                fileName: 'bcbsvt-2018-0815-0040_50.jpg',
                contentType: 'image/jpeg',
              },
            },
          },
        },
      },
      dpc_mns: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '2BZ1oHiB9RsPfcQl65L4F7',
          type: 'Entry',
          createdAt: '2019-04-29T14:04:21.576Z',
          updatedAt: '2022-01-31T18:41:33.284Z',
          publishedVersion: 315,
          revision: 4,
          locale: 'en-US',
        },
        fields: {
          headline: 'Shop FSAstore.com',
          content:
            'Remember, the funds in your Flexible Spending Account (FSA) may expire at the end of the year! Visit FSA Store for ideas on how to use your benefits before you lose them.',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '4XzaqyuVfnFvlzbaOSoARi',
              type: 'Asset',
              createdAt: '2022-01-25T19:29:56.961Z',
              updatedAt: '2022-01-31T18:41:40.077Z',
              publishedVersion: 14,
              revision: 2,
              locale: 'en-US',
            },
            fields: {
              title: 'FSA Store Icon',
              description: 'FSA store icon',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/4XzaqyuVfnFvlzbaOSoARi/8229bb457799f97f0fd8f368d6d277d2/fsastore.png',
                details: { size: 19193, image: { width: 315, height: 200 } },
                fileName: 'fsastore.png',
                contentType: 'image/png',
              },
            },
          },
        },
      },
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5SdaBjdIg3xP0EcWeqFviM',
          type: 'Entry',
          createdAt: '2021-06-27T16:05:13.615Z',
          updatedAt: '2021-06-27T16:05:13.615Z',
          publishedVersion: 12,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          headline: 'Why wait for your money?',
          content:
            'Make sure you sign up for direct deposit to get your reimbursements quickly and securely - no checks or mail needed!',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '5zyGxvHxuKSgjPGrVolsaV',
              type: 'Asset',
              createdAt: '2021-05-31T22:41:55.103Z',
              updatedAt: '2021-05-31T22:41:55.103Z',
              publishedVersion: 7,
              revision: 1,
              locale: 'en-US',
            },
            fields: {
              title: 'CapBlue Direct Deposit Tile Photo',
              description: 'couple on a bridge',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/5zyGxvHxuKSgjPGrVolsaV/f97fa8ca77eb63c55ed8d3721261fa4a/Audience_tile_3.jpg',
                details: { size: 563384, image: { width: 792, height: 528 } },
                fileName: 'Audience_tile_3.jpg',
                contentType: 'image/jpeg',
              },
            },
          },
          infoCardNote: 'CapBlue Manage Bank Accounts link',
        },
      },
      dpc_bcla: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '30AyBbRjEQM6MaSkQku0uc',
          type: 'Entry',
          createdAt: '2018-10-09T13:44:09.460Z',
          updatedAt: '2018-10-09T13:44:09.460Z',
          publishedVersion: 33,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          headline: 'Direct Deposit Available',
          content:
            'Why wait for your own money? Make sure you’re set up for direct deposit to get your reimbursements quickly and securely--no checks or mail required. ',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '4w9P6CQgiQwEeK2kCsiMgM',
              type: 'Asset',
              createdAt: '2018-06-11T14:19:33.840Z',
              updatedAt: '2018-06-11T20:05:08.151Z',
              publishedVersion: 6,
              revision: 2,
              locale: 'en-US',
            },
            fields: {
              title: 'MyReciepts-IconFurtherCard128px',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/4w9P6CQgiQwEeK2kCsiMgM/d52832db13e4f413292ec536a8dbcef2/Icon_Reciepts128px.jpg',
                details: { size: 5742, image: { width: 315, height: 200 } },
                fileName: 'Icon_Reciepts128px.jpg',
                contentType: 'image/jpeg',
              },
            },
          },
        },
      },
    },
  },
  'account-column-1': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '23J3pL0q1e4cMWcuksosKY',
      type: 'Entry',
      createdAt: '2018-01-29T17:44:35.242Z',
      updatedAt: '2021-10-04T17:07:43.358Z',
      publishedVersion: 113,
      revision: 25,
      locale: 'en-US',
    },
    fields: {
      description: 'Account Column 1',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '2BZ1oHiB9RsPfcQl65L4F7',
          type: 'Entry',
          createdAt: '2019-04-29T14:04:21.576Z',
          updatedAt: '2022-01-31T18:41:33.284Z',
          publishedVersion: 315,
          revision: 4,
          locale: 'en-US',
        },
        fields: {
          headline: 'Shop FSAstore.com',
          content:
            'Remember, the funds in your Flexible Spending Account (FSA) may expire at the end of the year! Visit FSA Store for ideas on how to use your benefits before you lose them.',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '4XzaqyuVfnFvlzbaOSoARi',
              type: 'Asset',
              createdAt: '2022-01-25T19:29:56.961Z',
              updatedAt: '2022-01-31T18:41:40.077Z',
              publishedVersion: 14,
              revision: 2,
              locale: 'en-US',
            },
            fields: {
              title: 'FSA Store Icon',
              description: 'FSA store icon',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/4XzaqyuVfnFvlzbaOSoARi/8229bb457799f97f0fd8f368d6d277d2/fsastore.png',
                details: { size: 19193, image: { width: 315, height: 200 } },
                fileName: 'fsastore.png',
                contentType: 'image/png',
              },
            },
          },
        },
      },
      contentAreaSlug: 'account-column-1',
      notes: 'Use for care tools links',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6DYATJ1OZqEccWqIo86mEe',
          type: 'Entry',
          createdAt: '2018-03-21T20:14:35.338Z',
          updatedAt: '2018-11-07T18:35:46.047Z',
          publishedVersion: 32,
          revision: 6,
          locale: 'en-US',
        },
        fields: {
          headline: 'Learning Center',
          content:
            'Have a question?  Search the Learning Center to find educational resources, tips, and more.',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '3uQPMozzUQSQICk6UUmW6q',
              type: 'Asset',
              createdAt: '2018-03-22T14:41:57.805Z',
              updatedAt: '2018-03-22T14:41:57.805Z',
              publishedVersion: 21,
              revision: 1,
              locale: 'en-US',
            },
            fields: {
              title: 'CareFirst Learning Center',
              description: 'CareFirst  Learning Center',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/3uQPMozzUQSQICk6UUmW6q/644ce7ca9911c9e2b8962fd68365b0f8/Learn.jpg',
                details: { size: 41650, image: { width: 400, height: 235 } },
                fileName: 'Learn.jpg',
                contentType: 'image/jpeg',
              },
            },
          },
          actions: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '5eFUfWYQsowgOsU6USyseI',
              type: 'Entry',
              createdAt: '2018-03-21T20:09:29.434Z',
              updatedAt: '2018-11-07T18:38:11.711Z',
              publishedVersion: 41,
              revision: 6,
              locale: 'en-US',
            },
            fields: {
              actionDescription: 'Visit the Learning Center',
              actionNote: 'CareFirst learn link',
              actionValue:
                'link="https://learn-carefirst.hellofurther.com/individuals"',
            },
          },
          infoCardNote: 'CareFirst learning center link',
        },
      },
      group_015273: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '2RJHObxLdKG04gkSCSMsoo',
          type: 'Entry',
          createdAt: '2018-06-20T17:06:05.996Z',
          updatedAt: '2018-06-20T17:06:05.996Z',
          publishedVersion: 43,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          headline: 'Sodexo Microsite',
          content: 'Have a question?  Find plan resources, forms, and videos.',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '3uQPMozzUQSQICk6UUmW6q',
              type: 'Asset',
              createdAt: '2018-03-22T14:41:57.805Z',
              updatedAt: '2018-03-22T14:41:57.805Z',
              publishedVersion: 21,
              revision: 1,
              locale: 'en-US',
            },
            fields: {
              title: 'CareFirst Learning Center',
              description: 'CareFirst  Learning Center',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/3uQPMozzUQSQICk6UUmW6q/644ce7ca9911c9e2b8962fd68365b0f8/Learn.jpg',
                details: { size: 41650, image: { width: 400, height: 235 } },
                fileName: 'Learn.jpg',
                contentType: 'image/jpeg',
              },
            },
          },
          actions: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '6yU1TSivZuEqM4UaI8Eeqa',
              type: 'Entry',
              createdAt: '2018-06-20T17:05:08.794Z',
              updatedAt: '2018-11-07T18:15:45.239Z',
              publishedVersion: 21,
              revision: 2,
              locale: 'en-US',
            },
            fields: {
              actionDescription: 'Visit the Microsite',
              actionNote: 'Sodexo microsite link',
              actionValue: 'link="https://www.carefirst.com/sodexo/"',
            },
          },
        },
      },
      dpc_bchzn: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6vZ0jwE4H6Qe8q0kIaYeSE',
          type: 'Entry',
          createdAt: '2018-11-07T17:59:17.700Z',
          updatedAt: '2020-03-02T17:16:59.772Z',
          publishedVersion: 353,
          revision: 4,
          locale: 'en-US',
        },
        fields: {
          headline: 'Download the Horizon Blue app',
          content:
            "Life doesn't happen in front of a computer. Our mobile app gives you real-time, easy access to your accounts whenever you need it, 24 hours a day, seven days a week.",
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '27lxb8uzcIwcMGW2UQ002K',
              type: 'Asset',
              createdAt: '2018-11-30T20:10:48.980Z',
              updatedAt: '2018-11-30T20:10:48.980Z',
              publishedVersion: 2,
              revision: 1,
              locale: 'en-US',
            },
            fields: {
              title: 'HorizonApp',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/27lxb8uzcIwcMGW2UQ002K/bc76b8bea53b795abee9a577b038050b/HorizonApp.png',
                details: { size: 151003, image: { width: 400, height: 239 } },
                fileName: 'HorizonApp.png',
                contentType: 'image/png',
              },
            },
          },
        },
      },
      group_600001: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1PhRbJCX4oSccaysA8Eko8',
          type: 'Entry',
          createdAt: '2019-01-04T19:51:11.122Z',
          updatedAt: '2019-01-09T15:21:49.769Z',
          publishedVersion: 111,
          revision: 4,
          locale: 'en-US',
        },
        fields: {
          headline: 'FSA',
          content:
            'Have questions about how your Horizon MyWay℠ FSA works and what expenses are eligible? Click here to learn more.',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '2xIr8nOScYUqCygKmMeQgS',
              type: 'Asset',
              createdAt: '2018-06-11T14:08:18.521Z',
              updatedAt: '2018-06-11T14:08:18.521Z',
              publishedVersion: 2,
              revision: 1,
              locale: 'en-US',
            },
            fields: {
              title: 'MyRecords',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/2xIr8nOScYUqCygKmMeQgS/4f0c394f02c16f8f8bcc2d818acf40ad/MyRecords.jpg',
                details: { size: 28797, image: { width: 400, height: 235 } },
                fileName: 'MyRecords.jpg',
                contentType: 'image/jpeg',
              },
            },
          },
          infoCardNote:
            "This is for the Merck experience, which doesn't include the learning site",
        },
      },
      dpc_bcvt: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5pMaGbM9PkHusDUWW8PbG0',
          type: 'Entry',
          createdAt: '2020-06-15T18:29:10.978Z',
          updatedAt: '2021-06-27T11:28:25.968Z',
          publishedVersion: 24,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          headline: 'Learning Center',
          content:
            'Have a question?  Search the Learning Center to find educational resources, tips, and more.',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '3CImGr87tlX5dQVDZrkAfx',
              type: 'Asset',
              createdAt: '2020-06-15T18:27:05.304Z',
              updatedAt: '2020-06-15T18:27:05.304Z',
              publishedVersion: 7,
              revision: 1,
              locale: 'en-US',
            },
            fields: {
              title: 'Vermont Learning Center Tile ',
              description:
                'Photo used for the Learning Center tile in the Vermont member portal',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/3CImGr87tlX5dQVDZrkAfx/766e875e829883a6ec3199f01540a40a/20180912_BCBSVT_0714_Edited_50.jpg',
                details: { size: 537530, image: { width: 2736, height: 1824 } },
                fileName: '20180912_BCBSVT_0714_Edited_50.jpg',
                contentType: 'image/jpeg',
              },
            },
          },
          infoCardNote: 'Vermont learning center link',
        },
      },
      dpc_mns: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3S5RymZhlXRWfMtRTvIbwk',
          type: 'Entry',
          createdAt: '2021-10-04T16:37:58.109Z',
          updatedAt: '2021-10-04T16:37:58.109Z',
          publishedVersion: 9,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          headline: 'Minnesota Healthcare Consortium',
          content:
            'Insurance is complicated. We’re here to help you understand your benefits and get connected to all the amazing wellness programs that come packaged with MHC plans.',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '2zSRfwh7mAnRdroyvz8JnJ',
              type: 'Asset',
              createdAt: '2021-08-05T20:58:46.644Z',
              updatedAt: '2021-10-12T13:30:03.974Z',
              publishedVersion: 10,
              revision: 2,
              locale: 'en-US',
            },
            fields: {
              title: 'MHC Minnesota Map',
              description: "MHC's map of Minnesota",
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/2zSRfwh7mAnRdroyvz8JnJ/781fbe6d56ffb67d6cbd3fd5dc8e75a5/icon-MHCmap.jpg',
                details: { size: 28269, image: { width: 315, height: 200 } },
                fileName: 'icon-MHCmap.jpg',
                contentType: 'image/jpeg',
              },
            },
          },
          infoCardNote: 'MHC Info Tile',
        },
      },
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3PMywy9msPd1TyL3XoDHAr',
          type: 'Entry',
          createdAt: '2021-06-27T16:05:50.910Z',
          updatedAt: '2021-06-27T16:05:50.910Z',
          publishedVersion: 7,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          headline: 'Learning Center',
          content:
            'Have a question?  Search the Learning Center to find educational resources, tips, and more.',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '1m58AHFs2u4nZwlsevOd6i',
              type: 'Asset',
              createdAt: '2021-05-31T22:27:19.246Z',
              updatedAt: '2021-05-31T22:27:19.246Z',
              publishedVersion: 6,
              revision: 1,
              locale: 'en-US',
            },
            fields: {
              title: 'CapBlue Learning Center Tile',
              description: 'family throwing frisbee',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/1m58AHFs2u4nZwlsevOd6i/43e99cc58e4ecf2a80c4d92f8350c3e9/Audience_tile_1.jpg',
                details: {
                  size: 4797184,
                  image: { width: 3300, height: 2200 },
                },
                fileName: 'Audience_tile_1.jpg',
                contentType: 'image/jpeg',
              },
            },
          },
          infoCardNote: 'CapBlue learning center link',
        },
      },
      dpc_bcla: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6ee8S4pwQj5JTLhOdmEnIo',
          type: 'Entry',
          createdAt: '2021-08-16T16:27:06.341Z',
          updatedAt: '2021-08-25T14:53:54.091Z',
          publishedVersion: 12,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          headline: 'BlueCare Telehealth',
          content:
            'See a doctor 24/7 for minor health issues or schedule an appointment for behavioral health. Telehealth is usually reimbursable by HRAs; ask your employer.',
          type: 'Centered',
          image: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '42jtn1c5wwh0OtJLLbM8Jl',
              type: 'Asset',
              createdAt: '2021-08-05T18:11:58.421Z',
              updatedAt: '2021-08-05T18:11:58.421Z',
              publishedVersion: 10,
              revision: 1,
              locale: 'en-US',
            },
            fields: {
              title: 'BCBS Louisiana Telehealth Icon',
              description:
                "This icon is used for BCBSLA's telehealth content tile",
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/42jtn1c5wwh0OtJLLbM8Jl/643dd2c02b912553f6f1de1105595cad/Telehealth-Icon-315x200__Revised_.jpg',
                details: { size: 14244, image: { width: 315, height: 200 } },
                fileName: 'Telehealth-Icon-315x200 (Revised).jpg',
                contentType: 'image/jpeg',
              },
            },
          },
        },
      },
    },
  },
  'related-sites-link-list': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '7zpUIH5EPYS088u8E0siIM',
      type: 'Entry',
      createdAt: '2017-12-19T17:40:30.613Z',
      updatedAt: '2021-10-04T17:03:45.735Z',
      publishedVersion: 52,
      revision: 13,
      locale: 'en-US',
    },
    fields: {
      description: 'Related Sites Link List',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5gidI0WzIs4EmcES8g82Yq',
          type: 'Entry',
          createdAt: '2017-12-18T21:41:17.899Z',
          updatedAt: '2018-03-14T12:35:49.823Z',
          publishedVersion: 321,
          revision: 19,
          locale: 'en-US',
        },
        fields: {
          title: 'Related Sites List',
          headline: 'Related Sites',
          content:
            '- [HSA Mutual Funds Listing](link="https://hsainvestments.com/fundperformance/?p=HSA")\n- [VEBA Mutual Funds Listing](link="https://hsainvestments.com/fundperformance/?p=VBA")\n',
        },
      },
      contentAreaSlug: 'related-sites-link-list',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1587pKwP3yeqmg8MoAaGu6',
          type: 'Entry',
          createdAt: '2018-02-19T18:46:16.063Z',
          updatedAt: '2018-07-02T13:37:56.219Z',
          publishedVersion: 96,
          revision: 4,
          locale: 'en-US',
        },
        fields: {
          title: 'CareFirst Related Sites List',
          headline: 'Related Sites',
          content:
            '- [Find a Doctor](link="http://www.carefirst.com/findadoc")\n- [Know Before You Go](link="https://member.carefirst.com/members/managing-health-care-costs/need-care/when-you-need-care.page")\n- [Drug Coverage](link="https://member.carefirst.com/members/drug-pharmacy-information/drug-coverage-your-prescription-drug-plan.page")\n',
        },
      },
      group_015273: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3ws4zqW82siao8mC0qIywq',
          type: 'Entry',
          createdAt: '2018-06-20T17:16:21.326Z',
          updatedAt: '2018-06-20T17:16:21.326Z',
          publishedVersion: 29,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Sodexo Related Sites List',
          headline: 'Related Sites',
          content:
            '- [Sodexo Benefits Site](link="http://resources.hewitt.com/sodexo/")\n- [Find a Doctor](link="https://member.carefirst.com/mos/#/fadpublic/search/home")\n',
        },
      },
      dpc_bchzn: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4fRsaG1j9mmegcUgG86CQ8',
          type: 'Entry',
          createdAt: '2018-11-30T20:37:50.607Z',
          updatedAt: '2018-11-30T20:37:50.607Z',
          publishedVersion: 50,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Horizon Related Sites List',
          headline: 'Related Sites',
          content:
            '- [Doctor & Hospital Finder](link="https://doctorfinder.horizonblue.com/")\n- [Treatment Cost Estimator](link="https://www.horizonblue.com/members/tools/treatment-cost-estimator")\n- [My Health Manager](link="https://www.horizonblue.com/members/wellness/my-health-manager")\n',
        },
      },
      group_600001: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4x5WJ3bmcoo8S0IqYGOm0c',
          type: 'Entry',
          createdAt: '2019-01-09T14:41:15.036Z',
          updatedAt: '2022-05-11T16:30:29.923Z',
          publishedVersion: 9,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Merck Related Sites List',
          headline: 'Related Sites',
          content:
            '- [Doctor & Hospital Finder](link="https://www.horizonblue.com/merck/tools-services/find-doctor")',
        },
      },
      dpc_bcvt: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'ehlhzkVwWxzY2Sv57wZgW',
          type: 'Entry',
          createdAt: '2020-06-15T20:09:34.867Z',
          updatedAt: '2020-06-17T16:51:17.854Z',
          publishedVersion: 8,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Vermont Related Sites List',
          headline: 'Related Sites',
          content:
            '- [HSA Mutual Funds Listing](link="https://hsainvestments.com/fundperformance/?p=HVT")\n- [VEBA Mutual Funds Listing](link="https://hsainvestments.com/fundperformance/?p=HVTVBA")\n',
        },
      },
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '7y5IETj7CjoIOJgryNYRDV',
          type: 'Entry',
          createdAt: '2021-05-20T20:43:07.337Z',
          updatedAt: '2021-05-20T20:43:07.337Z',
          publishedVersion: 9,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Capital Blue Related Sites List',
          headline: 'Related Sites',
          content:
            '- [Find a Doctor](link="https://capitalbluecross.healthsparq.com/healthsparq/public/#/one/insurerCode=CAPBC_I&locale=en_US&brandCode=CAPBC")\n- [Find a Drug](link="https://www.capbluecross.com/wps/portal/cap/home/find/drug")\n',
        },
      },
    },
  },
  'resources-link-list': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: 'OfrDwnq4s66eGcwgue0Y0',
      type: 'Entry',
      createdAt: '2017-12-19T17:43:34.457Z',
      updatedAt: '2021-10-04T16:59:48.109Z',
      publishedVersion: 27,
      revision: 9,
      locale: 'en-US',
    },
    fields: {
      description: 'Resources Link List',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '433TRv9ZpKScww8oeiWY2W',
          type: 'Entry',
          createdAt: '2017-12-18T21:55:17.045Z',
          updatedAt: '2018-03-19T18:47:50.030Z',
          publishedVersion: 159,
          revision: 6,
          locale: 'en-US',
        },
        fields: {
          title: 'Resources List',
          headline: 'Resources',
          content:
            '- [Learning Center](link="https://learn.hellofurther.com")\n- [Healthcare Decision Support Tools](link="https://learn.hellofurther.com/Individuals/Spending_Your_Account/Healthcare_Decision_Support_Tools")\n- [Eligible Expenses](link="https://learn.hellofurther.com/Individuals/Spending_Your_Account/Eligible_Expenses")',
        },
      },
      contentAreaSlug: 'resources-link-list',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4eI4Fz3Scoso2uc0MgY0Wm',
          type: 'Entry',
          createdAt: '2018-02-19T18:45:29.400Z',
          updatedAt: '2018-11-30T20:39:16.123Z',
          publishedVersion: 72,
          revision: 7,
          locale: 'en-US',
        },
        fields: {
          title: 'CareFirst Resources List',
          headline: 'Resources',
          content:
            '- [Learning Center](link="https://learn-carefirst.hellofurther.com")\n- [Eligible Expenses](link="https://learn-carefirst.hellofurther.com/Individuals/Spending_Your_Account/Eligible_Expenses")',
        },
      },
      group_015273: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4dYS2RuaiIAuyIEYM0WU2G',
          type: 'Entry',
          createdAt: '2018-06-20T17:10:37.564Z',
          updatedAt: '2018-06-20T17:10:37.564Z',
          publishedVersion: 66,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Sodexo Resources List',
          headline: 'Resources',
          content:
            '- [CareFirst Resources for Sodexo](link="https://www.carefirst.com/sodexo/")\n- [Spanish - CareFirst Resources for Sodexo](link="https://www.carefirst.com/sodexosp/")',
        },
      },
      dpc_bop: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1Ir1nPb60EKyuGEym2QkQ6',
          type: 'Entry',
          createdAt: '2018-09-06T16:09:14.699Z',
          updatedAt: '2018-09-06T16:09:14.699Z',
          publishedVersion: 4,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'BOP Resources List',
          headline: 'Resources',
          content:
            '- [Learning Center](link="https://learn.hellofurther.com/Landing_Pages/Board_of_Pensions")\n- [Healthcare Decision Support Tools](link="https://learn.hellofurther.com/Individuals/Spending_Your_Account/Healthcare_Decision_Support_Tools")\n- [Eligible Expenses](link="https://learn.hellofurther.com/Individuals/Spending_Your_Account/Eligible_Expenses")',
        },
      },
      dpc_bchzn: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '2YDEF4SKQgAsmIo0CiSa4W',
          type: 'Entry',
          createdAt: '2018-11-30T20:38:44.687Z',
          updatedAt: '2018-11-30T21:16:04.209Z',
          publishedVersion: 33,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Horizon Resources List',
          headline: 'Resources',
          content:
            '- [Learning Center](link="https://learn-horizonmyway.hellofurther.com")\n- [Eligible Expenses](link="https://learn-horizonmyway.hellofurther.com/Individuals/Spending_Your_Account/Eligible_Expenses")',
        },
      },
      group_600001: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4cvIaV6FlSowiaSkWos0us',
          type: 'Entry',
          createdAt: '2018-12-20T03:33:50.219Z',
          updatedAt: '2018-12-20T15:04:31.619Z',
          publishedVersion: 8,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Merck Resources List',
          headline: 'Resources',
          content:
            '- [Eligible Expenses](link="https://www.horizonblue.com/merck-fsa/eligible-expenses")',
        },
      },
      dpc_bcvt: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6u0w1g8A8AmTm0Xfmz3fs5',
          type: 'Entry',
          createdAt: '2020-06-10T17:21:03.718Z',
          updatedAt: '2020-06-11T19:29:18.521Z',
          publishedVersion: 12,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Vermont Resources List',
          headline: 'Resources',
          content:
            '- [Learning Center](link="https://learn-mymoneybcbsvt.hellofurther.com")\n- [HSA Calculators](link="https://learn-mymoneybcbsvt.hellofurther.com/Individuals/Spending_Your_Account/Healthcare_Decision_Support_Tools")\n- [Eligible Expenses](link="https://learn-mymoneybcbsvt.hellofurther.com/Individuals/Spending_Your_Account/Eligible_Expenses")',
        },
      },
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3KnjFO5Z8Js8oEuOe8UaeI',
          type: 'Entry',
          createdAt: '2021-05-14T16:43:01.151Z',
          updatedAt: '2021-05-20T20:41:33.997Z',
          publishedVersion: 9,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Capital Blue Resources List',
          headline: 'Resources',
          content:
            '- [Learning Center](link="https://learn-capitalbluecross.hellofurther.com/")\n- [Eligible Expenses](link="https://learn-capitalbluecross.hellofurther.com/Individuals/Spending_Your_Account/Eligible_Expenses")',
        },
      },
      dpc_bcla: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1e5N9Cczy8zIpSxaTPjirE',
          type: 'Entry',
          createdAt: '2021-08-19T19:39:27.184Z',
          updatedAt: '2021-10-22T16:44:51.228Z',
          publishedVersion: 25,
          revision: 6,
          locale: 'en-US',
        },
        fields: {
          title: 'BCBS Louisiana Resources List',
          headline: 'Resources',
          content:
            '- [Learning Center](link="https://learn.hellofurther.com/bcbsla")\n- [Blue Cross and Blue Shield of Louisiana Provider Directory](link="https://www.bcbsla.com/findcare")',
        },
      },
    },
  },
  'global-learn-link': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4MiAL2nbDaykE8WMOcEWGg',
      type: 'Entry',
      createdAt: '2018-03-06T17:33:09.463Z',
      updatedAt: '2021-10-04T16:59:00.505Z',
      publishedVersion: 25,
      revision: 10,
      locale: 'en-US',
    },
    fields: {
      description: 'Global - Learn Link',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '11Wxd81nismKAUQkM0Cyq0',
          type: 'Entry',
          createdAt: '2018-03-06T17:32:46.481Z',
          updatedAt: '2019-01-30T14:53:34.142Z',
          publishedVersion: 45,
          revision: 5,
          locale: 'en-US',
        },
        fields: {
          actionDescription: 'Visit the Learning Center',
          actionNote: 'Further learn site link',
          actionValue: 'link="https://learn.hellofurther.com/Individuals"',
        },
      },
      contentAreaSlug: 'global-learn-link',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5eFUfWYQsowgOsU6USyseI',
          type: 'Entry',
          createdAt: '2018-03-21T20:09:29.434Z',
          updatedAt: '2018-11-07T18:38:11.711Z',
          publishedVersion: 41,
          revision: 6,
          locale: 'en-US',
        },
        fields: {
          actionDescription: 'Visit the Learning Center',
          actionNote: 'CareFirst learn link',
          actionValue:
            'link="https://learn-carefirst.hellofurther.com/individuals"',
        },
      },
      group_015273: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6yU1TSivZuEqM4UaI8Eeqa',
          type: 'Entry',
          createdAt: '2018-06-20T17:05:08.794Z',
          updatedAt: '2018-11-07T18:15:45.239Z',
          publishedVersion: 21,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          actionDescription: 'Visit the Microsite',
          actionNote: 'Sodexo microsite link',
          actionValue: 'link="https://www.carefirst.com/sodexo/"',
        },
      },
      dpc_bop: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1jhMGaXWHuKeSY0Q0KMEqk',
          type: 'Entry',
          createdAt: '2018-09-06T15:47:23.943Z',
          updatedAt: '2018-11-07T18:05:53.357Z',
          publishedVersion: 33,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          actionDescription: 'Visit the Learning Center',
          actionNote: 'Board of Pensions learn link',
          actionValue:
            'link="https://learn.hellofurther.com/Landing_Pages/Board_of_Pensions"',
        },
      },
      dpc_bchzn: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5SgYMAXHTGo0cUUgA2mWQW',
          type: 'Entry',
          createdAt: '2018-10-29T16:07:56.350Z',
          updatedAt: '2018-11-07T18:04:33.111Z',
          publishedVersion: 14,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          actionDescription: 'Visit the Learning Center',
          actionNote: 'Horizon learning center link',
          actionValue:
            'link="https://learn-horizonmyway.hellofurther.com/Individuals"',
        },
      },
      group_600001: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6Pf6fbYPNmqmC0sgSygIa8',
          type: 'Entry',
          createdAt: '2018-12-20T03:14:27.429Z',
          updatedAt: '2018-12-20T03:14:27.429Z',
          publishedVersion: 89,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          actionDescription: 'Horizon Merck FSA page',
          actionNote:
            "This is used to replace links to the learn site with links to the Merck page on Horizon's site",
          actionValue: 'link="https://www.horizonblue.com/merck-fsa"',
        },
      },
      dpc_bcvt: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'umbJKVMg6LI6SAC11av8N',
          type: 'Entry',
          createdAt: '2020-05-29T16:20:29.710Z',
          updatedAt: '2020-05-29T16:20:29.710Z',
          publishedVersion: 7,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          actionDescription: 'Visit the Learning Center',
          actionNote: 'Vermont Learning Center link',
          actionValue:
            'link="https://learn-mymoneybcbsvt.hellofurther.com/Individuals"',
        },
      },
      dpc_mns: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1E1Q1XPrZVIYK6UziFBev6',
          type: 'Entry',
          createdAt: '2021-04-21T21:29:09.243Z',
          updatedAt: '2021-04-21T21:29:09.243Z',
          publishedVersion: 7,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          actionDescription: 'Visit the Learning Center',
          actionNote:
            'This will take MHC members to the cobraded MHC learning site page',
          actionValue: 'link="https://learn.hellofurther.com/mhc"',
        },
      },
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'WH8KWGGvzy92aAujqP8WM',
          type: 'Entry',
          createdAt: '2021-06-18T19:40:50.004Z',
          updatedAt: '2021-06-27T16:12:23.404Z',
          publishedVersion: 7,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          actionDescription: 'Visit the Learning Center',
          actionNote: 'Capital Blue Learning Center Link',
          actionValue:
            'link="https://learn-capitalbluecross.hellofurther.com/Individuals"',
        },
      },
      dpc_bcla: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6wakBRhQTipa2QnW3JBsKP',
          type: 'Entry',
          createdAt: '2021-09-22T19:43:59.827Z',
          updatedAt: '2021-09-22T19:43:59.827Z',
          publishedVersion: 7,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          actionDescription: 'Visit the Learning Center',
          actionNote: 'BCBSLA learning center link',
          actionValue: 'link="https://learn.hellofurther.com/BCBSLA"',
        },
      },
    },
  },
  'contact-us-sidebar-content': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '26WpBWmtteMocOgeEw64Ic',
      type: 'Entry',
      createdAt: '2018-01-19T19:52:08.613Z',
      updatedAt: '2021-10-04T16:58:38.451Z',
      publishedVersion: 36,
      revision: 11,
      locale: 'en-US',
    },
    fields: {
      description: 'Contact Us Sidebar Content',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5dAeYuB8hOicS06WKuUuoU',
          type: 'Entry',
          createdAt: '2018-01-19T19:51:37.860Z',
          updatedAt: '2021-04-22T13:31:43.413Z',
          publishedVersion: 208,
          revision: 7,
          locale: 'en-US',
        },
        fields: {
          title: 'Default Contact Us Sidebar',
          headline: 'Popular Resources',
          content:
            '[COVID-19 Frequently Asked Questions](link="https://learn.hellofurther.com/Landing_Pages/COVID-19_Frequently_Asked_Questions")\n\n[Eligible Expense List](link="https://learn.hellofurther.com/Individuals/Spending_Your_Account/Eligible_Expenses")\n\n[Learn: How to Get Reimbursed](link="https://learn.hellofurther.com/Individuals/Spending_Your_Account/Getting_Reimbursed")\n\n[Learn: Tips for Submitting Claims](link="https://learn.hellofurther.com/Individuals/Spending_Your_Account/Tips_for_Submitting_Claims")\n\n[Learn: Requesting and Managing Debit Cards](link="https://learn.hellofurther.com/Individuals/Debit_Cards/Requesting_and_Managing_Debit_Cards")\n\n[Learn: How Eligible Medical Expenses Work with Your Taxes](link="https://learn.hellofurther.com/Individuals/Spending_Your_Account/How_Eligible_Medical_Expenses_Work_with_Taxes")\n',
        },
      },
      contentAreaSlug: 'contact-us-sidebar-content',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1xXsbIELSM28y4UcmwEkue',
          type: 'Entry',
          createdAt: '2018-02-09T21:53:31.318Z',
          updatedAt: '2021-04-22T13:29:04.425Z',
          publishedVersion: 88,
          revision: 6,
          locale: 'en-US',
        },
        fields: {
          title: 'Group CareFirst Contact Us Sidebar',
          headline: 'Popular Resources',
          content:
            '[COVID-19 Frequently Asked Questions](link="https://learn-carefirst.hellofurther.com/Landing_Pages/COVID-19_Frequently_Asked_Questions")\n\n[Eligible Expense List](link="https://learn-carefirst.hellofurther.com/Individuals/Spending_Your_Account/Eligible_Expenses")\n\n[Learn: How to Get Reimbursed](link="https://learn-carefirst.hellofurther.com/Individuals/Spending_Your_Account/Getting_Reimbursed")\n\n[Learn: Tips for Submitting Claims](link="https://learn-carefirst.hellofurther.com/Individuals/Spending_Your_Account/Tips_for_Submitting_Claims")\n\n[Learn: Requesting and Managing Debit Cards](link="https://learn-carefirst.hellofurther.com/Individuals/Debit_Cards/Requesting_and_Managing_Debit_Cards")\n\n[Learn: How Eligible Medical Expenses Work with Your Taxes](link="https://learn-carefirst.hellofurther.com/Individuals/Spending_Your_Account/How_Eligible_Medical_Expenses_Work_with_Taxes")\n',
        },
      },
      group_015273: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '51JPDW8zTiqqWCCouKme8O',
          type: 'Entry',
          createdAt: '2018-06-21T13:26:12.978Z',
          updatedAt: '2018-06-21T13:26:12.978Z',
          publishedVersion: 82,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Group SodexoContact Us Sidebar',
          headline: 'Popular Resources',
          content:
            '[CareFirst resources for Sodexo](link="https://www.carefirst.com/sodexo/")\n\n[Spanish - CareFirst resources for Sodexo](link="https://www.carefirst.com/sodexosp/")\n\n[Sodexo Benefits site](link="http://resources.hewitt.com/sodexo/")',
        },
      },
      dpc_bchzn: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1ZiqpnOfr2g2A2UmmwoCKK',
          type: 'Entry',
          createdAt: '2018-11-30T21:03:41.311Z',
          updatedAt: '2021-04-22T13:30:53.734Z',
          publishedVersion: 65,
          revision: 4,
          locale: 'en-US',
        },
        fields: {
          title: 'Horizon Contact Us Sidebar',
          headline: 'Popular Resources',
          content:
            '[COVID-19 Frequently Asked Questions](link="https://learn-horizonmyway.hellofurther.com/Landing_Pages/COVID-19_Frequently_Asked_Questions")\n\n[Eligible Expense List](link="https://learn-horizonmyway.hellofurther.com/Individuals/Spending_Your_Account/Eligible_Expenses")\n\n[Learn: How to Get Reimbursed](link="https://learn-horizonmyway.hellofurther.com/Individuals/Spending_Your_Account/Getting_Reimbursed")\n\n[Learn: Tips for Submitting Claims](link="https://learn-horizonmyway.hellofurther.com/Individuals/Spending_Your_Account/Tips_for_Submitting_Claims")\n\n[Learn: Requesting and Managing Debit Cards](link="https://learn-horizonmyway.hellofurther.com/Individuals/Debit_Cards/Requesting_and_Managing_Debit_Cards")\n\n[Learn: How Eligible Medical Expenses Work with Your Taxes](link="https://learn-horizonmyway.hellofurther.com/Individuals/Spending_Your_Account/How_Eligible_Medical_Expenses_Work_with_Taxes")\n',
        },
      },
      group_600001: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '2OajMtd14IA2QqgeWSi4uy',
          type: 'Entry',
          createdAt: '2018-12-20T03:30:54.296Z',
          updatedAt: '2018-12-20T03:30:54.296Z',
          publishedVersion: 8,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Merck Contact Us Sidebar',
          headline: 'Popular Resources',
          content:
            '[Eligible Expense List](link="https://www.horizonblue.com/merck-fsa/eligible-expenses")',
        },
      },
      dpc_bcvt: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5r5Ie00ojTqwFzMcHoYVZR',
          type: 'Entry',
          createdAt: '2020-05-29T15:37:28.709Z',
          updatedAt: '2021-04-22T13:30:02.852Z',
          publishedVersion: 14,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Vermont Contact Us Sidebar',
          headline: 'Popular Resources',
          content:
            '[COVID-19 Frequently Asked Questions](link="https://learn-mymoneybcbsvt.hellofurther.com/Landing_Pages/COVID-19_Frequently_Asked_Questions")\n\n[Eligible Expense List](link="https://learn-mymoneybcbsvt.hellofurther.com/Individuals/Spending_Your_Account/Eligible_Expenses")\n\n[Learn: How to Get Reimbursed](link="https://learn-mymoneybcbsvt.hellofurther.com/Individuals/Spending_Your_Account/Getting_Reimbursed")\n\n[Learn: Tips for Submitting Claims](link="https://learn-mymoneybcbsvt.hellofurther.com/Individuals/Spending_Your_Account/Tips_for_Submitting_Claims")\n\n[Learn: Requesting and Managing Debit Cards](link="https://learn-mymoneybcbsvt.hellofurther.com/Individuals/Debit_Cards/Requesting_and_Managing_Debit_Cards")\n\n[Learn: How Eligible Medical Expenses Work with Your Taxes](link="https://learn-mymoneybcbsvt.hellofurther.com/Individuals/Spending_Your_Account/How_Eligible_Medical_Expenses_Work_with_Taxes")\n',
        },
      },
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6bdypPOg7mkqx6NLGdIL1q',
          type: 'Entry',
          createdAt: '2021-06-18T19:38:06.119Z',
          updatedAt: '2021-06-18T19:38:06.119Z',
          publishedVersion: 11,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Capital Blue Contact Us Sidebar',
          headline: 'Popular Resources',
          content:
            '[COVID-19 Frequently Asked Questions](link="https://learn-capitalbluecross.hellofurther.com/Landing_Pages/COVID-19_Frequently_Asked_Questions")\n\n[Eligible Expense List](link="https://learn-capitalbluecross.hellofurther.com/Individuals/Spending_Your_Account/Eligible_Expenses")\n\n[Learn: How to Get Reimbursed](link="https://learn-capitalbluecross.hellofurther.com/Individuals/Spending_Your_Account/Getting_Reimbursed")\n\n[Learn: Tips for Submitting Claims](link="https://learn-capitalbluecross.hellofurther.com/Individuals/Spending_Your_Account/Tips_for_Submitting_Claims")\n\n[Learn: Requesting and Managing Debit Cards](link="https://learn-capitalbluecross.hellofurther.com/Individuals/Debit_Cards/Requesting_and_Managing_Debit_Cards")\n\n[Learn: How Eligible Medical Expenses Work with Your Taxes](link="https://learn-capitalbluecross.hellofurther.com/Individuals/Spending_Your_Account/How_Eligible_Medical_Expenses_Work_with_Taxes")',
        },
      },
    },
  },
  'terms-and-conditions-investment-accounts': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '6toV4HlRSnAPGiybJEvvt4',
      type: 'Entry',
      createdAt: '2021-10-04T15:02:43.640Z',
      updatedAt: '2021-10-04T15:02:43.640Z',
      publishedVersion: 9,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Terms and Conditions- Investment Accounts',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4U2sKYHiDd8dTqqI5bKySk',
          type: 'Entry',
          createdAt: '2021-09-21T19:45:44.987Z',
          updatedAt: '2021-09-21T21:04:23.210Z',
          publishedVersion: 9,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          actionDescription: 'Terms and Conditions- Investment Accounts ',
          actionNote: 'Further brand',
          actionValue:
            'link="https://learn.hellofurther.com/@api/deki/files/1364/Terms_and_Conditions_-_Investment_Accounts.pdf"',
        },
      },
      contentAreaSlug: 'terms-and-conditions-investment-accounts',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3GbNzjluvSUIKxdCrdSZLg',
          type: 'Entry',
          createdAt: '2021-09-21T19:47:08.918Z',
          updatedAt: '2021-09-21T19:47:08.918Z',
          publishedVersion: 7,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          actionDescription:
            'Terms and Conditions- Investment Accounts - CareFirst',
          actionValue:
            'link="https://learn-carefirst.hellofurther.com/@api/deki/files/425/Terms_and_Conditions_-_Investment_Accounts.pdf"',
        },
      },
      dpc_bchzn: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '41wBm7FL1jhofWvjPRHBMF',
          type: 'Entry',
          createdAt: '2021-09-21T19:52:10.486Z',
          updatedAt: '2021-09-21T19:52:10.486Z',
          publishedVersion: 7,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          actionDescription:
            'Terms and Conditions- Investment Accounts - Horizon',
          actionValue:
            'link="https://learn-horizonmyway.hellofurther.com/@api/deki/files/687/Terms_and_Conditions_-_Investment_Accounts.pdf"',
        },
      },
      dpc_bcvt: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3BWcBN3CYCqhfLEecJhi21',
          type: 'Entry',
          createdAt: '2021-09-21T19:54:13.280Z',
          updatedAt: '2021-09-21T19:54:13.280Z',
          publishedVersion: 7,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          actionDescription:
            'Terms and Conditions- Investment Accounts- BCBS Vermont',
          actionValue:
            'link="https://learn-mymoneybcbsvt.hellofurther.com/@api/deki/files/718/Terms_and_Conditions_-_Investment_Accounts.pdf"',
        },
      },
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '60MlJQJIwgXKrNbwn0WiFw',
          type: 'Entry',
          createdAt: '2021-09-21T19:57:58.105Z',
          updatedAt: '2021-09-21T19:57:58.105Z',
          publishedVersion: 8,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          actionDescription:
            'Terms and Conditions- Investment Accounts- CapBlue',
          actionValue:
            'link="https://learn-capitalbluecross.hellofurther.com/@api/deki/files/522/Terms_and_Conditions_-_Investment_Accounts.pdf"',
        },
      },
    },
  },
  'hsa-info-terms-links-fdic': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4sKuaRMaI1rxdjjaIvBmMw',
      type: 'Entry',
      createdAt: '2021-10-01T13:40:49.369Z',
      updatedAt: '2021-10-01T13:42:45.789Z',
      publishedVersion: 8,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'HSA Info - Terms Links - FDIC ',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '797VmuqRKpxQSZFCMARUDw',
          type: 'Entry',
          createdAt: '2021-10-01T13:40:08.955Z',
          updatedAt: '2021-10-01T13:46:03.369Z',
          publishedVersion: 13,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          name: 'HSA Info - Terms Links - FDIC - Further',
          title: 'Terms & Conditions',
          link1: {
            data: {},
            content: [
              {
                data: {
                  target: {
                    metadata: { tags: [], concepts: [] },
                    sys: {
                      id: '1fT3DCnxg2lK39is83k7HP',
                      type: 'Entry',
                      createdAt: '2021-09-21T19:36:25.358Z',
                      updatedAt: '2021-09-21T19:36:25.358Z',
                      publishedVersion: 7,
                      revision: 1,
                      locale: 'en-US',
                    },
                    fields: {
                      actionDescription:
                        'HealthEquity HSA Custodial Agreement- Further',
                      actionValue:
                        'link="https://learn.hellofurther.com/@api/deki/files/1376/HealthEquity_HSA_Custodial_Agreement_-_Further_(M06309).pdf"',
                    },
                  },
                },
                content: [],
                nodeType: 'embedded-entry-block',
              },
              {
                data: {
                  target: {
                    metadata: { tags: [], concepts: [] },
                    sys: {
                      id: '7fJDm592YuR4bwkRO9FBrF',
                      type: 'Entry',
                      createdAt: '2021-09-21T18:56:27.144Z',
                      updatedAt: '2021-09-22T13:28:02.591Z',
                      publishedVersion: 17,
                      revision: 3,
                      locale: 'en-US',
                    },
                    fields: {
                      actionDescription:
                        'HealthEquity HSA Custodial Agreement- Federally Insured Cash Supplement- Further',
                      actionValue:
                        'link="https://learn.hellofurther.com/@api/deki/files/1375/HealthEquity_HSA_Custodial_Agreement_Federally_Insured_Cash_Supplement_-_Further_(M06299).pdf"',
                    },
                  },
                },
                content: [],
                nodeType: 'embedded-entry-block',
              },
              {
                data: {
                  target: {
                    metadata: { tags: [], concepts: [] },
                    sys: {
                      id: '4U2sKYHiDd8dTqqI5bKySk',
                      type: 'Entry',
                      createdAt: '2021-09-21T19:45:44.987Z',
                      updatedAt: '2021-09-21T21:04:23.210Z',
                      publishedVersion: 9,
                      revision: 2,
                      locale: 'en-US',
                    },
                    fields: {
                      actionDescription:
                        'Terms and Conditions- Investment Accounts ',
                      actionNote: 'Further brand',
                      actionValue:
                        'link="https://learn.hellofurther.com/@api/deki/files/1364/Terms_and_Conditions_-_Investment_Accounts.pdf"',
                    },
                  },
                },
                content: [],
                nodeType: 'embedded-entry-block',
              },
              {
                data: {},
                content: [{ data: {}, marks: [], value: '', nodeType: 'text' }],
                nodeType: 'paragraph',
              },
            ],
            nodeType: 'document',
          },
        },
      },
      contentAreaSlug: 'hsa-info-terms-links-fdic',
    },
  },
  'hsa-custodial-agreement-supplement-paclife-cash-supplement': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '1HdHN8iAUQ9ZpF1QWxbswT',
      type: 'Entry',
      createdAt: '2021-09-21T19:03:20.696Z',
      updatedAt: '2021-09-22T16:34:18.771Z',
      publishedVersion: 17,
      revision: 3,
      locale: 'en-US',
    },
    fields: {
      description:
        'HSA Custodial Agreement Supplement - PacLife Cash Supplement',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '32jHqxnHdNvsKa7mvwCSbN',
          type: 'Entry',
          createdAt: '2021-09-21T18:53:36.900Z',
          updatedAt: '2021-09-22T14:03:27.533Z',
          publishedVersion: 10,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          actionDescription:
            'HealthEquity HSA Custodial Agreement - PacLife Cash Supplement - Further',
          actionValue:
            'link="https://learn.hellofurther.com/@api/deki/files/1374/HealthEquity_HSA_Custodial_Agreement_PacLife_Cash_Supplement_-_Further_(M06300).pdf"',
        },
      },
      contentAreaSlug:
        'hsa-custodial-agreement-supplement-paclife-cash-supplement',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '7snAejw9iQ41Gjqp3WED9e',
          type: 'Entry',
          createdAt: '2021-09-21T18:56:04.141Z',
          updatedAt: '2021-11-02T00:06:41.933Z',
          publishedVersion: 14,
          revision: 4,
          locale: 'en-US',
        },
        fields: {
          actionDescription:
            'Health Equity HSA Custodial Agreement - PacLife Cash Supplement - CareFirst',
          actionValue:
            'link="https://learn-carefirst.hellofurther.com/@api/deki/files/439/HealthEquity_HSA_Custodial_Agreement_PacLife_Cash_Supplement_-_CareFirst_(M06302).pdf"',
        },
      },
      dpc_bchzn: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6zDzqh31ZOtUSww3VRsclw',
          type: 'Entry',
          createdAt: '2021-09-21T18:58:37.326Z',
          updatedAt: '2021-09-22T14:09:54.707Z',
          publishedVersion: 8,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          actionDescription:
            'HealthEquity HSA Custodial Agreement - PacLife Cash Supplement - Horizon',
          actionValue:
            'link="https://learn-horizonmyway.hellofurther.com/@api/deki/files/694/HealthEquity_HSA_Custodial_Agreement_PacLife_Cash_Supplement_-_Horizon_(M06304).pdf"',
        },
      },
      dpc_bcvt: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '18TaUIrCCKUQ34IWrCHMPi',
          type: 'Entry',
          createdAt: '2021-09-21T19:01:26.187Z',
          updatedAt: '2021-09-22T14:10:12.740Z',
          publishedVersion: 9,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          actionDescription:
            'HealthEquity HSA Custodial Agreement - PacLife Cash Supplement - Vermont',
          actionValue:
            'link="https://learn-mymoneybcbsvt.hellofurther.com/@api/deki/files/725/HealthEquity_HSA_Custodial_Agreement_PacLife_Cash_Supplement_-_BCBS_VT_(M06308).pdf"',
        },
      },
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6iO5FuGadtkUOEIu0Rd9lV',
          type: 'Entry',
          createdAt: '2021-09-21T19:02:50.070Z',
          updatedAt: '2021-09-22T14:11:40.398Z',
          publishedVersion: 9,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          actionDescription:
            'HealthEquity HSA Custodial Agreement - PacLife Cash Supplement - Capital Blue',
          actionValue:
            'link="https://learn-capitalbluecross.hellofurther.com/@api/deki/files/532/HealthEquity_HSA_Custodial_Agreement_PacLife_Cash_Supplement_-_Capital_BC_(M06306).PDF"',
        },
      },
    },
  },
  'hsa-custodial-agreement': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '5oXCaQvTCulWJsqQhEPexW',
      type: 'Entry',
      createdAt: '2021-09-21T19:36:28.717Z',
      updatedAt: '2021-09-21T19:36:28.717Z',
      publishedVersion: 9,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'HSA Custodial Agreement',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1fT3DCnxg2lK39is83k7HP',
          type: 'Entry',
          createdAt: '2021-09-21T19:36:25.358Z',
          updatedAt: '2021-09-21T19:36:25.358Z',
          publishedVersion: 7,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          actionDescription: 'HealthEquity HSA Custodial Agreement- Further',
          actionValue:
            'link="https://learn.hellofurther.com/@api/deki/files/1376/HealthEquity_HSA_Custodial_Agreement_-_Further_(M06309).pdf"',
        },
      },
      contentAreaSlug: 'hsa-custodial-agreement',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'MRA13myPVmPviIVhoPlPd',
          type: 'Entry',
          createdAt: '2021-09-21T19:32:58.873Z',
          updatedAt: '2021-09-21T19:32:58.873Z',
          publishedVersion: 7,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          actionDescription: 'HealthEquity HSA Custodial Agreement- CareFirst',
          actionValue:
            'link="https://learn-carefirst.hellofurther.com/@api/deki/files/433/HealthEquity_HSA_Custodial_Agreement_-_CareFirst_(M06312).pdf"',
        },
      },
      dpc_bchzn: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4ybBj6aaRXy8GqAimjbmyV',
          type: 'Entry',
          createdAt: '2021-09-21T19:33:53.334Z',
          updatedAt: '2021-09-21T19:33:53.334Z',
          publishedVersion: 6,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          actionDescription: 'HealthEquity HSA Custodial Agreement- Horizon',
          actionValue:
            'link="https://learn-horizonmyway.hellofurther.com/@api/deki/files/692/HealthEquity_HSA_Custodial_Agreement_-_Horizon_(M06313).pdf"',
        },
      },
      dpc_bcvt: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1spw2dvDAavX2JzZyRbCEZ',
          type: 'Entry',
          createdAt: '2021-09-21T19:35:03.950Z',
          updatedAt: '2021-09-21T19:35:03.950Z',
          publishedVersion: 7,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          actionDescription:
            'HealthEquity HSA Custodial Agreement- BCBS Vermont',
          actionValue:
            'link="https://learn-mymoneybcbsvt.hellofurther.com/@api/deki/files/723/HealthEquity_HSA_Custodial_Agreement_-_BCBS_Vermont_(M06311).pdf"',
        },
      },
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6QnYx4JWOqoZFI3gB8kRdb',
          type: 'Entry',
          createdAt: '2021-09-21T19:36:01.455Z',
          updatedAt: '2021-09-21T19:36:01.455Z',
          publishedVersion: 7,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          actionDescription: 'HealthEquity HSA Custodial Agreement- Capital BC',
          actionValue:
            'link="https://learn-capitalbluecross.hellofurther.com/@api/deki/files/530/HealthEquity_HSA_Custodial_Agreement_-_Capital_BC_(M06310).pdf"',
        },
      },
    },
  },
  'hsa-custodial-agreement-supplement-fdic-insured-cash-supplement': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '53oPGl1g5ucfqPrIoijUql',
      type: 'Entry',
      createdAt: '2021-09-21T19:02:54.795Z',
      updatedAt: '2021-09-21T19:05:04.358Z',
      publishedVersion: 12,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description:
        'HSA Custodial Agreement Supplement - FDIC Insured Cash Supplement',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '7fJDm592YuR4bwkRO9FBrF',
          type: 'Entry',
          createdAt: '2021-09-21T18:56:27.144Z',
          updatedAt: '2021-09-22T13:28:02.591Z',
          publishedVersion: 17,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          actionDescription:
            'HealthEquity HSA Custodial Agreement- Federally Insured Cash Supplement- Further',
          actionValue:
            'link="https://learn.hellofurther.com/@api/deki/files/1375/HealthEquity_HSA_Custodial_Agreement_Federally_Insured_Cash_Supplement_-_Further_(M06299).pdf"',
        },
      },
      contentAreaSlug:
        'hsa-custodial-agreement-supplement-fdic-insured-cash-supplement',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '2aToqCgzLZts6pgCxQNv7O',
          type: 'Entry',
          createdAt: '2021-09-21T18:58:32.633Z',
          updatedAt: '2021-09-22T13:39:48.056Z',
          publishedVersion: 12,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          actionDescription:
            'HealthEquity HSA Custodial Agreement- Federally Insured Cash Supplement- CareFirst',
          actionValue:
            'link="https://learn-carefirst.hellofurther.com/@api/deki/files/434/HealthEquity_HSA_Custodial_Agreement_Federally_Insured_Cash_Supplement_-_CareFirst_(M06301).pdf?"',
        },
      },
      dpc_bchzn: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '767twbXwZvU8zMhoosyY0m',
          type: 'Entry',
          createdAt: '2021-09-21T18:59:49.629Z',
          updatedAt: '2021-09-22T13:40:22.081Z',
          publishedVersion: 12,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          actionDescription:
            'HealthEquity HSA Custodial Agreement- Federally Insured Cash Supplement- Horizon',
          actionValue:
            'link="https://learn-horizonmyway.hellofurther.com/@api/deki/files/693/HealthEquity_HSA_Custodial_Agreement_Federally_Insured_Cash_Supplement_-_Horizon_(M06303).pdf"',
        },
      },
      dpc_bcvt: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '2IkTdvMHApIQfeSOf3LO1G',
          type: 'Entry',
          createdAt: '2021-09-21T19:01:03.300Z',
          updatedAt: '2021-09-22T13:50:43.358Z',
          publishedVersion: 10,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          actionDescription:
            'HealthEquity HSA Custodial Agreement- Federally Insured Cash supplement- Vermont',
          actionValue:
            'link="https://learn-mymoneybcbsvt.hellofurther.com/@api/deki/files/724/HealthEquity_HSA_Custodial_Agreement_Federally_Insured_Cash_Supplement_-_BCBS_VT_(M06307).pdf"',
        },
      },
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1xew8dvVTyxpN6Tl9OJ7Qb',
          type: 'Entry',
          createdAt: '2021-09-21T19:05:00.079Z',
          updatedAt: '2021-09-22T13:53:24.991Z',
          publishedVersion: 13,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          actionDescription:
            'HealthEquity HSA Custodial agreement- Federally Insured Cash Supplement- CapBlue',
          actionValue:
            'link="https://learn-capitalbluecross.hellofurther.com/@api/deki/files/531/HealthEquity_HSA_Custodial_Agreement_Federally_Insured_Cash_Supplement_-_Capital_BC_(M06305).PDF"',
        },
      },
    },
  },
  'service-mark': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '3X8mC4bzovjRWWjA1hR0Yw',
      type: 'Entry',
      createdAt: '2019-01-24T16:48:05.683Z',
      updatedAt: '2021-09-15T13:51:39.720Z',
      publishedVersion: 19,
      revision: 4,
      locale: 'en-US',
    },
    fields: {
      description: 'Service Mark',
      contentAreaSlug: 'service-mark',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '7DQLVOHUOYJb02EXbl1WcU',
          type: 'Entry',
          createdAt: '2019-01-24T16:59:44.886Z',
          updatedAt: '2019-01-24T18:23:39.136Z',
          publishedVersion: 7,
          revision: 2,
          locale: 'en-US',
        },
        fields: { title: 'Service Mark - CareFirst', content: ' ' },
      },
      dpc_bchzn: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '27b8v3CXhIXAKkhOO0fVGs',
          type: 'Entry',
          createdAt: '2019-01-24T16:59:54.269Z',
          updatedAt: '2019-01-24T18:22:46.190Z',
          publishedVersion: 21,
          revision: 4,
          locale: 'en-US',
        },
        fields: { title: 'Service Mark - Horizon', content: ' ' },
      },
    },
  },
  'pdf-tagline': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '5HkXVS0XqPfIoFUmlVAIDO',
      type: 'Entry',
      createdAt: '2021-07-09T17:02:03.472Z',
      updatedAt: '2021-07-09T17:02:03.472Z',
      publishedVersion: 3,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'PDF tagline',
      contentAreaSlug: 'pdf-tagline',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5D3Q3WweTSFdhXXWl1hodi',
          type: 'Entry',
          createdAt: '2021-07-09T17:00:46.668Z',
          updatedAt: '2021-07-09T17:00:46.668Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          headline: 'Capital Blue PDF Tagline Copy ',
          content:
            'An Independent Licensee of the Blue Cross Blue Shield Association',
        },
      },
    },
  },
  'submit-hsa-application-error-get-group-plan-types': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '6eWfCE8imkuywuqWekGYW4',
      type: 'Entry',
      createdAt: '2018-02-22T15:37:34.652Z',
      updatedAt: '2021-06-27T16:24:18.308Z',
      publishedVersion: 15,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Submit HSA Application - Error - Get Group Plan Types',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'submit-hsa-application-error-get-group-plan-types',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'submit-hsa-application-error-get-irs-limits': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4u1ru6K8fCQ6C46kmWEkWm',
      type: 'Entry',
      createdAt: '2018-03-07T21:53:37.984Z',
      updatedAt: '2021-06-27T16:24:17.891Z',
      publishedVersion: 12,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Submit HSA Application - Error - Get IRS Limits',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1uOtRniUrWaeCqwUqmIS4w',
          type: 'Entry',
          createdAt: '2018-03-07T21:53:10.129Z',
          updatedAt: '2018-03-22T15:35:24.161Z',
          publishedVersion: 105,
          revision: 5,
          locale: 'en-US',
        },
        fields: {
          title: 'Submit HSA Application - Error - Get IRS Limits - Default',
          content:
            '## Unable to retrieve IRS contribution limits\nWe are unable to retrieve the current IRS contribution limits at this time. Please contact Customer Service at (800) 859-2144 for more information.',
        },
      },
      contentAreaSlug: 'submit-hsa-application-error-get-irs-limits',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '36T0qmsC4LNduDU6INvRAb',
          type: 'Entry',
          createdAt: '2021-06-22T01:28:33.018Z',
          updatedAt: '2021-06-22T01:28:33.018Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title:
            'Submit HSA Application - Error - Get IRS Limits - Capital Blue',
          content:
            '## Unable to retrieve IRS contribution limits\nWe are unable to retrieve the current IRS contribution limits at this time. Please contact Customer Service at 877.293.7041 for more information.',
        },
      },
    },
  },
  'submit-hsa-application-error-validate-personal-information': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '5DW4sTno9GumGgwi60S2Ya',
      type: 'Entry',
      createdAt: '2018-02-21T21:46:14.613Z',
      updatedAt: '2021-06-27T16:24:17.884Z',
      publishedVersion: 14,
      revision: 3,
      locale: 'en-US',
    },
    fields: {
      description:
        'Submit HSA Application - Error - Validate Personal Information',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1Nfc4Owtd2WAY6MI6cSWge',
          type: 'Entry',
          createdAt: '2018-02-21T23:25:48.641Z',
          updatedAt: '2019-09-16T21:01:46.934Z',
          publishedVersion: 225,
          revision: 5,
          locale: 'en-US',
        },
        fields: {
          title:
            'Submit HSA Application - Error - Validate Personal Information - Default',
          content:
            '## You are already a member\nThe information entered seems to match with an existing member. Please contact Customer Service at (800) 859-2144 for more information.',
        },
      },
      contentAreaSlug:
        'submit-hsa-application-error-validate-personal-information',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '515CPraRFd7NJq8or8fwWh',
          type: 'Entry',
          createdAt: '2021-06-22T01:24:24.574Z',
          updatedAt: '2021-06-22T01:24:24.574Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title:
            'Submit HSA Application - Error - Validate Personal Information - Capital Blue',
          content:
            '## You are already a member\nThe information entered seems to match with an existing member. Please contact Customer Service at 877.293.7041 for more information.',
        },
      },
    },
  },
  'login-error-invalid-credentials': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2SuMUTVkm4AW2wiuCiqwoE',
      type: 'Entry',
      createdAt: '2018-02-25T18:53:59.803Z',
      updatedAt: '2021-06-27T16:24:17.878Z',
      publishedVersion: 24,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Login Error - Invalid Credentials',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '15U6oAb26gCeOc2cqc48mS',
          type: 'Entry',
          createdAt: '2018-02-25T18:53:34.859Z',
          updatedAt: '2018-03-23T15:36:18.965Z',
          publishedVersion: 100,
          revision: 9,
          locale: 'en-US',
        },
        fields: {
          title: 'Login Error - Invalid Credentials',
          content:
            "We're unable to sign you in. Please make sure your username and password are correct and try again or contact Customer Service at (800) 859-2144 for assistance.",
        },
      },
      contentAreaSlug: 'login-error-invalid-credentials',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'RjHKUGotu5yeVNFCm8pxK',
          type: 'Entry',
          createdAt: '2021-06-22T01:27:17.405Z',
          updatedAt: '2021-06-22T01:27:17.405Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Login Error - Invalid Credentials - Capital Blue',
          content:
            "We're unable to sign you in. Please make sure your username and password are correct and try again or contact Customer Service at 877.293.7041 for assistance.",
        },
      },
    },
  },
  'fraudulent-login-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '7Gy6HNIAAE42SaU42wIQ8G',
      type: 'Entry',
      createdAt: '2018-02-24T17:45:36.917Z',
      updatedAt: '2021-06-27T16:24:17.876Z',
      publishedVersion: 14,
      revision: 5,
      locale: 'en-US',
    },
    fields: {
      description: 'Fraudulent Login - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6J29FKW9YA0EEeyu6U48i0',
          type: 'Entry',
          createdAt: '2018-02-24T17:45:06.713Z',
          updatedAt: '2018-03-23T15:51:25.728Z',
          publishedVersion: 43,
          revision: 13,
          locale: 'en-US',
        },
        fields: {
          title: 'Fraudulent Login - Error - Default',
          content:
            'Your account is under review. Please contact Customer Service at (800) 859-2144 for more information.',
        },
      },
      contentAreaSlug: 'fraudulent-login-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '7pQYeTeMppHclnOQEwZ8pc',
          type: 'Entry',
          createdAt: '2021-06-22T01:26:06.503Z',
          updatedAt: '2021-06-22T01:26:06.503Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Fraudulent Login - Error - Capital Blue',
          content:
            'Your account is under review. Please contact Customer Service at 877.293.7041 for more information.',
        },
      },
    },
  },
  'submit-hsa-application-error-add-scheduled-deposit': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '5rQdRec9ziseWom2MkQy8k',
      type: 'Entry',
      createdAt: '2018-02-23T19:32:38.327Z',
      updatedAt: '2021-06-27T16:24:16.943Z',
      publishedVersion: 12,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Submit HSA Application - Error - Add Scheduled Deposit',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4rG1ISojEsSkqmugeOGa0G',
          type: 'Entry',
          createdAt: '2018-02-23T19:30:39.283Z',
          updatedAt: '2018-03-21T15:35:36.733Z',
          publishedVersion: 67,
          revision: 5,
          locale: 'en-US',
        },
        fields: {
          title:
            'Submit HSA Application - Error - Add Scheduled Deposit - Default',
          content:
            '## Unable to complete deposit\nYour application has been received, but the deposit cannot completed at this time. Please contact Customer Service at (800) 859-2144 for more information.',
        },
      },
      contentAreaSlug: 'submit-hsa-application-error-add-scheduled-deposit',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3mRrcMB8NYzY8EpYcrcYgD',
          type: 'Entry',
          createdAt: '2021-06-22T01:30:08.208Z',
          updatedAt: '2021-06-22T01:30:08.208Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title:
            'Submit HSA Application - Error - Add Scheduled Deposit - Capital Blue',
          content:
            '## Unable to complete deposit\nYour application has been received, but the deposit cannot completed at this time. Please contact Customer Service at 877.293.7041 for more information.',
        },
      },
    },
  },
  'match-document-to-transaction-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '5wHHN9TAsg6OEaqaESk4WU',
      type: 'Entry',
      createdAt: '2018-05-07T20:55:02.961Z',
      updatedAt: '2021-06-27T16:24:16.921Z',
      publishedVersion: 14,
      revision: 3,
      locale: 'en-US',
    },
    fields: {
      description: 'Match Document To Transaction - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'match-document-to-transaction-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'get-user-groups-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '42uPXTO04wQeumkYK0GkUi',
      type: 'Entry',
      createdAt: '2018-07-16T15:52:56.568Z',
      updatedAt: '2021-06-27T16:24:16.904Z',
      publishedVersion: 9,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Get User Groups - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'get-user-groups-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'submit-hsa-application-error-add-bank-account': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2HmaCIXbDasSeoa0OueqMY',
      type: 'Entry',
      createdAt: '2018-02-23T19:32:05.334Z',
      updatedAt: '2021-06-27T16:24:16.900Z',
      publishedVersion: 9,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Submit HSA Application - Error - Add Bank Account',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6tn4yFWYSsMKIMuigoaEik',
          type: 'Entry',
          createdAt: '2018-02-23T19:29:52.125Z',
          updatedAt: '2018-03-21T15:35:28.084Z',
          publishedVersion: 67,
          revision: 6,
          locale: 'en-US',
        },
        fields: {
          title: 'Submit HSA Application - Error - Add Bank Account - Default',
          content:
            "## Unable to add bank account\nWe've received your application, but we're unable to add your bank account at this time. Please contact Customer Service at (800) 859-2144 for more information.",
        },
      },
      contentAreaSlug: 'submit-hsa-application-error-add-bank-account',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '348zbafmM2oYEUAIRpqNRw',
          type: 'Entry',
          createdAt: '2021-06-22T01:31:08.077Z',
          updatedAt: '2021-06-22T01:31:08.077Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title:
            'Submit HSA Application - Error - Add Bank Account - Capital Blue',
          content:
            "## Unable to add bank account\nWe've received your application, but we're unable to add your bank account at this time. Please contact Customer Service at 877.293.7041 for more information.",
        },
      },
    },
  },
  'remove-document-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4GVxnGgQ4EumC4igAMIqsM',
      type: 'Entry',
      createdAt: '2018-05-07T17:20:09.653Z',
      updatedAt: '2021-06-27T16:24:16.878Z',
      publishedVersion: 6,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Remove Document - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'remove-document-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'update-document-detail-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2DkNsMG3VGC2EYauSYK6Oo',
      type: 'Entry',
      createdAt: '2018-05-03T18:29:23.814Z',
      updatedAt: '2021-06-27T16:24:16.873Z',
      publishedVersion: 18,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Update Document Detail - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'update-document-detail-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'add-debit-card-error-validate-dependent': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '3hlLGabOZOgycEWYGMaYqs',
      type: 'Entry',
      createdAt: '2018-03-09T19:51:02.837Z',
      updatedAt: '2021-06-27T16:24:16.154Z',
      publishedVersion: 12,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Add Debit Card - Error - Validate Dependent',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'add-debit-card-error-validate-dependent',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'view-account-number-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '1BIHdaTXMgaAC08OCSgkAO',
      type: 'Entry',
      createdAt: '2018-02-25T00:38:44.959Z',
      updatedAt: '2021-06-27T16:24:16.119Z',
      publishedVersion: 16,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'View Account Number - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'view-account-number-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'add-debit-card-error-add-dependent': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4FvB0vHci4e0GyMSSCQi4y',
      type: 'Entry',
      createdAt: '2018-03-09T19:51:23.634Z',
      updatedAt: '2021-06-27T16:24:16.097Z',
      publishedVersion: 5,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Add Debit Card - Error - Add Dependent',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'add-debit-card-error-add-dependent',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'forgot-password-error-default': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2NL5QgsavYgKYmaG8A208Y',
      type: 'Entry',
      createdAt: '2018-02-24T18:29:39.625Z',
      updatedAt: '2021-06-27T16:24:16.069Z',
      publishedVersion: 28,
      revision: 3,
      locale: 'en-US',
    },
    fields: {
      description: 'Forgot Password - Error - Default',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'forgot-password-error-default',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'register-error-default': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '1o4kv6X2AAo2Ei6aiCcoC4',
      type: 'Entry',
      createdAt: '2018-02-24T18:23:51.360Z',
      updatedAt: '2021-06-27T16:24:16.032Z',
      publishedVersion: 12,
      revision: 3,
      locale: 'en-US',
    },
    fields: {
      description: 'Register - Error - Default',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'register-error-default',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'investment-transfer-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '6P8Y1P1pTOK6WSW4UG2EA8',
      type: 'Entry',
      createdAt: '2018-02-19T23:04:31.606Z',
      updatedAt: '2021-06-27T16:24:16.014Z',
      publishedVersion: 7,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Investment Transfer - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'investment-transfer-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'activate-hsa-error-open-account': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '7L5kPiw7FCC22mYa6wo0is',
      type: 'Entry',
      createdAt: '2018-02-19T22:44:20.467Z',
      updatedAt: '2021-06-27T16:24:15.886Z',
      publishedVersion: 5,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Activate HSA - Error - Open Account',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'activate-hsa-error-open-account',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'make-deposit-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '3xvNtqP26kGQIQC6GKYoCU',
      type: 'Entry',
      createdAt: '2018-02-18T20:37:51.524Z',
      updatedAt: '2021-06-27T16:24:15.600Z',
      publishedVersion: 12,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Make Deposit - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'make-deposit-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'view-attachment-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: 'q7RykhvuZEaOEic444Uye',
      type: 'Entry',
      createdAt: '2018-02-19T18:51:57.175Z',
      updatedAt: '2021-06-27T16:24:15.592Z',
      publishedVersion: 14,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'View Attachment - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'view-attachment-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'update-beneficiaries-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '6TN06XSdd62SqaGIqy2W4',
      type: 'Entry',
      createdAt: '2018-02-19T22:05:32.466Z',
      updatedAt: '2021-06-27T16:24:15.590Z',
      publishedVersion: 7,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Update Beneficiaries - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'update-beneficiaries-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'submit-claim-error-get-providers': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '3firZb7tKM6s6KOescMy8m',
      type: 'Entry',
      createdAt: '2018-02-19T15:20:35.425Z',
      updatedAt: '2021-06-27T16:24:15.581Z',
      publishedVersion: 8,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Submit Claim - Error - Get Providers',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'submit-claim-error-get-providers',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'submit-claim-error-get-bank-accounts': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '6PLQA0ftpCy8YgWYE6muYu',
      type: 'Entry',
      createdAt: '2018-02-19T15:20:24.496Z',
      updatedAt: '2021-06-27T16:24:15.571Z',
      publishedVersion: 10,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Submit Claim - Error - Get Bank Accounts',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'submit-claim-error-get-bank-accounts',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'update-scheduled-deposit-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '755NsE8BsA06EQckYm08uq',
      type: 'Entry',
      createdAt: '2018-02-18T19:46:58.043Z',
      updatedAt: '2021-06-27T16:24:15.569Z',
      publishedVersion: 5,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Update Scheduled Deposit - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'update-scheduled-deposit-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'update-phone-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: 'ZKRhYNDUqYaSWMQKSuomw',
      type: 'Entry',
      createdAt: '2018-02-18T17:12:28.693Z',
      updatedAt: '2021-06-27T16:23:39.529Z',
      publishedVersion: 5,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Update Phone - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'update-phone-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'update-account-hold-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4ySpQRSMRigE42qqikW0cU',
      type: 'Entry',
      createdAt: '2018-02-18T17:45:27.896Z',
      updatedAt: '2021-06-27T16:23:39.311Z',
      publishedVersion: 7,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Update Account Hold - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'update-account-hold-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'add-ari-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4hGn8DxhRu6GOaQ4swuW84',
      type: 'Entry',
      createdAt: '2018-02-18T18:35:05.299Z',
      updatedAt: '2021-06-27T16:23:38.816Z',
      publishedVersion: 7,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Add ARI - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'add-ari-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'update-coverage-tier-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '5Ib48PE54QGsMwqq2kacUu',
      type: 'Entry',
      createdAt: '2018-02-18T18:13:25.276Z',
      updatedAt: '2021-06-27T16:23:38.186Z',
      publishedVersion: 9,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Update Coverage Tier - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'update-coverage-tier-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'cancel-pending-investment-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '76SuACTlle2Y88Kkyy0QsE',
      type: 'Entry',
      createdAt: '2018-02-18T19:28:27.249Z',
      updatedAt: '2021-06-27T16:23:37.929Z',
      publishedVersion: 8,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Cancel Pending Investment - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'cancel-pending-investment-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'update-ari-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '3humzm23yEYQyUOAGQauS8',
      type: 'Entry',
      createdAt: '2018-02-18T18:35:13.521Z',
      updatedAt: '2021-06-27T16:23:37.877Z',
      publishedVersion: 5,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Update ARI - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'update-ari-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'remove-ari-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '6oRy8hFNwkQ882MiAi0gCW',
      type: 'Entry',
      createdAt: '2018-02-18T19:00:20.882Z',
      updatedAt: '2021-06-27T16:23:37.868Z',
      publishedVersion: 6,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Remove ARI - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'remove-ari-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'cancel-pending-claim-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '1xPF2jcwBGu0IuoIg0sC0O',
      type: 'Entry',
      createdAt: '2018-02-18T19:15:03.649Z',
      updatedAt: '2021-06-27T16:23:37.858Z',
      publishedVersion: 7,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Cancel Pending Claim - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'cancel-pending-claim-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'update-plan-type-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: 'Mnx3e6IBqwEQuESG2OeI4',
      type: 'Entry',
      createdAt: '2018-02-18T18:06:46.115Z',
      updatedAt: '2021-06-27T16:23:37.439Z',
      publishedVersion: 10,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Update Plan Type - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'update-plan-type-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'update-email-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4OHI1fiodGCwwqoOKAgWAK',
      type: 'Entry',
      createdAt: '2018-02-18T16:59:19.635Z',
      updatedAt: '2021-06-27T16:23:36.873Z',
      publishedVersion: 5,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Update Email - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'update-email-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'update-address-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2ELSp2vxu4AcmCUGiK6yeA',
      type: 'Entry',
      createdAt: '2018-02-18T16:38:10.811Z',
      updatedAt: '2021-06-27T16:23:36.722Z',
      publishedVersion: 7,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Update Address - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'update-address-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'add-provider-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4m5sddj196AysOmKCOquIG',
      type: 'Entry',
      createdAt: '2018-02-18T01:20:33.448Z',
      updatedAt: '2021-06-27T16:23:36.637Z',
      publishedVersion: 14,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Add Provider - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'add-provider-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'cancel-debit-card-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4EhmsJxiVOouQuCaMqCuC6',
      type: 'Entry',
      createdAt: '2018-02-17T23:13:32.145Z',
      updatedAt: '2021-06-27T16:23:36.517Z',
      publishedVersion: 5,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Cancel Debit Card - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'cancel-debit-card-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'remove-bank-account-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '5iBO0mlRDqMWCw8ikwM20A',
      type: 'Entry',
      createdAt: '2018-02-16T18:23:29.180Z',
      updatedAt: '2021-06-27T16:23:36.501Z',
      publishedVersion: 14,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Remove Bank Account - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'remove-bank-account-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'cancel-all-debit-cards-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '3X6GwzsPQsAacEOe4cQECS',
      type: 'Entry',
      createdAt: '2018-02-17T23:13:23.114Z',
      updatedAt: '2021-06-27T16:23:36.483Z',
      publishedVersion: 7,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Cancel All Debit Cards - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'cancel-all-debit-cards-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'add-debit-card-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '5eiy5aQX604uwmsc00OUau',
      type: 'Entry',
      createdAt: '2018-02-17T22:35:33.594Z',
      updatedAt: '2021-06-27T16:23:36.452Z',
      publishedVersion: 15,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Add Debit Card - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'add-debit-card-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'manage-crossover-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '6vwpYw7tCMQQsIWECWSaCO',
      type: 'Entry',
      createdAt: '2018-02-18T00:30:13.671Z',
      updatedAt: '2021-06-27T16:23:36.449Z',
      publishedVersion: 9,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Manage Crossover - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'manage-crossover-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'forgot-username-error-unable-to-confirm': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '6GlTKlbPoIOQokOW4WkKmE',
      type: 'Entry',
      createdAt: '2018-02-24T18:27:35.399Z',
      updatedAt: '2021-06-27T16:23:36.402Z',
      publishedVersion: 24,
      revision: 3,
      locale: 'en-US',
    },
    fields: {
      description: 'Forgot Username - Error - Unable to Confirm',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6tmO6X6WEou6KCoUeYyqUs',
          type: 'Entry',
          createdAt: '2018-02-24T18:12:24.629Z',
          updatedAt: '2018-03-20T19:40:35.236Z',
          publishedVersion: 28,
          revision: 6,
          locale: 'en-US',
        },
        fields: {
          title: 'Forgot Username - Error - Unable to Confirm',
          content:
            '## Unable to confirm your information\nWe are unable to confirm the information you entered. Please contact Customer Service at (800) 859-2144 for assistance.',
        },
      },
      contentAreaSlug: 'forgot-username-error-unable-to-confirm',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4uVpsUIxRwCNPOfSNSY8Pc',
          type: 'Entry',
          createdAt: '2021-06-22T02:02:38.537Z',
          updatedAt: '2021-06-22T02:02:38.537Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title:
            'Forgot Username - Error - No Email Address on File - Capital Blue',
          content:
            '## No email address found\nYou do not have an email address on file. Please contact Customer Service at 877.293.7041 for assistance.',
        },
      },
    },
  },
  'make-primary-bank-account-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '5OI2uXm8HCCoweaEIU20Ww',
      type: 'Entry',
      createdAt: '2018-02-16T18:16:20.748Z',
      updatedAt: '2021-06-27T16:23:36.170Z',
      publishedVersion: 8,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Make Primary Bank Account - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'make-primary-bank-account-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'update-provider-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2PMfG6BO76OqyOyckIou0Q',
      type: 'Entry',
      createdAt: '2018-02-16T03:13:06.735Z',
      updatedAt: '2021-06-27T16:23:36.125Z',
      publishedVersion: 16,
      revision: 3,
      locale: 'en-US',
    },
    fields: {
      description: 'Update Provider - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'update-provider-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'remove-provider-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '6OFSBg14QggAuaeOMsEUOk',
      type: 'Entry',
      createdAt: '2018-02-16T03:17:24.417Z',
      updatedAt: '2021-06-27T16:23:36.122Z',
      publishedVersion: 10,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Remove Provider - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'remove-provider-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'submit-claim-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2AjLEbuUd2g6yIAk4SUCKe',
      type: 'Entry',
      createdAt: '2018-02-16T17:22:46.239Z',
      updatedAt: '2021-06-27T16:23:36.114Z',
      publishedVersion: 8,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Submit Claim - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'submit-claim-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'add-bank-account-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: 'jE8XL90FvaE60mY2oOU4E',
      type: 'Entry',
      createdAt: '2018-02-16T18:20:54.971Z',
      updatedAt: '2021-06-27T16:23:36.114Z',
      publishedVersion: 14,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Add Bank Account - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'add-bank-account-error',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6kTna3AjLBazrx9E3UjlWV',
          type: 'Entry',
          createdAt: '2021-06-22T01:32:29.714Z',
          updatedAt: '2021-06-22T01:32:29.714Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Capital Blue',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at 877.293.7041 for more information. ',
        },
      },
    },
  },
  'forgot-password-error-no-email-address-on-file': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '7t0QK4RKvYwWIqAO42ecAW',
      type: 'Entry',
      createdAt: '2018-02-24T20:51:27.975Z',
      updatedAt: '2021-06-27T16:23:36.111Z',
      publishedVersion: 29,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Forgot Password - Error - No Email Address on File',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5ciUyeXsNqyG2CWoAG08wk',
          type: 'Entry',
          createdAt: '2018-02-24T20:50:16.284Z',
          updatedAt: '2018-03-20T19:42:09.473Z',
          publishedVersion: 87,
          revision: 6,
          locale: 'en-US',
        },
        fields: {
          title: 'Forgot Password - Error - No Email Address on File',
          content:
            "## Email address not found\n\nWe couldn't find an email address for your account. Please contact Customer Service at (800) 859-2144 for assistance.",
        },
      },
      contentAreaSlug: 'forgot-password-error-no-email-address-on-file',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3UU30JR2CWixmpnZwkEvex',
          type: 'Entry',
          createdAt: '2021-06-22T02:01:27.356Z',
          updatedAt: '2021-06-22T02:01:27.356Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title:
            'Forgot Password - Error - No Email Address on File - Capital Blue',
          content:
            "## Email address not found\n\nWe couldn't find an email address for your account. Please contact Customer Service at 877.293.7041 for assistance.",
        },
      },
    },
  },
  'payment-method-sidebar-content': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '1UEK7e3uSYy46oeiyYoe6a',
      type: 'Entry',
      createdAt: '2017-12-22T17:35:33.659Z',
      updatedAt: '2021-06-27T16:18:13.597Z',
      publishedVersion: 45,
      revision: 11,
      locale: 'en-US',
    },
    fields: {
      description: 'Payment Method Sidebar Content',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1Qj30hfJYAO60sOcswog2I',
          type: 'Entry',
          createdAt: '2017-12-22T17:34:48.815Z',
          updatedAt: '2019-04-30T13:40:02.009Z',
          publishedVersion: 205,
          revision: 7,
          locale: 'en-US',
        },
        fields: {
          title: 'Default Payment Method Sidebar',
          headline: 'Related',
          content:
            '[Learn: Automated Claim Payment](link="https://learn.hellofurther.com/Individuals/Getting_Started/Automated_Claim_Payments")\n\n[Review or update your contact info](route="personalInformation")\n\n[Learn: Using Your Debit Card](link="https://learn.hellofurther.com/Individuals/Debit_Cards/Using_Your_Debit_Card")\n\n[Review the Cardholder Agreement](link="https://selectaccount-prod2.mindtouch.us/@api/deki/files/785/Further_Cardholder_Agreement.pdf")',
        },
      },
      contentAreaSlug: 'payment-method-sidebar-content',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1I6SY8wR7q2UIKOOcieuKc',
          type: 'Entry',
          createdAt: '2018-02-09T15:44:33.244Z',
          updatedAt: '2020-06-08T18:48:09.609Z',
          publishedVersion: 58,
          revision: 5,
          locale: 'en-US',
        },
        fields: {
          title: 'Group CareFirst Payment Method Sidebar',
          headline: 'Related',
          content:
            '[Learn: Automated Claim Submission](link="https://learn-carefirst.hellofurther.com/Individuals/Getting_Started/Automated_Claim_Payments")\n\n[Learn: Using Your Debit Card](link="https://learn-carefirst.hellofurther.com/Individuals/Debit_Cards/Using_Your_Debit_Card")',
        },
      },
      group_015273: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '2a0MiAoE0sSQKYSGoSmMso',
          type: 'Entry',
          createdAt: '2018-06-20T17:34:11.335Z',
          updatedAt: '2018-06-20T17:34:11.335Z',
          publishedVersion: 37,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Group Sodexo Payment Method Sidebar',
          headline: 'Related',
          content:
            '[Authorize access to your account information for someone](route="releaseAuthorization")',
        },
      },
      dpc_bchzn: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6uhOxPNohagwwCIsWukMEg',
          type: 'Entry',
          createdAt: '2018-11-30T21:14:50.509Z',
          updatedAt: '2018-11-30T21:14:50.509Z',
          publishedVersion: 35,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Horizon Payment Method Sidebar',
          headline: 'Related',
          content:
            '[Learn: Automated Claim Submission](link="https://learn-horizonmyway.hellofurther.com/Individuals/Automated_Claim_Payments_with_Crossover")\n\n[Review or update your contact info](route="personalInformation")\n\n[Learn: Using Your Debit Card](link="https://learn-horizonmyway.hellofurther.com/Individuals/Debit_Cards/Using_Your_Debit_Card")\n\n[Review the Cardholder Agreement](link="https://learn-horizonmyway.hellofurther.com/@api/deki/files/528/M126243-Horizon_Cardholder_Agreement.pdf")',
        },
      },
      group_600001: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '2ncJDjKdjO2qU0cqc0UyCi',
          type: 'Entry',
          createdAt: '2018-12-20T03:27:15.199Z',
          updatedAt: '2018-12-20T03:27:15.199Z',
          publishedVersion: 8,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Merck Payment Method Sidebar',
          headline: 'Related',
          content:
            '[Review or update your contact info](route="personalInformation")\n\n[Review the Cardholder Agreement](link="https://learn-horizonmyway.hellofurther.com/@api/deki/files/528/M126243-Horizon_Cardholder_Agreement.pdf")',
        },
      },
      dpc_bcvt: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4ykWosSYH6vqvau7M74mYm',
          type: 'Entry',
          createdAt: '2020-05-29T16:15:27.645Z',
          updatedAt: '2020-05-29T16:15:27.645Z',
          publishedVersion: 6,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Vermont Payment Method Sidebar',
          headline: 'Related',
          content:
            '[Learn: Automated Claim Submission](link="https://learn-mymoneybcbsvt.hellofurther.com/Individuals/Automated_Claim_Payments_with_Crossover")\n\n[Review or update your contact info](route="personalInformation")\n\n[Learn: Using Your Debit Card](link="https://learn-mymoneybcbsvt.hellofurther.com/Individuals/Debit_Cards/Using_Your_Debit_Card")',
        },
      },
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3YLO8aBZbcVUyFWswcfqQc',
          type: 'Entry',
          createdAt: '2021-06-21T21:19:34.469Z',
          updatedAt: '2021-06-21T21:19:34.469Z',
          publishedVersion: 4,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Capital Blue Payment Method Sidebar',
          headline: 'Related',
          content:
            '[Learn: Automated Claim Submission](link="https://learn-capitalbluecross.hellofurther.com/Individuals/Automated_Claim_Payments_with_Crossover")\n\n[Review or update your contact info](route="personalInformation")\n\n[Learn: Using Your Debit Card](link="https://learn-capitalbluecross.hellofurther.com/Individuals/Debit_Cards/Using_Your_Debit_Card")',
        },
      },
    },
  },
  'important-claim-information': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '16774a34omWiIau2W0A6Ko',
      type: 'Entry',
      createdAt: '2018-03-21T02:42:41.960Z',
      updatedAt: '2021-06-27T16:17:48.930Z',
      publishedVersion: 24,
      revision: 5,
      locale: 'en-US',
    },
    fields: {
      description: 'Important Claim Information',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '2xNgYKNQeU4iga4Ku2scOM',
          type: 'Entry',
          createdAt: '2018-01-30T21:14:16.817Z',
          updatedAt: '2023-09-18T16:29:53.663Z',
          publishedVersion: 384,
          revision: 22,
          locale: 'en-US',
        },
        fields: {
          title: 'Important Claim Information',
          helpContent:
            '# Important Claim Processing Information\n\nFor hearing and speech impaired telephone access for benefits and claims information, please call 711. Provide the following member support number to the relay service: 1-800-859-2144.\n\nA claim that is incomplete or needs additional information to make an appropriate benefit determination is indicated by the denial/adjustment reason on the Explanation of Payment page. When we receive all necessary information, we will process your claim. \n\nWe use internal and external rules and guidelines to make and adverse benefit determination. You have the right to ask for any relevant documents, records, or other information used to process your claim. You may also ask for scientific or clinical judgment used if you claim was denied because it was determined to be experimental or not medically necessary. You can name a representative to ask for this information. Please note by law we cannot send copies of your protected health information to your representative without a [signed authorization for information form](https://learn.hellofurther.com/@api/deki/files/516/Authorization-for-Release-of-Information.pdf) or without authorization granted via the [Further Member Portal](https://member.hellofurther.com/account-settings/release-authorizations). Please contact customer service to request any additional relevant documents. \n\n# Complaint/Appeal Information\n\nThe explanation of payment page explains how your claim was processed based on upon the information submitted to us. You or your designed representative may appeal a denial, partial denial, or reduction of your claim by following our complaint procedures. First, contact customer service for an explanation. If you are not satisfied with the explanation given, please submit your concern on our [appeal filing form](https://learn.hellofurther.com/@api/deki/files/513/SA-Appeal.pdf)  with any other documents, records or information that pertains to your request. Upon receipt of your request, we will provide you a full and fair review of your complaint and a written notice of our decision according to the timeframe found in your Plan documentation. \n\nIf you are a member of a group plan that is a subject to the Employee Retirement Income Security Act(ERISA), once you have exhausted our complaint/appeal process, you have the right to file suit in Federal Court under Section 502(a) of ERISA. ',
          helpContentSlug: 'important-claim-information',
        },
      },
      contentAreaSlug: 'important-claim-information',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '45P2fIzDIAyEWKASus8Kyo',
          type: 'Entry',
          createdAt: '2018-03-19T19:59:05.838Z',
          updatedAt: '2023-09-18T16:29:45.174Z',
          publishedVersion: 120,
          revision: 11,
          locale: 'en-US',
        },
        fields: {
          title: 'CareFirst Important Claim Information',
          helpContent:
            '# Important Claim Processing Information\n\nFor hearing and speech impaired telephone access for benefits and claims information, please call 711. Provide the following member support number to the relay service: 1-866-758-6119.\n\nA claim that is incomplete or needs additional information to make an appropriate benefit determination is indicated by the denial/adjustment reason on the Explanation of Payment page. When we receive all necessary information, we will process your claim. \n\nWe use internal and external rules and guidelines to make and adverse benefit determination. You have the right to ask for any relevant documents, records, or other information used to process your claim. You may also ask for scientific or clinical judgment used if you claim was denied because it was determined to be experimental or not medically necessary. You can name a representative to ask for this information. Please note by law we cannot send copies of your protected health information to your representative without authorization granted via the [CareFirst Member Portal](https://carefirst.member.hellofurther.com/account-settings/release-authorizations). Please contact customer service to request any additional relevant documents. \n\n# Complaint/Appeal Information\n\nThe explanation of payment page explains how your claim was processed based on upon the information submitted to us. You or your designed representative may appeal a denial, partial denial, or reduction of your claim by following our complaint procedures. First, contact customer service for an explanation. If you are not satisfied with the explanation given, please submit your concern on our [appeal filing form](https://learn-carefirst.hellofurther.com/@api/deki/files/281/CareFirst_Appeal_Form.pdf)  with any other documents, records or information that pertains to your request. Upon receipt of your request, we will provide you a full and fair review of your complaint and a written notice of our decision according to the timeframe found in your Plan documentation. \n\nIf you are a member of a group plan that is a subject to the Employee Retirement Income Security Act(ERISA), once you have exhausted our complaint/appeal process, you have the right to file suit in Federal Court under Section 502(a) of ERISA. \n',
          helpContentSlug: 'carefirst-important-claim-information',
        },
      },
      dpc_bchzn: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4ZpspDuGGtLUms1WiUlOhD',
          type: 'Entry',
          createdAt: '2019-03-01T21:00:02.174Z',
          updatedAt: '2023-09-18T16:29:39.503Z',
          publishedVersion: 58,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Horizon Important Claim Information',
          helpContent:
            '# Important Claim Processing Information\n\nFor hearing and speech impaired telephone access for benefits and claims information, please call 711. Provide the following member support number to the relay service: 1-888-215-0025.\n\nA claim that is incomplete or needs additional information to make an appropriate benefit determination is indicated by the denial/adjustment reason on the Explanation of Payment page. When we receive all necessary information, we will process your claim. \n\nWe use internal and external rules and guidelines to make and adverse benefit determination. You have the right to ask for any relevant documents, records, or other information used to process your claim. You may also ask for scientific or clinical judgment used if you claim was denied because it was determined to be experimental or not medically necessary. You can name a representative to ask for this information. Please note by law we cannot send copies of your protected health information to your representative without authorization granted via the [Horizon MyWay Member Portal](https://horizonmyway.member.hellofurther.com/account-settings/release-authorizations). Please contact customer service to request any additional relevant documents. \n\n# Complaint/Appeal Information\n\nThe explanation of payment page explains how your claim was processed based on upon the information submitted to us. You or your designed representative may appeal a denial, partial denial, or reduction of your claim by following our complaint procedures. First, contact customer service for an explanation. If you are not satisfied with the explanation given, please submit your concern on our [appeal filing form](https://learn-horizonmyway.hellofurther.com/@api/deki/files/639/Appeal_Form_-_Horizon.pdf)  with any other documents, records or information that pertains to your request. Upon receipt of your request, we will provide you a full and fair review of your complaint and a written notice of our decision according to the timeframe found in your Plan documentation. \n\nIf you are a member of a group plan that is a subject to the Employee Retirement Income Security Act(ERISA), once you have exhausted our complaint/appeal process, you have the right to file suit in Federal Court under Section 502(a) of ERISA. \n',
          helpContentSlug: 'horizon-important-claim-information',
        },
      },
      dpc_bcvt: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '35N39gUqmB2UqAescg0rpV',
          type: 'Entry',
          createdAt: '2020-06-01T19:24:54.509Z',
          updatedAt: '2023-09-18T16:29:31.398Z',
          publishedVersion: 16,
          revision: 4,
          locale: 'en-US',
        },
        fields: {
          title: 'Vermont Important Claim Information',
          helpContent:
            '# Important Claim Processing Information\n\nFor hearing and speech impaired telephone access for benefits and claims information, please call 711. Provide the following member support number to the relay service: 1-866-999-2605.\n\nA claim that is incomplete or needs additional information to make an appropriate benefit determination is indicated by the denial/adjustment reason on the Explanation of Payment page. When we receive all necessary information, we will process your claim. \n\nWe use internal and external rules and guidelines to make and adverse benefit determination. You have the right to ask for any relevant documents, records, or other information used to process your claim. You may also ask for scientific or clinical judgment used if you claim was denied because it was determined to be experimental or not medically necessary. You can name a representative to ask for this information. Please note by law we cannot send copies of your protected health information to your representative without authorization granted via the [Blue Cross Blue Shield of Vermont Member Portal](https://mymoneybcbsvt.member.hellofurther.com/account-settings/release-authorizations). Please contact customer service to request any additional relevant documents. \n\n# Complaint/Appeal Information\n\nThe explanation of payment page explains how your claim was processed based on upon the information submitted to us. You or your designed representative may appeal a denial, partial denial, or reduction of your claim by following our complaint procedures. First, contact customer service for an explanation. If you are not satisfied with the explanation given, please submit your concern on our [appeal filing form](https://learn-mymoneybcbsvt.hellofurther.com/@api/deki/files/663/Appeal_Form_VT.pdf)  with any other documents, records or information that pertains to your request. Upon receipt of your request, we will provide you a full and fair review of your complaint and a written notice of our decision according to the timeframe found in your Plan documentation. \n\nIf you are a member of a group plan that is a subject to the Employee Retirement Income Security Act(ERISA), once you have exhausted our complaint/appeal process, you have the right to file suit in Federal Court under Section 502(a) of ERISA. \n',
          helpContentSlug: 'vermont-important-claim-information',
        },
      },
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3zsuMIWrPkDslrCG2Tq4xS',
          type: 'Entry',
          createdAt: '2021-06-21T21:06:19.590Z',
          updatedAt: '2023-09-18T16:29:26.492Z',
          publishedVersion: 9,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Capital Blue Important Claim Information',
          helpContent:
            '# Important Claim Processing Information\n\nFor hearing and speech impaired telephone access for benefits and claims information, please call 711. Provide the following member support number to the relay service: 877.293.7041.\n\nA claim that is incomplete or needs additional information to make an appropriate benefit determination is indicated by the denial/adjustment reason on the Explanation of Payment page. When we receive all necessary information, we will process your claim. \n\nWe use internal and external rules and guidelines to make and adverse benefit determination. You have the right to ask for any relevant documents, records, or other information used to process your claim. You may also ask for scientific or clinical judgment used if you claim was denied because it was determined to be experimental or not medically necessary. You can name a representative to ask for this information. Please note by law we cannot send copies of your protected health information to your representative without authorization granted via the [Capital BlueCross Member Portal](https://capitalbluecross.member.hellofurther.com/account-settings/release-authorizations). Please contact customer service to request any additional relevant documents. \n\n# Complaint/Appeal Information\n\nThe explanation of payment page explains how your claim was processed based on upon the information submitted to us. You or your designed representative may appeal a denial, partial denial, or reduction of your claim by following our complaint procedures. First, contact customer service for an explanation. If you are not satisfied with the explanation given, please submit your concern on our [appeal filing form](https://learn.hellofurther.com/@api/deki/files/513/SA-Appeal.pdf)  with any other documents, records or information that pertains to your request. Upon receipt of your request, we will provide you a full and fair review of your complaint and a written notice of our decision according to the timeframe found in your Plan documentation. \n\nIf you are a member of a group plan that is a subject to the Employee Retirement Income Security Act(ERISA), once you have exhausted our complaint/appeal process, you have the right to file suit in Federal Court under Section 502(a) of ERISA. \n',
          helpContentSlug: 'capital-blue-important-claim-information',
        },
      },
    },
  },
  'contact-us-fax': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '5eIgrbPd7iq6sIcsuwUueg',
      type: 'Entry',
      createdAt: '2018-03-13T17:21:04.531Z',
      updatedAt: '2021-06-27T16:14:56.448Z',
      publishedVersion: 7,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Contact Us - Fax',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '315pB5EarYYM8Ko8CKIcsI',
          type: 'Entry',
          createdAt: '2018-03-13T17:18:56.106Z',
          updatedAt: '2018-03-13T17:18:56.106Z',
          publishedVersion: 4,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Contact Us - Fax - Default',
          content: '(866) 231-0214\nor (651) 662-7247 (local)',
        },
      },
      contentAreaSlug: 'contact-us-fax',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '14qbASV127ms36ZbjE1FiR',
          type: 'Entry',
          createdAt: '2021-06-21T19:41:02.442Z',
          updatedAt: '2021-06-21T19:41:02.442Z',
          publishedVersion: 4,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Contact Us - Fax - Capital Blue',
          content: '866.231.0214\n',
        },
      },
    },
  },
  'contact-us-phone': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '1eDzVV3JJe0myiSC28ckcY',
      type: 'Entry',
      createdAt: '2018-03-13T17:19:18.841Z',
      updatedAt: '2021-06-27T16:14:26.259Z',
      publishedVersion: 24,
      revision: 8,
      locale: 'en-US',
    },
    fields: {
      description: 'Contact Us - Phone',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6IFk8oFFZKkSugsIyAw8AA',
          type: 'Entry',
          createdAt: '2018-03-13T17:17:10.175Z',
          updatedAt: '2018-03-13T17:17:10.175Z',
          publishedVersion: 15,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Contact Us - Phone - Default',
          content: '(800) 859-2144 (toll-free)\nor (651) 662-5065 (local)',
        },
      },
      contentAreaSlug: 'contact-us-phone',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '31cWO0oOdyoiccoEkQGuyo',
          type: 'Entry',
          createdAt: '2018-06-20T18:20:54.316Z',
          updatedAt: '2018-06-20T18:20:54.316Z',
          publishedVersion: 21,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Contact Us - Phone - CareFirst',
          content: '(866) 758-6119 (toll-free)',
        },
      },
      group_015273: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '31cWO0oOdyoiccoEkQGuyo',
          type: 'Entry',
          createdAt: '2018-06-20T18:20:54.316Z',
          updatedAt: '2018-06-20T18:20:54.316Z',
          publishedVersion: 21,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Contact Us - Phone - CareFirst',
          content: '(866) 758-6119 (toll-free)',
        },
      },
      dpc_bckc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6IFk8oFFZKkSugsIyAw8AA',
          type: 'Entry',
          createdAt: '2018-03-13T17:17:10.175Z',
          updatedAt: '2018-03-13T17:17:10.175Z',
          publishedVersion: 15,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Contact Us - Phone - Default',
          content: '(800) 859-2144 (toll-free)\nor (651) 662-5065 (local)',
        },
      },
      dpc_bcvt: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3TV0oyMqib4dTFJ4MiqHhj',
          type: 'Entry',
          createdAt: '2020-05-29T15:41:45.239Z',
          updatedAt: '2020-05-29T15:41:45.239Z',
          publishedVersion: 5,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Contact Us - Phone - Vermont',
          content: '866-999-2605',
        },
      },
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '46uXQhinNDkAUY9CLUOwHF',
          type: 'Entry',
          createdAt: '2021-06-21T19:37:58.425Z',
          updatedAt: '2021-06-21T19:37:58.425Z',
          publishedVersion: 4,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Contact Us - Phone - Capital Blue',
          content: '877.293.7041',
        },
      },
    },
  },
  'account-eligible-expenses-link': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '3HD4Bs6EHSqsuke8WiqyI8',
      type: 'Entry',
      createdAt: '2018-03-06T16:34:30.770Z',
      updatedAt: '2021-06-27T16:13:51.392Z',
      publishedVersion: 29,
      revision: 8,
      locale: 'en-US',
    },
    fields: {
      description: 'Account - Eligible Expenses Link',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3VVZJhvR7OuCsUW4ue0Mq4',
          type: 'Entry',
          createdAt: '2018-03-06T16:34:22.957Z',
          updatedAt: '2018-11-07T18:09:25.138Z',
          publishedVersion: 64,
          revision: 5,
          locale: 'en-US',
        },
        fields: {
          actionDescription: 'Eligible Expenses',
          actionNote: 'Further eligible expenses page link',
          actionValue:
            'link="https://learn.hellofurther.com/Individuals/Spending_Your_Account/Eligible_Expenses"',
        },
      },
      contentAreaSlug: 'account-eligible-expenses-link',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5QCquTbthmSU8A6AaeSSK2',
          type: 'Entry',
          createdAt: '2018-03-21T21:25:58.480Z',
          updatedAt: '2018-11-30T21:23:23.542Z',
          publishedVersion: 36,
          revision: 4,
          locale: 'en-US',
        },
        fields: {
          actionDescription: 'Eligible Expenses',
          actionNote: 'CareFirst eligible expenses page link',
          actionValue:
            'link="https://learn-carefirst.hellofurther.com/Individuals/Spending_Your_Account/Eligible_Expenses"',
        },
      },
      dpc_bchzn: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '52E2iC62tGawMkoCwO8OAc',
          type: 'Entry',
          createdAt: '2018-11-30T21:19:05.839Z',
          updatedAt: '2018-11-30T21:19:05.839Z',
          publishedVersion: 15,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          actionDescription: 'Eligible Expenses',
          actionNote: 'Horizon eligible expenses page link',
          actionValue:
            'link="https://learn-horizonmyway.hellofurther.com/Individuals/Spending_Your_Account/Eligible_Expenses"',
        },
      },
      group_600001: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5lQTV93XOMAG4OmeaM0m0G',
          type: 'Entry',
          createdAt: '2018-12-20T03:17:23.625Z',
          updatedAt: '2018-12-20T03:17:23.625Z',
          publishedVersion: 29,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          actionDescription: 'Merck Eligible Expenses',
          actionNote:
            'Link to Merck eligible expenses page on the Horizon site',
          actionValue:
            'link="https://www.horizonblue.com/merck-fsa/eligible-expenses"',
        },
      },
      dpc_bcvt: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4Him1j8Nb0ujPlz2vMuRuQ',
          type: 'Entry',
          createdAt: '2020-05-29T16:29:06.202Z',
          updatedAt: '2020-05-29T16:29:06.202Z',
          publishedVersion: 6,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          actionDescription: 'Eligible Expenses',
          actionNote: 'Vermont eligible expenses link',
          actionValue:
            'link="https://learn-mymoneybcbsvt.hellofurther.com/Individuals/Spending_Your_Account/Eligible_Expenses"',
        },
      },
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4eBUwPDINk7nKm8nVI7cZS',
          type: 'Entry',
          createdAt: '2021-06-21T18:03:53.720Z',
          updatedAt: '2021-06-21T18:03:53.720Z',
          publishedVersion: 5,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          actionDescription: 'Eligible Expenses',
          actionNote: 'Capital Blue eligible expenses link',
          actionValue:
            'link="https://learn-capitalbluecross.hellofurther.com/Individuals/Spending_Your_Account/Eligible_Expenses"',
        },
      },
    },
  },
  'tax-forms-sidebar-content': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '7tZd2dAsSIeckioig2I4OG',
      type: 'Entry',
      createdAt: '2018-12-12T17:22:53.628Z',
      updatedAt: '2021-06-27T16:13:27.078Z',
      publishedVersion: 22,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Tax Forms Sidebar Content',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '7jNUqziK4gaiOu2maWgmmI',
          type: 'Entry',
          createdAt: '2018-12-12T17:22:15.720Z',
          updatedAt: '2021-06-18T19:55:05.738Z',
          publishedVersion: 213,
          revision: 4,
          locale: 'en-US',
        },
        fields: {
          title: 'Default Tax Forms Sidebar',
          headline: 'Related',
          content:
            '[Learn: HSAs and Filing Your Taxes](link="https://learn.hellofurther.com/Individuals/Browse_by_Account/Health_Savings_Account_(HSA)/HSAs_and_Your_Taxes")\n[Learn: How Eligible Medical Expenses Work with Taxes](link="https://learn.hellofurther.com/Individuals/Spending_Your_Account/How_Eligible_Medical_Expenses_Work_with_Taxes")\n',
        },
      },
      contentAreaSlug: 'tax-forms-sidebar-content',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '2r7mSsA5WOJ7ESjlKdu6a8',
          type: 'Entry',
          createdAt: '2021-06-18T19:56:48.124Z',
          updatedAt: '2021-06-18T19:56:48.124Z',
          publishedVersion: 6,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Capital Blue Tax Forms Sidebar',
          headline: 'Related',
          content:
            '[Learn: HSAs and Filing Your Taxes](link="https://learn-capitalbluecross.hellofurther.com/Individuals/Browse_by_Account/Health_Savings_Account_(HSA)/HSAs_and_Your_Taxes")\n[Learn: How Eligible Medical Expenses Work with Taxes](link="https://learn-capitalbluecross.hellofurther.com/Individuals/Spending_Your_Account/How_Eligible_Medical_Expenses_Work_with_Taxes")\n',
        },
      },
    },
  },
  'statements-sidebar-content': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '209uMcwx9CM8ykCem2u2ca',
      type: 'Entry',
      createdAt: '2018-02-09T20:18:46.547Z',
      updatedAt: '2021-06-27T16:13:03.003Z',
      publishedVersion: 22,
      revision: 7,
      locale: 'en-US',
    },
    fields: {
      description: 'Statements Sidebar Content',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '24hMvtRzcQuaaug0oY6kCM',
          type: 'Entry',
          createdAt: '2018-02-09T15:49:22.277Z',
          updatedAt: '2021-03-12T14:29:00.926Z',
          publishedVersion: 695,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Default Statements Sidebar',
          headline: 'Related',
          content:
            '[See activity for this account](route="activity")\n\n[View your past or inactive accounts](route="inactiveAccounts")\n\n[Learn: HSA Interest Rates](link="https://learn.hellofurther.com/Individuals/Browse_by_Account/Health_Savings_Account_(HSA)/Choosing_an_HSA_Plan#Account_Credit_Rates")\n*Tip: Interest rates are determined by your balance and HSA plan type. To check your plan type, go to My Profile and select See All Settings.*\n\n[Learn: How Eligible Medical Expenses Work with Taxes](link="https://learn.hellofurther.com/Individuals/Spending_Your_Account/How_Eligible_Medical_Expenses_Work_with_Taxes")\n\n[Learn: When You Can Change Your Annual Election Amount](link="https://learn.hellofurther.com/Individuals/Life_Changes")\n',
        },
      },
      contentAreaSlug: 'statements-sidebar-content',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4tQzMkfyTSEGQGAgKU6W4U',
          type: 'Entry',
          createdAt: '2018-02-09T15:49:59.431Z',
          updatedAt: '2020-06-08T18:44:48.309Z',
          publishedVersion: 51,
          revision: 6,
          locale: 'en-US',
        },
        fields: {
          title: 'Group CareFirst Statements Sidebar',
          headline: 'Related',
          content:
            '[Learn: How Eligible Medical Expenses Work with Taxes](link="https://learn-carefirst.hellofurther.com/Individuals/Spending_Your_Account/How_Eligible_Medical_Expenses_Work_with_Taxes")\n\n[Learn: When You Can Change Your Yearly Contribution Amount](link="https://learn-carefirst.hellofurther.com/Individuals/Life_Changes")\n\n[View Your Past or Inactive Accounts](route="inactiveAccounts")',
        },
      },
      group_015273: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3gRQLqNLUcwsgY6ucqSgi0',
          type: 'Entry',
          createdAt: '2018-06-20T17:24:13.428Z',
          updatedAt: '2018-06-20T17:24:13.428Z',
          publishedVersion: 7,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Group Sodexo Statements Sidebar',
          headline: 'Related',
          content:
            '[View Your Past or Inactive Accounts](route="inactiveAccounts")',
        },
      },
      dpc_bchzn: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4WfhWq1kZqkaCgAcim0qIQ',
          type: 'Entry',
          createdAt: '2018-11-30T21:08:01.902Z',
          updatedAt: '2018-11-30T21:08:01.902Z',
          publishedVersion: 21,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Horizon Statements Sidebar',
          headline: 'Related',
          content:
            '[Learn: How Eligible Medical Expenses Work with Taxes](link="https://learn-horizonmyway.hellofurther.com/Individuals/Spending_Your_Account/How_Eligible_Medical_Expenses_Work_with_Taxes")\n\n[Learn: When You Can Change Your Yearly Contribution Amount](link="https://learn-horizonmyway.hellofurther.com/Individuals/Life_Changes")\n\n[View Your Past or Inactive Accounts](route="inactiveAccounts")',
        },
      },
      group_600001: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '365WyirlbawyMIwso24cm4',
          type: 'Entry',
          createdAt: '2018-12-20T03:31:50.023Z',
          updatedAt: '2018-12-20T03:31:50.023Z',
          publishedVersion: 8,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Merck Statements Sidebar',
          headline: 'Related',
          content:
            '[View Your Past or Inactive Accounts](route="inactiveAccounts")',
        },
      },
      dpc_bcvt: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'sH0Qb4LVpRJQqyOpAsxeJ',
          type: 'Entry',
          createdAt: '2020-05-29T15:49:23.127Z',
          updatedAt: '2020-05-29T15:49:23.127Z',
          publishedVersion: 5,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Vermont Statements Sidebar',
          headline: 'Related',
          content:
            '[Learn: How Eligible Medical Expenses Work with Taxes](link="https://learn-mymoneybcbsvt.hellofurther.com/Individuals/Spending_Your_Account/How_Eligible_Medical_Expenses_Work_with_Taxes")\n\n[Learn: When You Can Change Your Yearly Contribution Amount](link="https://learn-mymoneybcbsvt.hellofurther.com/Individuals/Life_Changes")\n\n[View Your Past or Inactive Accounts](route="inactiveAccounts")',
        },
      },
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1WPETk6tYCnHnuCweMN1lH',
          type: 'Entry',
          createdAt: '2021-06-18T19:49:59.549Z',
          updatedAt: '2021-06-18T19:49:59.549Z',
          publishedVersion: 8,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Capital Blue Statements Sidebar',
          headline: 'Related',
          content:
            '[See activity for this account](route="activity")\n\n[View your past or inactive accounts](route="inactiveAccounts")\n\n[Learn: HSA Interest Rates](link="https://learn-capitalbluecross.hellofurther.com/Individuals/Browse_by_Account/Health_Savings_Account_(HSA)/Choosing_an_HSA_Plan#Account_Credit_Rates")\n*Tip: Interest rates are determined by your balance and HSA plan type. To check your plan type, go to My Profile and select See All Settings.*\n\n[Learn: How Eligible Medical Expenses Work with Taxes](link="https://learn-capitalbluecross.hellofurther.com/Individuals/Spending_Your_Account/How_Eligible_Medical_Expenses_Work_with_Taxes")\n\n[Learn: When You Can Change Your Annual Election Amount](link="https://learn-capitalbluecross.hellofurther.com/Individuals/Life_Changes")',
        },
      },
    },
  },
  'login-content': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4EQbwXo8HC62EeUkUE2Qi6',
      type: 'Entry',
      createdAt: '2018-03-26T01:20:02.692Z',
      updatedAt: '2021-06-27T16:10:25.511Z',
      publishedVersion: 14,
      revision: 3,
      locale: 'en-US',
    },
    fields: {
      description: 'Login Content',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '41q94SYndYW8IOs2Kmyqw2',
          type: 'Entry',
          createdAt: '2018-03-26T01:19:49.093Z',
          updatedAt: '2021-03-25T12:31:02.832Z',
          publishedVersion: 437,
          revision: 6,
          locale: 'en-US',
        },
        fields: {
          title: 'Login Content - Default',
          content:
            "# Spend every day wisely\nFurther seamlessly connects health and finance to help people live healthier lives.\n\nOver thirty years ago, we set out to do it right. We built our health spending solutions from scratch and connected the pieces like no one else. Today and every day, we're committed to helping people seamlessly manage their money, health and life.",
        },
      },
      contentAreaSlug: 'login-content',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '25vRdHuE5qGmfgpdadAlJq',
          type: 'Entry',
          createdAt: '2021-03-08T21:40:45.283Z',
          updatedAt: '2021-03-08T21:40:45.283Z',
          publishedVersion: 4,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Login Page - CareFirst',
          content:
            '# Spend every day wisely\nHere is your secure home for all of your health savings and financial tools to make the most of your health care dollars.',
        },
      },
      dpc_bchzn: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '70cImwXkRf8tGB0IcLD7pw',
          type: 'Entry',
          createdAt: '2021-03-08T21:40:34.909Z',
          updatedAt: '2021-03-08T21:40:34.909Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Login Page - Horizon',
          content:
            '# Spend every day wisely\nHere is your secure home for all of your health savings and financial tools to make the most of your health care dollars.',
        },
      },
      dpc_bcvt: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3FG7JAjloasWlizy6mA9Sh',
          type: 'Entry',
          createdAt: '2021-03-08T21:40:24.773Z',
          updatedAt: '2021-03-08T21:40:24.773Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Login Page - Vermont',
          content:
            '# Spend every day wisely\nHere is your secure home for all of your health savings and financial tools to make the most of your health care dollars.',
        },
      },
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1YWqZmyJBjAzB7ESbei1x8',
          type: 'Entry',
          createdAt: '2021-06-18T19:32:35.920Z',
          updatedAt: '2021-06-18T19:32:35.920Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Login Page - CapBlue',
          content:
            '# Spend every day wisely\nHere is your secure home for all of your health savings and financial tools to make the most of your health care dollars.',
        },
      },
    },
  },
  'submit-hsa-application-need-help': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '1p2e8rPB8oGKoAI2WsWIyI',
      type: 'Entry',
      createdAt: '2018-02-21T19:51:03.358Z',
      updatedAt: '2021-06-22T02:05:55.824Z',
      publishedVersion: 9,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Submit HSA Application - Need Help',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6nBjYCzna0sYSu66oOUgww',
          type: 'Entry',
          createdAt: '2018-02-21T19:49:25.006Z',
          updatedAt: '2018-02-21T20:31:06.644Z',
          publishedVersion: 73,
          revision: 4,
          locale: 'en-US',
        },
        fields: {
          title: 'Submit HSA Application - Need Help - Default',
          content: 'Need help? Call [(800) 859-2144](tel:8008592144)',
        },
      },
      contentAreaSlug: 'submit-hsa-application-need-help',
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '7sjJ79cpzWrg1tbHCmAfxT',
          type: 'Entry',
          createdAt: '2021-06-22T02:05:17.115Z',
          updatedAt: '2021-06-22T02:05:17.115Z',
          publishedVersion: 4,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Submit HSA Application - Need Help - Capital Blue',
          content: 'Need help? Call [877.293.7041](tel:8772937041)',
        },
      },
    },
  },
  'make-a-deposit-tax-year-note-on-off-switch': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: 'O08BJuHKT4yzfc7klcaV2',
      type: 'Entry',
      createdAt: '2021-04-30T15:10:09.779Z',
      updatedAt: '2021-06-15T13:00:53.328Z',
      publishedVersion: 32,
      revision: 11,
      locale: 'en-US',
    },
    fields: {
      description: 'Make a Deposit Tax Year Note On/Off Switch',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3DNHX3E5A8q6qkJRcK0QZ0',
          type: 'Entry',
          createdAt: '2021-04-30T15:09:30.644Z',
          updatedAt: '2021-04-30T15:09:30.644Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          recordName: 'Hide Make a Deposit Tax Year Note',
          showhide: false,
        },
      },
      contentAreaSlug: 'make-a-deposit-tax-year-note-on-off-switch',
    },
  },
  'login-error-locked': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '7ogO5PJK4WTE5RPOgpJx4E',
      type: 'Entry',
      createdAt: '2021-05-27T18:57:13.244Z',
      updatedAt: '2021-05-27T18:57:13.244Z',
      publishedVersion: 9,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'login-error-locked',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5bDGygbYlpza08dmve36ME',
          type: 'Entry',
          createdAt: '2021-05-27T18:57:11.934Z',
          updatedAt: '2021-05-27T18:57:11.934Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'login-error-locked-default',
          content:
            'Your access has been locked due to too many failed login attempts. Please try again later or contact Employer Services at (888) 460-4013 for assistance.',
        },
      },
      contentAreaSlug: 'login-error-locked',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'Cg2X5GfjBHwfXzEMPeyBL',
          type: 'Entry',
          createdAt: '2021-05-27T18:57:11.724Z',
          updatedAt: '2021-05-27T18:57:11.724Z',
          publishedVersion: 5,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'login-error-locked-carefirst',
          content:
            'Your access has been locked due to too many failed login attempts. Please try again later or contact Employer Services at (866) 758-6119 for assistance.',
        },
      },
      dpc_bchzn: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '7bUIhYtxiPT2te8SYBDIV3',
          type: 'Entry',
          createdAt: '2021-05-27T18:57:11.712Z',
          updatedAt: '2021-05-27T18:57:11.712Z',
          publishedVersion: 5,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'login-error-locked-horizon',
          content:
            'Your access has been locked due to too many failed login attempts. Please try again later or contact Employer Services at (888) 215-0025 for assistance.',
        },
      },
      dpc_bcvt: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3S2sPv7WSgcVThYQziy4Nq',
          type: 'Entry',
          createdAt: '2021-05-27T18:57:13.238Z',
          updatedAt: '2021-05-27T18:57:13.238Z',
          publishedVersion: 6,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'login-error-locked-vermont',
          content:
            'Your access has been locked due to too many failed login attempts. Please try again later or contact Employer Services at (866) 999-2605 for assistance.',
        },
      },
    },
  },
  'login-error-disabled': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4WrH6RDofpkme7BNxmnGf1',
      type: 'Entry',
      createdAt: '2021-05-27T18:57:11.738Z',
      updatedAt: '2021-05-27T18:57:11.738Z',
      publishedVersion: 9,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'login-error-disabled',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6HPexBQdKdDJ0fyZvfnVAO',
          type: 'Entry',
          createdAt: '2021-05-27T18:57:31.830Z',
          updatedAt: '2021-05-27T18:57:31.830Z',
          publishedVersion: 6,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'login-error-disabled-default',
          content:
            'Your login has been disabled. Please [register again](https://group.int.hellofurther.com/portal/register) to gain online access.',
        },
      },
      contentAreaSlug: 'login-error-disabled',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4sfFx0OW5Q5UQhD0YHOlrB',
          type: 'Entry',
          createdAt: '2021-05-27T18:57:12.061Z',
          updatedAt: '2021-05-27T18:57:12.061Z',
          publishedVersion: 3,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'login-error-disabled-carefirst',
          content:
            'Your login has been disabled. Please [register again](https://group.int.hellofurther.com/portal/register) to gain online access.',
        },
      },
    },
  },
  'footer-information': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2GnJvZnHEQ8yiuO64EwuoO',
      type: 'Entry',
      createdAt: '2017-12-19T18:49:45.866Z',
      updatedAt: '2021-05-24T18:49:34.954Z',
      publishedVersion: 37,
      revision: 6,
      locale: 'en-US',
    },
    fields: {
      description: 'Footer Information',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'Dme2Y7O7TMiE4oYyaamwc',
          type: 'Entry',
          createdAt: '2017-12-19T18:48:10.777Z',
          updatedAt: '2021-03-05T20:16:40.999Z',
          publishedVersion: 59,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Further',
          companyDescription:
            'We are dedicated to evolving the connections between money, health, and life through our products, customer service, and education. We serve as an ally to help people use their dollars to pay for care wisely and avoid common pitfalls.',
          companyWebsite: 'https://www.hellofurther.com/',
          copyright: '© %currentYear% Further ',
        },
      },
      contentAreaSlug: 'footer-information',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4c4VB9vj6ggeSWO8uKESY2',
          type: 'Entry',
          createdAt: '2018-02-19T19:01:38.052Z',
          updatedAt: '2021-03-05T20:17:15.353Z',
          publishedVersion: 32,
          revision: 5,
          locale: 'en-US',
        },
        fields: {
          title: 'CareFirst',
          companyDescription:
            'CareFirst BlueCross BlueShield is a not-for-profit, non-stock health services company which, through its affiliates and subsidiaries, offers a comprehensive portfolio of products and administrative services to individuals and groups in Maryland, the District of Columbia and portions of Northern Virginia. CareFirst is the parent company of CareFirst of Maryland, Inc., and Group Hospitalization and Medical Services, Inc.',
          companyWebsite:
            'https://individual.carefirst.com/individuals-families/home.page',
          copyright: '© %currentYear% Further',
        },
      },
      dpc_bchzn: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'yvtj8ovWSWsQW68QksWmi',
          type: 'Entry',
          createdAt: '2018-11-30T20:23:19.544Z',
          updatedAt: '2021-03-05T20:17:31.508Z',
          publishedVersion: 90,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'Horizon',
          companyDescription:
            'Since 1932, Horizon BCBSNJ has offered quality health insurance products and services to New Jersey families and businesses.',
          companyWebsite: 'https://www.horizonblue.com/',
          copyright: '© %currentYear% Further',
        },
      },
      dpc_bcvt: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4gd2JfEpeX6TdobhzM6QFu',
          type: 'Entry',
          createdAt: '2020-06-02T15:28:33.852Z',
          updatedAt: '2021-06-27T11:32:08.114Z',
          publishedVersion: 13,
          revision: 4,
          locale: 'en-US',
        },
        fields: {
          title: 'Blue Cross Blue Shield of Vermont',
          companyDescription:
            'Blue Cross and Blue Shield of Vermont, an independent licensee of the Blue Cross and Blue Shield Association, is Vermont’s only local not-for-profit health plan. For over 70 years, we have been enhancing the health and well-being of Vermonters by offering innovative plans to individuals, seniors and businesses.  ',
          companyWebsite: 'https://www.bcbsvt.com/',
          copyright: '© %currentYear% Further',
        },
      },
      dpc_cbc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4F3ScyaBMrO0QvmASVCjnp',
          type: 'Entry',
          createdAt: '2021-05-20T20:48:19.674Z',
          updatedAt: '2021-06-27T16:08:13.061Z',
          publishedVersion: 13,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Capital Blue',
          companyDescription:
            'Our mission is to improve the health and well-being of our members and the communities in which they live.',
          companyWebsite: 'https://www.capbluecross.com/',
          copyright: '© %currentYear% Further',
        },
      },
    },
  },
  'make-deposit-tax-year-note': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2WKnxLwVIYv5il5GNsC6F3',
      type: 'Entry',
      createdAt: '2021-04-30T15:10:43.970Z',
      updatedAt: '2021-05-11T14:16:44.862Z',
      publishedVersion: 19,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Make Deposit Tax Year Note',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'OaOycKHGAtK5N5hMTOOBo',
          type: 'Entry',
          createdAt: '2021-04-30T15:09:30.643Z',
          updatedAt: '2021-05-05T19:37:01.935Z',
          publishedVersion: 15,
          revision: 5,
          locale: 'en-US',
        },
        fields: {
          headline: 'Make a Deposit Tax Year Note',
          content:
            'Members who file taxes in Louisiana, Oklahoma, or Texas and wish to apply a contribution to the 2020 tax year may do so by phone until June 15, 2021. Please call us at %groupTollFreePhone%.',
          type: 'Centered',
        },
      },
      contentAreaSlug: 'make-deposit-tax-year-note',
      notes:
        'This adds extra content to the Make Deposit screen. Originally built so we could add a note about the 2021 tax deadline extension for three states affected by the TX winter storms. ',
    },
  },
  t4: {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '1LbGHNUOzGQU6K0eCSuiA2',
      type: 'Entry',
      createdAt: '2018-02-17T19:14:24.815Z',
      updatedAt: '2020-06-01T19:46:25.262Z',
      publishedVersion: 11,
      revision: 4,
      locale: 'en-US',
    },
    fields: {
      description: 'T4',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '7ujBNIh9F6uUaqgEYKUa4g',
          type: 'Entry',
          createdAt: '2018-02-06T20:28:17.412Z',
          updatedAt: '2018-03-14T22:59:14.943Z',
          publishedVersion: 355,
          revision: 4,
          locale: 'en-US',
        },
        fields: {
          taskText:
            'We offer multiple HSA plan types. Review our plan credit rates to make sure you have the right plan.\n*Note: Some groups will pay the plan fee for their employees. Check with your employer or benefits administrator to make sure you switch plans.*\n',
        },
      },
      contentAreaSlug: 't4',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3G4cj8xqIU6UiSI8o8oYW2',
          type: 'Entry',
          createdAt: '2018-02-06T20:28:36.917Z',
          updatedAt: '2018-02-06T20:28:36.917Z',
          publishedVersion: 5,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          taskText:
            'We offer multiple HSA plan types. Review our plan credit rates to make sure you have the right plan.\n*Note: Some groups will pay the plan fee for their employees. Check with your employer or benefits administrator to make sure you switch plans.*\n',
        },
      },
      dpc_bchzn: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '15y3W66DouO2o2Ae0w06oi',
          type: 'Entry',
          createdAt: '2018-11-30T21:52:21.319Z',
          updatedAt: '2018-11-30T21:52:21.319Z',
          publishedVersion: 38,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          taskText:
            'Review our plan credit rate to understand how you can earn interest on your funds.\n',
        },
      },
      dpc_bcvt: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '2rC5uIoOedNygRXWoV6wZv',
          type: 'Entry',
          createdAt: '2020-06-01T19:46:19.565Z',
          updatedAt: '2020-06-01T19:46:19.565Z',
          publishedVersion: 4,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          taskText:
            'We offer multiple HSA plan types. Review our plan credit rates to make sure you have the right plan.\n*Note: Some groups will pay the plan fee for their employees. Check with your employer or benefits administrator to make sure you switch plans.*\n',
        },
      },
    },
  },
  t3: {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '6zgtLBFUruuIAS2q2UiSwe',
      type: 'Entry',
      createdAt: '2018-02-17T19:10:46.076Z',
      updatedAt: '2020-06-01T19:43:53.027Z',
      publishedVersion: 15,
      revision: 4,
      locale: 'en-US',
    },
    fields: {
      description: 'T3',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6Mi2PIKJnaWi2WmocgouoY',
          type: 'Entry',
          createdAt: '2018-02-06T18:52:21.833Z',
          updatedAt: '2018-02-06T18:53:00.618Z',
          publishedVersion: 239,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          taskText:
            "Start saving your receipts! There's no time limit for being reimbursed for out-of-pocket health expenses. Delaying reimbursements helps you save for non-health related expenses.",
        },
      },
      contentAreaSlug: 't3',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6r5DqJCCli66MGysgMCOGO',
          type: 'Entry',
          createdAt: '2018-02-06T18:53:20.339Z',
          updatedAt: '2018-03-14T22:57:48.761Z',
          publishedVersion: 24,
          revision: 4,
          locale: 'en-US',
        },
        fields: {
          taskText:
            "Start saving your receipts! There's no time limit for being reimbursed for out-of-pocket health expenses. Delaying reimbursements helps you save for non-health related expenses.",
        },
      },
      dpc_bchzn: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4vKMOEwENOuaQWQuIucOEc',
          type: 'Entry',
          createdAt: '2018-12-03T17:12:34.566Z',
          updatedAt: '2018-12-03T17:12:34.566Z',
          publishedVersion: 5,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          taskText:
            "Start saving your receipts! There's no time limit for being reimbursed for out-of-pocket health expenses. Delaying reimbursements helps you save for non-health related expenses.",
        },
      },
      dpc_bcvt: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'QWlLzipXXFJHuQlHWmzc0',
          type: 'Entry',
          createdAt: '2020-06-01T19:43:48.684Z',
          updatedAt: '2020-06-01T19:43:48.684Z',
          publishedVersion: 4,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          taskText:
            "Start saving your receipts! There's no time limit for being reimbursed for out-of-pocket health expenses. Delaying reimbursements helps you save for non-health related expenses.",
        },
      },
    },
  },
  t2: {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: 'xpgifuH2xiiMkgw6SWag4',
      type: 'Entry',
      createdAt: '2018-02-17T18:23:04.934Z',
      updatedAt: '2020-06-01T19:40:45.831Z',
      publishedVersion: 11,
      revision: 5,
      locale: 'en-US',
    },
    fields: {
      description: 'T2',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4LsgDqgPw4sKQygWAymcc6',
          type: 'Entry',
          createdAt: '2018-02-06T18:39:31.758Z',
          updatedAt: '2018-03-14T22:55:44.501Z',
          publishedVersion: 141,
          revision: 5,
          locale: 'en-US',
        },
        fields: {
          taskText:
            "It's not all about saving; you reap rewards every time you contribute to your HSA. ",
        },
      },
      contentAreaSlug: 't2',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5yhlpwtpzUoOScASAmqiKs',
          type: 'Entry',
          createdAt: '2018-02-06T18:45:28.057Z',
          updatedAt: '2018-02-06T18:45:28.057Z',
          publishedVersion: 5,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          taskText:
            "It's not all about saving; you reap rewards every time you contribute to your HSA. ",
        },
      },
      dpc_bchzn: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1KlODlIFo8oy2sy0GkYioK',
          type: 'Entry',
          createdAt: '2018-12-03T16:57:41.037Z',
          updatedAt: '2018-12-03T16:57:41.037Z',
          publishedVersion: 5,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          taskText:
            "It's not all about saving; you reap rewards every time you contribute to your HSA. ",
        },
      },
      dpc_bcvt: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3YtW7gZEyK1Y4hFp4JYLMV',
          type: 'Entry',
          createdAt: '2020-06-01T19:39:50.310Z',
          updatedAt: '2020-06-01T19:39:50.310Z',
          publishedVersion: 4,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          taskText:
            "It's not all about saving; you reap rewards every time you contribute to your HSA. ",
        },
      },
    },
  },
  t1: {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4Y7ifgfFVuOkYWuWWU6Uwg',
      type: 'Entry',
      createdAt: '2018-02-17T18:22:24.144Z',
      updatedAt: '2020-06-01T19:37:31.907Z',
      publishedVersion: 27,
      revision: 6,
      locale: 'en-US',
    },
    fields: {
      description: 'T1',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5Vv44VIfSgEAiAcmEKUIAi',
          type: 'Entry',
          createdAt: '2018-02-05T18:05:51.287Z',
          updatedAt: '2018-03-19T22:03:45.379Z',
          publishedVersion: 155,
          revision: 8,
          locale: 'en-US',
        },
        fields: { taskText: 'Review the basics of an HSA.' },
      },
      contentAreaSlug: 't1',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'hHWz206c3CQUaoQGU4ga0',
          type: 'Entry',
          createdAt: '2018-02-06T18:44:13.180Z',
          updatedAt: '2018-03-19T22:03:54.765Z',
          publishedVersion: 59,
          revision: 7,
          locale: 'en-US',
        },
        fields: { taskText: 'Review the basics of an HSA.' },
      },
      dpc_bchzn: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6F8Wxawox2QkeMuwC8y4E0',
          type: 'Entry',
          createdAt: '2018-11-30T21:49:30.213Z',
          updatedAt: '2018-11-30T21:49:30.213Z',
          publishedVersion: 5,
          revision: 1,
          locale: 'en-US',
        },
        fields: { taskText: 'Review the basics of an HSA.' },
      },
      dpc_bcvt: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '7fbNft65RyMwdLbWI5Zgub',
          type: 'Entry',
          createdAt: '2020-06-01T19:35:54.330Z',
          updatedAt: '2020-06-01T19:35:54.330Z',
          publishedVersion: 5,
          revision: 1,
          locale: 'en-US',
        },
        fields: { taskText: 'Review the basics of an HSA.' },
      },
    },
  },
  'bank-accounts-sidebar-content': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '5qebMnFrKEUUEo6qYkI6c6',
      type: 'Entry',
      createdAt: '2018-01-11T19:16:32.558Z',
      updatedAt: '2020-05-29T15:52:25.978Z',
      publishedVersion: 28,
      revision: 6,
      locale: 'en-US',
    },
    fields: {
      description: 'Bank Accounts Sidebar Content',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '286BmyIKA0ym8EkgMMooeM',
          type: 'Entry',
          createdAt: '2018-01-11T19:15:46.946Z',
          updatedAt: '2018-03-30T11:59:03.082Z',
          publishedVersion: 213,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Default Bank Accounts Sidebar',
          headline: 'Related',
          content:
            '[Make a Deposit](route="makeDepositDefault")\n\n[Get Reimbursed](route="submitClaimGetReimbursedDefault")\n\n[Learn: Direct HSA deposits from a paycheck](link="https://learn.hellofurther.com/Individuals/Contributing_Funds/Ways_to_Contribute_to_Your_HSA")',
        },
      },
      contentAreaSlug: 'bank-accounts-sidebar-content',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1OesmcDwo0Myci2QGeCSky',
          type: 'Entry',
          createdAt: '2018-02-09T15:27:51.587Z',
          updatedAt: '2020-08-11T15:44:17.741Z',
          publishedVersion: 81,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Group CareFirst Bank Accounts Sidebar',
          headline: 'Related',
          content:
            '[Learn: Setting up direct deposit for reimbursements](link="https://learn-carefirst.hellofurther.com/Individuals/Profile_and_Settings/Setting_Up_Direct_Deposit_for_Reimbursements")\n\n[Make a Deposit](route="makeDepositDefault")\n\n[Get Reimbursed](route="submitClaimGetReimbursedDefault)\n\n[Learn: Direct HSA deposits from a paycheck](link="https://learn-carefirst.hellofurther.com/Individuals/Contributing_Funds/Ways_to_Contribute_to_Your_HSA")',
        },
      },
      group_015273: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '9rbUqeHIJOEsuwckWYMSI',
          type: 'Entry',
          createdAt: '2018-06-20T17:30:57.472Z',
          updatedAt: '2018-06-20T17:30:57.472Z',
          publishedVersion: 13,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Group Sodexo Bank Accounts Sidebar',
          headline: 'Related',
          content: '[Get Reimbursed](route="submitClaimGetReimbursedDefault)',
        },
      },
      dpc_bchzn: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1W4stvwiUwcmsGcQyIi0q8',
          type: 'Entry',
          createdAt: '2018-11-30T21:09:50.255Z',
          updatedAt: '2018-12-20T03:29:18.031Z',
          publishedVersion: 31,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'Horizon Bank Accounts Sidebar',
          headline: 'Related',
          content:
            '[Make a Deposit](route="makeDepositDefault")\n\n[Get Reimbursed](route="submitClaimGetReimbursedDefault")\n\n[Learn: Direct HSA deposits from a paycheck](link="https://learn-horizonmyway.hellofurther.com/Individuals/Contributing_Funds/Ways_to_Contribute_to_Your_HSA")',
        },
      },
      group_600001: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '7o85nz4jHay880IwA2GIMU',
          type: 'Entry',
          createdAt: '2018-12-20T03:29:49.898Z',
          updatedAt: '2018-12-20T03:29:49.898Z',
          publishedVersion: 8,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Merck Bank Accounts Sidebar',
          headline: 'Related',
          content:
            '[Make a Deposit](route="makeDepositDefault")\n\n[Get Reimbursed](route="submitClaimGetReimbursedDefault")',
        },
      },
      dpc_bcvt: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5t2aEG8xqSyJKUdyWTcBca',
          type: 'Entry',
          createdAt: '2020-05-29T15:52:17.387Z',
          updatedAt: '2020-05-29T15:52:17.387Z',
          publishedVersion: 6,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Vermont Bank Accounts Sidebar',
          headline: 'Related',
          content:
            '[Learn: Setting up direct deposit for reimbursemnts](link="https://learn-mymoneybcbsvt.learn.hellofurther.com/Individuals/Profile_and_Settings/Setting_Up_Direct_Deposit_for_Reimbursements")\n\n[Make a Deposit](route="makeDepositDefault")\n\n[Get Reimbursed](route="submitClaimGetReimbursedDefault)\n\n[Learn: Direct HSA deposits from a paycheck](link="https://learn-mymoneybcbsvt.hellofurther.com/Individuals/Contributing_Funds/Ways_to_Contribute_to_Your_HSA")',
        },
      },
    },
  },
  'providers-sidebar-content': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2aasbw4AwUgWwSAy24IUai',
      type: 'Entry',
      createdAt: '2018-02-18T01:06:40.772Z',
      updatedAt: '2020-05-29T15:47:30.638Z',
      publishedVersion: 19,
      revision: 6,
      locale: 'en-US',
    },
    fields: {
      description: 'Providers Sidebar Content',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '27x1vsHC6kekQKsm8qOSmk',
          type: 'Entry',
          createdAt: '2018-02-18T01:06:12.055Z',
          updatedAt: '2018-03-27T16:00:47.729Z',
          publishedVersion: 89,
          revision: 4,
          locale: 'en-US',
        },
        fields: {
          title: 'Default Providers Sidebar',
          headline: 'Related',
          content:
            '[Learn: How to Pay a Provider](link="https://learn.hellofurther.com/Individuals/Spending_Your_Account/Paying_a_Provider")\n\n[Pay your provider](route="submitClaimPayBillDefault")\n\n[View your communicaton preferences](route="communications")\n\n',
        },
      },
      contentAreaSlug: 'providers-sidebar-content',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5UGU1WmSVGacQmQE8Kioee',
          type: 'Entry',
          createdAt: '2018-02-19T19:55:01.621Z',
          updatedAt: '2020-06-08T18:43:27.626Z',
          publishedVersion: 21,
          revision: 5,
          locale: 'en-US',
        },
        fields: {
          title: 'Group CareFirst Providers Sidebar',
          headline: 'Related',
          content:
            '[Pay your provider](route="submitClaimPayBillDefault")\n\n[View your communicaton preferences](route="communications")\n\n[Learn: How to Pay a Provider](link="https://learn-carefirst.hellofurther.com/Individuals/Spending_Your_Account/Paying_a_Provider")',
        },
      },
      group_015273: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4OMJXu4DXiEqqyAG4i0eUi',
          type: 'Entry',
          createdAt: '2018-06-20T17:27:44.595Z',
          updatedAt: '2018-06-20T17:27:44.595Z',
          publishedVersion: 7,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Group Sodexo Providers Sidebar',
          headline: 'Related',
          content:
            '[Pay your provider](route="submitClaimPayBillDefault")\n\n[View your communicaton preferences](route="communications")',
        },
      },
      dpc_bchzn: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6N3s3RllxCOOU6esI4E8am',
          type: 'Entry',
          createdAt: '2018-11-30T21:05:33.283Z',
          updatedAt: '2018-11-30T21:08:20.906Z',
          publishedVersion: 13,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Horizon Providers Sidebar',
          headline: 'Related',
          content:
            '[Learn: How to Pay a Provider](link="https://learn-horizonmyway.hellofurther.com/Individuals/Spending_Your_Account/Paying_a_Provider")\n\n[Pay your provider](route="submitClaimPayBillDefault")\n\n[View your communicaton preferences](route="communications")\n\n',
        },
      },
      group_600001: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6NC2K0vQ9UW8QGua84s4Y0',
          type: 'Entry',
          createdAt: '2018-12-20T03:31:24.553Z',
          updatedAt: '2018-12-20T03:31:24.553Z',
          publishedVersion: 7,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Merck Providers Sidebar',
          headline: 'Related',
          content:
            '[Pay your provider](route="submitClaimPayBillDefault")\n\n[View your communicaton preferences](route="communications")\n\n',
        },
      },
      dpc_bcvt: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '2tZjpIbNdyc7JzSyi3HYGV',
          type: 'Entry',
          createdAt: '2020-05-29T15:47:16.092Z',
          updatedAt: '2020-05-29T15:47:16.092Z',
          publishedVersion: 4,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Vermont Providers Sidebar',
          headline: 'Related',
          content:
            '[Learn: How to Pay a Provider](link="https://learn-mymoneybcbsvt.hellofurther.com/Individuals/Spending_Your_Account/Paying_a_Provider")\n\n[Pay your provider](route="submitClaimPayBillDefault")\n\n[View your communicaton preferences](route="communications")',
        },
      },
    },
  },
  'ari-sidebar-content': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '1WfPLr1KEsoA4eeCOsoYWC',
      type: 'Entry',
      createdAt: '2018-02-18T18:39:55.432Z',
      updatedAt: '2020-05-29T15:45:11.835Z',
      publishedVersion: 13,
      revision: 4,
      locale: 'en-US',
    },
    fields: {
      description: 'ARI Sidebar Content',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '24pPYEfTWYmIsgyKcq0o8C',
          type: 'Entry',
          createdAt: '2018-02-18T18:39:15.425Z',
          updatedAt: '2018-11-27T20:56:48.310Z',
          publishedVersion: 53,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'Default ARI Sidebar',
          headline: 'Related',
          content:
            '[Review or update your contact info](route="personalInformation")\n\n[View your communication preferences](route="communications")\n\n[Request a debit card for a dependent](route="paymentMethod")',
        },
      },
      contentAreaSlug: 'ari-sidebar-content',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5QChkZLLTaiQmeyycimiMK',
          type: 'Entry',
          createdAt: '2018-11-30T21:04:38.733Z',
          updatedAt: '2018-11-30T21:04:38.733Z',
          publishedVersion: 8,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'SSO Partner ARI Sidebar',
          headline: 'Related',
          content:
            '[Review your contact info](route="personalInformation")\n\n[View your communication preferences](route="communications")\n\n[Request a debit card for a dependent](route="paymentMethod")',
        },
      },
      dpc_bchzn: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5QChkZLLTaiQmeyycimiMK',
          type: 'Entry',
          createdAt: '2018-11-30T21:04:38.733Z',
          updatedAt: '2018-11-30T21:04:38.733Z',
          publishedVersion: 8,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'SSO Partner ARI Sidebar',
          headline: 'Related',
          content:
            '[Review your contact info](route="personalInformation")\n\n[View your communication preferences](route="communications")\n\n[Request a debit card for a dependent](route="paymentMethod")',
        },
      },
      dpc_bcvt: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5QChkZLLTaiQmeyycimiMK',
          type: 'Entry',
          createdAt: '2018-11-30T21:04:38.733Z',
          updatedAt: '2018-11-30T21:04:38.733Z',
          publishedVersion: 8,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'SSO Partner ARI Sidebar',
          headline: 'Related',
          content:
            '[Review your contact info](route="personalInformation")\n\n[View your communication preferences](route="communications")\n\n[Request a debit card for a dependent](route="paymentMethod")',
        },
      },
    },
  },
  'enrollment-election-step-help': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '7psWdAXdEvh8uRtm3WX8l8',
      type: 'Entry',
      createdAt: '2020-04-27T18:55:45.341Z',
      updatedAt: '2020-04-27T18:55:45.341Z',
      publishedVersion: 31,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Enrollment - Election Step - Help',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6UFy98xygSYEmqjqTGQ5rQ',
          type: 'Entry',
          createdAt: '2020-04-27T18:55:40.655Z',
          updatedAt: '2020-04-27T18:55:40.655Z',
          publishedVersion: 41,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Enrollment - Election Step - Help - Default',
          content:
            '# Plan Year Election Amount\n\nThis is the amount you will set aside this year in this account.\n\n%paycheckMessage%',
        },
      },
      contentAreaSlug: 'enrollment-election-step-help',
    },
  },
  'enrollment-dashboard-dcap-description': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '6sTPoVSpAqf4fm0BmdnUP0',
      type: 'Entry',
      createdAt: '2020-04-27T16:54:08.953Z',
      updatedAt: '2020-04-27T16:54:08.953Z',
      publishedVersion: 12,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Enrollment - Dashboard - DCAP - Description',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '7iKdzCGT8EGsgWZifJWhPT',
          type: 'Entry',
          createdAt: '2020-04-27T15:29:52.934Z',
          updatedAt: '2020-05-28T18:45:44.077Z',
          publishedVersion: 58,
          revision: 5,
          locale: 'en-US',
        },
        fields: {
          title: 'Enrollment - Dashboard - DCAP - Description - Default',
          content:
            '### %productName%\n\n- Set aside up to %annualMaxContribution% for dependent care expenses\n- This amount is taken in equal portions from your paychecks over the year\n- You can spend the funds as they build up\n- %rolloverText%\n- Pay for care for tax dependents 13 and younger, or elderly or disabled tax dependents with a letter of medical necessity\n\nMore information:\n- [Essential Guide](https://selectaccount-prod2.mindtouch.us/@api/deki/pages/=Brokers_and_Agents%252FProduct_Information%252FDependent_Care_Assistance_Program_%2528DCAP%2529_Materials/files/DCAP-Essential-Guide.pdf)',
        },
      },
      contentAreaSlug: 'enrollment-dashboard-dcap-description',
    },
  },
  'enrollment-dashboard-fsa-description': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: 'tt4UtwDclxsJWgyjjtu3F',
      type: 'Entry',
      createdAt: '2020-04-27T16:54:08.942Z',
      updatedAt: '2020-04-27T16:54:08.942Z',
      publishedVersion: 27,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Enrollment - Dashboard - FSA - Description',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5wF4LuEDI9Y5T8yyg7nKQh',
          type: 'Entry',
          createdAt: '2020-04-27T15:28:57.516Z',
          updatedAt: '2020-04-29T20:04:16.497Z',
          publishedVersion: 163,
          revision: 5,
          locale: 'en-US',
        },
        fields: {
          title: 'Enrollment - Dashboard - FSA - Description - Default',
          content:
            '### %productName%\n- Set aside up to %annualMaxContribution% this year for medical expenses\n- This amount is taken in equal portions from your paychecks over the year\n- You can spend the full amount as soon as the plan year starts\n- %rolloverText%\n- A debit card is included for making purchases\n\nMore information:\n- [Essential Guide](https://selectaccount-prod2.mindtouch.us/@api/deki/files/1028/FSA_Essential_Guide.pdf)\n- [Eligible expenses list](https://learn.hellofurther.com/Individuals/Spending_Your_Account/Eligible_Expenses)',
        },
      },
      contentAreaSlug: 'enrollment-dashboard-fsa-description',
    },
  },
  'enrollment-base-message': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4y7hk1MJfQVuorTkvzxrV3',
      type: 'Entry',
      createdAt: '2020-04-23T15:12:15.734Z',
      updatedAt: '2020-04-23T15:12:15.734Z',
      publishedVersion: 15,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Enrollment - Base Message',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '2cqdxpXWMsCgOlaMOHCE6f',
          type: 'Entry',
          createdAt: '2020-04-23T15:12:12.001Z',
          updatedAt: '2020-04-24T17:11:07.362Z',
          publishedVersion: 240,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'Enrollment - Base Message - Default',
          content:
            "Please use the link provided by your benefits administrator to access online enrollment. If the link didn't work, please let your benefits administator know.",
        },
      },
      contentAreaSlug: 'enrollment-base-message',
    },
  },
  'enrollment-dashboard-set-aside': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '6amyMZ3ojvnUTCIn3Yibyg',
      type: 'Entry',
      createdAt: '2020-04-21T20:33:53.253Z',
      updatedAt: '2020-04-21T20:33:53.253Z',
      publishedVersion: 33,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Enrollment - Dashboard - Set Aside',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3BHKhctQARtmYCd7IGqz0r',
          type: 'Entry',
          createdAt: '2020-04-21T20:33:49.010Z',
          updatedAt: '2020-04-24T20:18:37.672Z',
          publishedVersion: 39,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Enrollment - Dashboard - Set Aside - Default',
          content:
            '## Not sure how much to set aside?\n\nIf you already have a spending account with us, you can see how much you spent last year [on our portal](https://member.hellofurther.com/login).',
        },
      },
      contentAreaSlug: 'enrollment-dashboard-set-aside',
    },
  },
  'enrollment-dashboard-elections-saved': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '1mmhcIQ4ENC0NUGo44F7Kd',
      type: 'Entry',
      createdAt: '2020-04-17T19:30:58.574Z',
      updatedAt: '2020-04-17T19:30:58.574Z',
      publishedVersion: 23,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Enrollment - Dashboard - Elections Saved',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'w3ESi6l0UEDbDKUurIAqn',
          type: 'Entry',
          createdAt: '2020-04-17T19:30:53.681Z',
          updatedAt: '2020-04-24T20:30:23.029Z',
          publishedVersion: 64,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Enrollment - Dashboard - Elections Saved - Default',
          content:
            'Your benefit elections were saved. Please print this information for your records.\n\nYou can make changes until %deadlineDate%.',
        },
      },
      contentAreaSlug: 'enrollment-dashboard-elections-saved',
    },
  },
  'enrollment-logged-out-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '1UNgcVZ5tTlaVMub8xeakz',
      type: 'Entry',
      createdAt: '2020-04-17T16:31:23.417Z',
      updatedAt: '2020-04-17T16:31:23.417Z',
      publishedVersion: 24,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Enrollment - Logged Out - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1rRQ3Rlw0EX20JYT8QT5Ba',
          type: 'Entry',
          createdAt: '2020-04-17T16:31:18.746Z',
          updatedAt: '2020-04-17T17:10:09.585Z',
          publishedVersion: 11,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Enrollment - Logged Out - Success - Default',
          content:
            'You have exited the enrollment dashboard. Thanks for staying secure!',
        },
      },
      contentAreaSlug: 'enrollment-logged-out-success',
    },
  },
  'enrollment-logged-out-session-timeout': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '3oeP2LVBlXTSzFoFeE2SwK',
      type: 'Entry',
      createdAt: '2020-04-17T16:22:43.498Z',
      updatedAt: '2020-04-17T16:22:43.498Z',
      publishedVersion: 31,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Enrollment - Logged Out - Session Timeout',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4mN5n2dWBVGEJCtxKz6KZM',
          type: 'Entry',
          createdAt: '2020-04-17T16:22:23.431Z',
          updatedAt: '2020-04-17T16:22:23.431Z',
          publishedVersion: 37,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Enrollment - Logged Out - Session Timeout - Default',
          content:
            "We're sorry, but in order to keep your information secure, we have closed your enrollment session. Any information you did not submit was not saved.",
        },
      },
      contentAreaSlug: 'enrollment-logged-out-session-timeout',
    },
  },
  'enrollment-dcap-description': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '1hbI5ObN6O8WkKB3UwnZut',
      type: 'Entry',
      createdAt: '2020-04-14T20:58:42.212Z',
      updatedAt: '2020-04-14T20:58:42.212Z',
      publishedVersion: 25,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Enrollment - DCAP - Description',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '7eJ7XnGbQN7mOvPSHWHCqi',
          type: 'Entry',
          createdAt: '2020-04-14T20:58:37.141Z',
          updatedAt: '2021-04-30T18:22:09.344Z',
          publishedVersion: 390,
          revision: 9,
          locale: 'en-US',
        },
        fields: {
          title: 'Enrollment - DCAP - Description - Default',
          content:
            "### What is a %ProductName%?\nThis expense reimbursement account is for dependent care costs such as before or after school programs, child or adult day care, and summer camps to allow the participant to work. To qualify, care must be for tax dependents 13 and younger, or elderly or disabled tax dependents with a letter of medical necessity. Please note this account is not for medical costs for your dependents.\n\n### Things to know:\n- Set aside up to %annualMaxContribution% for dependent care expenses\n- You won't pay income tax on these funds\n- You can't make changes to your election amount mid-year, unless you have a qualifying life event (e.g., marriage, birth, divorce, unemployment, etc.)\n- %rolloverText%",
        },
      },
      contentAreaSlug: 'enrollment-dcap-description',
    },
  },
  'enrollment-fsa-description': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '6kubDIvDyCbn4EPohWbI8P',
      type: 'Entry',
      createdAt: '2020-04-14T20:34:39.862Z',
      updatedAt: '2020-04-14T20:34:39.862Z',
      publishedVersion: 26,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Enrollment - FSA - Description',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3qN6iIaGJm62RqJ8WgBnwJ',
          type: 'Entry',
          createdAt: '2020-04-14T20:34:34.966Z',
          updatedAt: '2020-04-29T19:56:17.025Z',
          publishedVersion: 148,
          revision: 11,
          locale: 'en-US',
        },
        fields: {
          title: 'Enrollment - FSA - Description - Default',
          content:
            '### %productName% Enrollment\n\nThis personal expense account is where you can set aside a portion of your salary pretax to pay for health costs not paid for by your health, vision, or dental plan.\n\n### Things to know:\n- Set aside up to %annualMaxContribution% this year for medical expenses\n- You won’t pay income tax on these funds\n- You can’t make changes to your election amount mid-year unless you have a qualifying life event (e.g., marriage, birth, divorce, unemployment, etc.)\n- %rolloverText%',
        },
      },
      contentAreaSlug: 'enrollment-fsa-description',
    },
  },
  'enrollment-dashboard-have-questions': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '3uH5p0E1YBDx5fakSrcGPQ',
      type: 'Entry',
      createdAt: '2020-04-14T20:10:39.261Z',
      updatedAt: '2020-04-14T20:10:39.261Z',
      publishedVersion: 22,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Enrollment - Dashboard - Have Questions',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '7FyPEHwJGb9lY2lTWd7WS9',
          type: 'Entry',
          createdAt: '2020-04-14T20:10:35.098Z',
          updatedAt: '2020-04-24T20:31:01.926Z',
          publishedVersion: 34,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Enrollment - Dashboard - Have Questions - Default',
          content: '## Have Questions?\n\nGet in touch at %phone%',
        },
      },
      contentAreaSlug: 'enrollment-dashboard-have-questions',
    },
  },
  'enrollment-dashboard-welcome': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '5DcIBaURhl3gEiIofpauHu',
      type: 'Entry',
      createdAt: '2020-04-14T20:09:23.986Z',
      updatedAt: '2020-04-14T20:09:23.986Z',
      publishedVersion: 16,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Enrollment - Dashboard - Welcome',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'UTD9vHe3vCnPi9FG62mFM',
          type: 'Entry',
          createdAt: '2020-04-14T20:06:51.848Z',
          updatedAt: '2020-04-14T20:06:51.848Z',
          publishedVersion: 23,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Enrollment - Dashboard - Welcome - Default',
          content:
            '## Ready to get started?\n\nFirst, you will tell us where to send your enrollment confirmation. Next, you will choose your benefits.',
        },
      },
      contentAreaSlug: 'enrollment-dashboard-welcome',
    },
  },
  'enrollment-contact-us-phone': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2LCxfoEUlMl7nRUuDogADx',
      type: 'Entry',
      createdAt: '2020-04-13T18:10:23.863Z',
      updatedAt: '2020-04-13T18:10:23.863Z',
      publishedVersion: 20,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Enrollment - Contact Us - Phone',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '22M5guSpgMeQw3V9O22vCw',
          type: 'Entry',
          createdAt: '2020-04-13T18:09:39.938Z',
          updatedAt: '2020-04-13T18:12:31.440Z',
          publishedVersion: 34,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Enrollment - Contact Us - Phone - Default',
          content: 'Phone: %phone%',
        },
      },
      contentAreaSlug: 'enrollment-contact-us-phone',
    },
  },
  'enrollment-welcome-banner': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2RcLXunCqtyx4kXLkpXwB8',
      type: 'Entry',
      createdAt: '2020-04-02T18:28:35.657Z',
      updatedAt: '2020-04-02T18:28:35.657Z',
      publishedVersion: 14,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Enrollment - Welcome Banner',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '36HBSveF3oZXDojraK1j8F',
          type: 'Entry',
          createdAt: '2020-04-02T18:27:55.301Z',
          updatedAt: '2020-04-02T18:28:24.023Z',
          publishedVersion: 50,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Enrollment - Welcome Banner - Default',
          content:
            '# %spendingAccountYear% Spending Account Enrollment\n    \nWelcome!',
        },
      },
      contentAreaSlug: 'enrollment-welcome-banner',
    },
  },
  'enrollment-have-questions-banner': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2HGCFg0yfGjl6VyBp2MBT3',
      type: 'Entry',
      createdAt: '2020-04-02T18:14:39.150Z',
      updatedAt: '2020-04-02T18:14:39.150Z',
      publishedVersion: 18,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Enrollment - Have Questions Banner',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '32eDgWj7cC5miER5Ilhap4',
          type: 'Entry',
          createdAt: '2020-04-02T18:14:33.067Z',
          updatedAt: '2020-04-02T18:14:33.067Z',
          publishedVersion: 43,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Enrollment - Have Questions Banner - Default',
          content: '### Have Questions?\n\nGet in touch at %planPhone%',
        },
      },
      contentAreaSlug: 'enrollment-have-questions-banner',
    },
  },
  'enrollment-get-started-banner': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '6TnDEr8TGMPOHa4X1WDp4N',
      type: 'Entry',
      createdAt: '2020-04-02T18:03:44.778Z',
      updatedAt: '2020-04-02T18:03:44.778Z',
      publishedVersion: 28,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Enrollment - Get Started Banner',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4WQvpgq9SiRWmcyh5bNcG8',
          type: 'Entry',
          createdAt: '2020-04-02T18:03:32.183Z',
          updatedAt: '2020-04-02T18:03:32.183Z',
          publishedVersion: 37,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Enrollment - Get Started Banner - Default',
          content:
            '## Ready to get started?\n\nFirst, you will tell us where to send your enrollment confirmation. Next, you will choose your benefits.',
        },
      },
      contentAreaSlug: 'enrollment-get-started-banner',
    },
  },
  'enrollment-login-screen': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '012YEVfxzdVU4zIsgER7pU',
      type: 'Entry',
      createdAt: '2020-04-02T14:39:24.721Z',
      updatedAt: '2020-04-02T14:39:24.721Z',
      publishedVersion: 17,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Enrollment - Login Screen',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5Lt7K4McNuKtlrpTlpK8SX',
          type: 'Entry',
          createdAt: '2020-04-01T19:27:53.948Z',
          updatedAt: '2020-04-13T17:24:04.746Z',
          publishedVersion: 50,
          revision: 6,
          locale: 'en-US',
        },
        fields: {
          title: 'Enrollment - Login Content - Default',
          content:
            '\n# Welcome to your Spending Account Enrollment\n\nThese benefits help you set aside tax-free funds for the care you need. To get started, enter some information to find your options, and then select which benefits you want.\n\nFor assistance call %planPhone%.',
        },
      },
      contentAreaSlug: 'enrollment-login-screen',
    },
  },
  'username-rules': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2WYt0bpsFq54Ch87VSzOOD',
      type: 'Entry',
      createdAt: '2020-02-14T14:11:54.388Z',
      updatedAt: '2020-02-14T14:11:54.388Z',
      publishedVersion: 8,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Username Rules',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '64fj225oVyS5KqXW2ieeMU',
          type: 'Entry',
          createdAt: '2020-02-14T14:11:25.484Z',
          updatedAt: '2020-02-14T14:11:25.484Z',
          publishedVersion: 45,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Username Rules',
          content:
            '__Your username:__ Must contain 6-14 letters, numbers, or symbols from the following list: ^ $ * . [ ] { } ( ) ? - " ! @ # % & / \\ , > < \' ; | _ ~ `',
        },
      },
      contentAreaSlug: 'username-rules',
    },
  },
  'privacy-policy-page-content': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: 'YQ9eoUEXgOYyyySakQWWk',
      type: 'Entry',
      createdAt: '2017-12-19T20:59:01.037Z',
      updatedAt: '2020-02-07T20:20:49.771Z',
      publishedVersion: 19,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Privacy Policy Page Content',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4Pz51eB8TYc6EsioqyMaks',
          type: 'Entry',
          createdAt: '2017-12-19T20:11:58.851Z',
          updatedAt: '2022-10-25T18:02:26.883Z',
          publishedVersion: 366,
          revision: 6,
          locale: 'en-US',
        },
        fields: {
          title: 'Privacy Policy',
          content:
            "## Notice of Privacy Practices\n\nEffective date: 29 March 2018\n\n### For Your Protection\nFurther is committed to providing you with best in class products and services.  As part of obtaining our products and services, we understand that you provide Further with personal, private information and we take this responsibility seriously. This notice is provided so that you will be aware of the measures we take to protect the privacy of your nonpublic personal information.  It also describes information we collect and how we use this information to conduct our business.  You should know that we are required by law to provide you this notice about our legal duties and privacy practices. We hope that this notice will clarify our responsibilities to you and provide you with a good understanding of your rights. This notice describes how your information may be used and disclosed, and how you can get access to this information. Please review this notice carefully.\n\n### How Further Safeguards Your Protected Health Information\nFurther Compliance has the overall responsibility to implement and enforce privacy policies and procedures to protect your protected health information. You can be assured that every effort is taken to comply with federal and state laws — physically, electronically and procedurally — to safeguard your information. In some situations, where state laws provide greater protection for your privacy, we will follow the provisions of that state law. Further requires all of its employees, business associates, providers and vendors to adhere to federal and state privacy laws. Following are descriptions of how your protected health information is handled throughout our administration of your personal spending account.\n\n### Permitted Handling of Protected Health Information\nAt Further, your protected health information is handled in a number of different ways as we administer your personal spending account. The following examples show you the various uses we are permitted by law to make without your authorization:\n\n__Treatment.__ We can use your health information and share it with professionals who are treating you. This may include information about your visits with health care providers related to your personal spending account claims.\n\n__Payment.__ We can use and disclose your health information as we pay for your health services. This may include information about your financial transactions with us, such as your personal spending account information, your account balance, fees, payments, withdrawals, deposits and payment history.\n\n__Additional uses and disclosures.__ In certain situations, the law permits us to use or disclose your protected health information without your authorization. Learn more.\n\n### Your Rights\nFurther would like you to know that you have additional rights regarding your protected health information. Your additional rights are described below:\n\n__Your right to request restrictions.__ You have the right to request restrictions on the way we handle your protected health information for treatment, payment or health care operations as described in the “Permitted handling of protected health information” section of this notice. The law, however, does not require us to agree to these restrictions. If we do agree to a restriction, we will send you a written confirmation and will not use or disclose your protected health information in violation of that restriction. If we don’t agree, we will notify you in writing.\n\n__Your right to confidential communications.__ We will make every effort to accommodate reasonable requests to communicate with you about your protected health information at an alternative location. For our records, we need your request in writing. It is important that you understand that any payment or payment information may be sent to the original address in our records.\n\n__Your right to access.__ You have the right to receive (or request that a designated person receive), by written request, a copy of your protected health information that is contained in a “designated record set,” (click the link for definition) with some specified exceptions. For example, if your doctor determines that your records are sensitive, we may not give you access to your records. You also have the right to request an electronic copy of protected health information that is maintained electronically.\n\n__Your right to amend your protected health information.__ You have the right to ask us to amend any protected health information that is contained in a “[designated record set.](https://www.hellofurther.com/privacy-policy-what-is-a-designated-record-set/)” (click the link for definition) For our records, your request for an amendment must be in writing. Further will not amend records in the following situations:\n\n- Further does not have the records you want amended\n- Further did not create the records that you want amended\n- Further has determined that the records are accurate and complete\n- The records have been compiled in anticipation of a civil, criminal or administrative action or proceeding\n- If you have requested an amendment under any of these situations, we will notify you in writing that we are denying your request. You have the right to file a written statement of disagreement with us, and we have the right to rebut that statement. Please note that changes of addresses are not required in writing.\n\n__Your right to information about certain disclosures.__ You have the right to request (in writing) information about any times we have disclosed your protected health information for any purpose other than the following exceptions:\n\n- Treatment, payment, or health care operations as described in the “Permitted handling of protected health information” section of this notice\n- Disclosures that you or your personal representative have authorized\n- Certain other disclosures, such as disclosures for military, national security, and presidential protective services purposes.\n\n__Your right to receive notifications of breaches of protected health information.__ In the event of any unauthorized acquisition, use or disclosure of your unsecured protected health information (a “breach”), Further will notify you of such breach, unless there is a low probability that your protected health information has been compromised.\n\n### What Other Personal Information Does Further Gather?\n__Information you give us:__ We receive and store any information you enter on our Web site or give us in any other way ([see examples of what we collect](https://www.hellofurther.com/privacy-policy-examples-of-other-personal-data-our-website-may-collect/)).  You can choose not to provide certain information, but then you might not be able to take advantage of many of our features. We use the information that you provide for such purposes as responding to your requests, improving our services, and communicating with you.\n\n__Automatic Information:__ We receive and store certain types of information whenever you interact with us.  We may also collect certain information your browser sends us, which is used to improve the content of our web services and help us understand how people are using our services. We analyze data generated by your visits to our website to continually improve the value of the materials and services available on our site. Data utilized in such analysis is not personally identifiable, and we make no attempt to link it with the individuals that browse our website. [Learn more](https://www.hellofurther.com/privacy-policy-personal-information-gathered-automatically-by-our-website/).\n\n__Mobile:__ When you download or use apps created by Further, we may receive information about your mobile device, including a unique identifier for your device.\n\n__E-mail Communications:__ We may utilize read-receipt notifications in our e-mail communications with you, as well as collect forwarding statistics from information you copy and paste from our website and send to others.\n\n### Cookies and Other Tracking Technologies\nCookies are unique data identifiers that are assigned to your browser by our web servers and are stored by your device. They enable our systems to recognize your device and to enable website features. We also use cookies for purposes such as maintaining continuity during an online session, gathering data about the use of our site, monitoring online promotions, and anti-fraud and information security purposes. We may also, from time to time, utilize additional technologies such as pixel tags, web beacons, script-based trackers, clear GIFs, and other similar techniques, and may permit our third party service providers to use these technologies. We use these technologies for purposes such as measuring the effectiveness of our advertisements or other communications, determining viewing and response rates, measuring technical performance of our sites and mobile apps, and determining which offers to present to you on our own or on third party sites. With selected business partners (for example, Amazon's FSA|HSA-eligible Store), we may also use tracking technologies for mapping of attribution or referral sources when you click on links that connect to offerings and programs made available in coordination with these partners.\n\nIf you wish to disable cookies, the Help feature on most browsers will tell you how to set configuration options for processing cookies, including disabling cookies altogether. By disabling cookies, be aware that you may also disable certain features and functions normally available when visiting our website.\n\n__Do Not Track disclosure:__ Industry standards are currently evolving and we may not separately respond to or take any action with respect to a “do not track” configuration set in your internet browser. [Click here to learn more](https://www.hellofurther.com/privacy-policy-do-not-track-disclosure/) about how Further complies with privacy laws and Do Not Track settings. Additional information about other methods to opt-out from tracking can be found at [http://www.aboutads.info/choices](http://www.aboutads.info/choices).\n\n### How Does Further Use the Information We Gather?\nWe may use and disclose other personal information gathered as described above unless restricted by this policy or by law; for example:\n\n- Customizing your experience on this website including managing and recording your preferences;\n- Marketing, product development, and research purposes;\n- Tracking resources and data accessed on the website;\n- Developing reports regarding website usage, activity, technical performance, and other statistics;\n- Assisting users experiencing website difficulties;\n- Enabling certain functions and tools on this website;\n- Tracking paths of visitors to this website and within this website.\n\nWe may share information with service providers with whom we work, such as data processors and companies that help us market products and services to you. When permitted or required by law, we may share information with additional third parties for purposes including response to legal process or law enforcement.\n\n### Remarketing\nFurther uses Google Analytics Remarketing to advertise online.  This means we may continue to show ads to visitors who have previously visited our website. Google remarketing helps us tailor ads that we think may be of interest to you. As always, we respect your privacy and do not collect any personally identifiable information through the use of Google’s remarketing system.\n\nFurther and third-party vendors, including Google, use first-party cookies (such as the Google Analytics cookie) and third-party cookies (such as the DoubleClick cookie) together to inform, optimize, and serve ads based on your past visits to our website. It could mean that we advertise to previous visitors who have completed a specific task on the website, for example, downloading a PDF document. We may also tailor advertising based on the specific product pages you viewed on the website. These ads may appear across the internet, including websites on the Google Display Network.\n\nYou may opt out of Google’s use of cookies by visiting [Google Ads Settings](http://www.google.com/settings/ads). You can also learn more about opting-out of [Google Analytics by using the Google Analytics Opt-outBrowser Add On](https://tools.google.com/dlpage/gaoptout/).\n\nOf course, any data collected will be used in accordance with our own privacy policy and Google’s privacy policy.\n\n### Children’s Privacy\nFurther does not knowingly collect personal information from individuals under the age of 13 without obtaining verifiable consent from their parents. We request that such individuals do not provide personal information through the services.\n\nFor more information about the Children’s Online Privacy Protection Act (COPPA), visit the FTC website: [http://www.ftc.gov](http://www.ftc.gov/).\n\n### Future Changes\nAlthough Further follows the privacy practices described in this notice, you should know that under certain circumstances these practices could change in the future. For example, if privacy laws change, we will change our practices to comply with the law. Should this occur:\n\n- We will post a new notice on our website (www.hellofurther.com) by the effective date of the new notice and will also provide a copy of the new notice, or information about the new notice and how to obtain the new notice, in our next annual mailing to members.\n- The changes will apply to all protected health information we have in our possession, including any information created or received before we change the notice.\n\n### Contact Us\nFor more information or to request a copy of this notice please visit [https://www.hellofurther.com](https://www.hellofurther.com) or call us at 1-800-859-2144.\n\nIf you think that your privacy rights may have been violated you may either:\n\n1. Call us at the number listed above\n2. File a written complaint with our privacy officer at the following address: Further Compliance, P.O. Box 14836 Lexington, KY 40511\n3. Contact the Minnesota Department of Commerce at (651) 296-2488 or call toll free at 1-800-657-3602\n4. Contact the Minnesota Department of Health at (651) 282-5600 or toll free 1-800-657-3916\n5. Notify the Secretary of the U.S. Department of Health and Human Services (HHS). Send your complaint to: Office for Civil Rights, U.S. Department of Health and Human Services, 233 N.Michigan Ave., Suite 240, Chicago,, IL 60601; Voice Phone (312) 886-2359 or Fax (312) 886-1807 or TDD (312) 353-5693\n6. Call the HSS Voice Hotline number at 1-800-368-101",
        },
      },
      contentAreaSlug: 'privacy-policy-page-content',
    },
  },
  'update-provider-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: 'qE9Kvg3pW8EMEKY8O68OE',
      type: 'Entry',
      createdAt: '2018-02-16T03:12:53.547Z',
      updatedAt: '2020-02-07T19:28:20.624Z',
      publishedVersion: 22,
      revision: 4,
      locale: 'en-US',
    },
    fields: {
      description: 'Update Provider - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '7yjANFMmXuii4EOa2iCCSS',
          type: 'Entry',
          createdAt: '2018-03-06T19:31:14.445Z',
          updatedAt: '2018-03-06T19:31:14.445Z',
          publishedVersion: 2,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Update Provider - Success - Default',
          content:
            '## Success!\nYou have updated the provider information for your account.',
        },
      },
      contentAreaSlug: 'update-provider-success',
    },
  },
  'contact-us_text_chat': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4oYvrAQiRK9JG8av34TCyS',
      type: 'Entry',
      createdAt: '2020-01-13T20:57:38.924Z',
      updatedAt: '2020-01-13T20:57:38.924Z',
      publishedVersion: 5,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'contact-us_text_chat',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '21Na7e2hNYpU4ahTJyK7WM',
          type: 'Entry',
          createdAt: '2020-01-10T22:21:43.632Z',
          updatedAt: '2020-01-10T22:21:43.632Z',
          publishedVersion: 10,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'contact-us_text_chat',
          helpContent:
            'Start chatting by clicking the __Chat with Further__ button at the bottom of the page.\n*Note: If an agent is not available at the moment, the button will not appear. If you like, you can try refreshing the page or come back later to see if an agent is available.*',
          helpContentSlug: 'contact-us_text_chat',
        },
      },
      contentAreaSlug: 'contact-us_text_chat',
    },
  },
  'contact-us-mail': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2iua820tRGEMMYUsmU688q',
      type: 'Entry',
      createdAt: '2018-03-13T17:20:36.220Z',
      updatedAt: '2019-01-10T20:22:27.776Z',
      publishedVersion: 6,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Contact Us - Mail',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '46UJdewuA0qqccG4uMkACQ',
          type: 'Entry',
          createdAt: '2018-03-13T17:18:15.797Z',
          updatedAt: '2022-10-25T18:02:27.166Z',
          publishedVersion: 54,
          revision: 9,
          locale: 'en-US',
        },
        fields: {
          title: 'Contact Us - Mail - Default',
          content: 'Further\nP.O. Box 14836\nLexington, KY 40511',
        },
      },
      contentAreaSlug: 'contact-us-mail',
      dpc_bckc: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '46UJdewuA0qqccG4uMkACQ',
          type: 'Entry',
          createdAt: '2018-03-13T17:18:15.797Z',
          updatedAt: '2022-10-25T18:02:27.166Z',
          publishedVersion: 54,
          revision: 9,
          locale: 'en-US',
        },
        fields: {
          title: 'Contact Us - Mail - Default',
          content: 'Further\nP.O. Box 14836\nLexington, KY 40511',
        },
      },
    },
  },
  t6: {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '7aH4S4IkakCkyQ8SccAWOU',
      type: 'Entry',
      createdAt: '2018-02-17T19:16:26.622Z',
      updatedAt: '2018-12-06T15:13:35.327Z',
      publishedVersion: 16,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'T6',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '12idZHk4hKocSeQyKWmUyg',
          type: 'Entry',
          createdAt: '2018-02-06T20:58:42.330Z',
          updatedAt: '2018-05-16T14:45:56.364Z',
          publishedVersion: 61,
          revision: 6,
          locale: 'en-US',
        },
        fields: {
          taskText:
            'Order any additional debit cards your family may need--additional cards are free!',
        },
      },
      contentAreaSlug: 't6',
    },
  },
  'claim-filing-deadline-information': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '3yx8doRiPuSQ6mouAsMkC2',
      type: 'Entry',
      createdAt: '2018-11-27T20:50:12.767Z',
      updatedAt: '2018-11-27T20:50:12.767Z',
      publishedVersion: 15,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Claim Filing Deadline Information',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'uCYPlOv7Q4KcCaGQiUc2A',
          type: 'Entry',
          createdAt: '2018-11-27T20:50:15.819Z',
          updatedAt: '2018-11-29T15:36:57.508Z',
          publishedVersion: 48,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Claim Filing Deadline Information',
          helpContent:
            "All requests for reimbursement or payment from this account must be made by this date. This date is determined by your group's rules around claims filing and may change if the account is terminated.",
          helpContentSlug: 'claim-filing-deadline-information',
        },
      },
      contentAreaSlug: 'claim-filing-deadline-information',
    },
  },
  'upload-document-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '6xdIC9Qaic4uEEU2I2w2km',
      type: 'Entry',
      createdAt: '2018-05-04T14:40:05.381Z',
      updatedAt: '2018-06-05T17:22:26.260Z',
      publishedVersion: 13,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Upload Document - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '7bN7EXxmAE2wIUQA6uyCWQ',
          type: 'Entry',
          createdAt: '2018-06-05T17:22:04.372Z',
          updatedAt: '2018-06-05T17:22:04.372Z',
          publishedVersion: 10,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Upload Document - Success - Default',
          content: '## Success!\nYour file was successfully uploaded.',
        },
      },
      contentAreaSlug: 'upload-document-success',
    },
  },
  'match-document-to-transaction-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '6EmFSqlWO4SKaCCcaKE0gE',
      type: 'Entry',
      createdAt: '2018-05-07T20:54:44.231Z',
      updatedAt: '2018-05-07T20:54:44.231Z',
      publishedVersion: 12,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Match Document To Transaction - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4mk370jMVG0E0c6CukcQI6',
          type: 'Entry',
          createdAt: '2018-05-07T20:54:17.788Z',
          updatedAt: '2018-05-07T20:54:17.788Z',
          publishedVersion: 30,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Match Document To Transaction - Success - Default',
          content:
            '## Success!\nYou have attached this document from the transaction. ',
        },
      },
      contentAreaSlug: 'match-document-to-transaction-success',
    },
  },
  'remove-document-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '6nfVEV4JAkGmy24EcMeq68',
      type: 'Entry',
      createdAt: '2018-05-07T17:19:59.143Z',
      updatedAt: '2018-05-07T17:19:59.143Z',
      publishedVersion: 6,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Remove Document - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'kEffYdkRagOgE4Q6kIesi',
          type: 'Entry',
          createdAt: '2018-05-07T17:19:38.667Z',
          updatedAt: '2019-06-14T18:25:09.195Z',
          publishedVersion: 31,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Remove Document - Success - Default',
          content:
            '## Success!\nYou have removed this document from your My Records and Receipts library. ',
        },
      },
      contentAreaSlug: 'remove-document-success',
    },
  },
  'upload-document-error-bad-file': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '152QYppTwmOaa8QOwuGAMe',
      type: 'Entry',
      createdAt: '2018-05-04T14:43:16.684Z',
      updatedAt: '2018-05-04T14:43:16.684Z',
      publishedVersion: 5,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Upload Document - Error Bad File',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'aag79QAVgcEmaYo6Iw8O2',
          type: 'Entry',
          createdAt: '2018-02-16T02:47:06.315Z',
          updatedAt: '2018-03-14T16:19:40.710Z',
          publishedVersion: 86,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'Attach Documents - Error Bad File - Default',
          content:
            "## Unable to read file\nWe're unable to read the file you uploaded. Please try again or contact Customer Service at %groupTollFreePhone% for assistance. ",
        },
      },
      contentAreaSlug: 'upload-document-error-bad-file',
    },
  },
  'upload-document-error-encrypted-pdf': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '5vBLVjZ4bu4gMkiMyAssGi',
      type: 'Entry',
      createdAt: '2018-05-04T14:42:28.223Z',
      updatedAt: '2018-05-04T14:42:28.223Z',
      publishedVersion: 8,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Upload Document - Error Encrypted PDF',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6bmbzLCxJScyqkyoAKwoaE',
          type: 'Entry',
          createdAt: '2018-02-16T02:46:41.657Z',
          updatedAt: '2018-03-13T18:18:04.773Z',
          publishedVersion: 114,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Attach Documents - Error Encrypted PDF - Default',
          content:
            "## File is a password-protected PDF\n\nWe couldn't read this PDF because it's password protected. Please upload a PDF that isn't password protected.",
        },
      },
      contentAreaSlug: 'upload-document-error-encrypted-pdf',
    },
  },
  'upload-document-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4xQRnYq0ZOk4keguuwgWAc',
      type: 'Entry',
      createdAt: '2018-05-04T14:41:19.135Z',
      updatedAt: '2018-05-04T14:41:19.135Z',
      publishedVersion: 5,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Upload Document - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '2uIZUYzYpCoe2OuWGQsEgo',
          type: 'Entry',
          createdAt: '2018-02-16T02:47:26.697Z',
          updatedAt: '2018-03-14T16:20:11.249Z',
          publishedVersion: 107,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'Attach Documents - Error - Default',
          content:
            '## Unable to save file\n\nWe are unable to save the file you uploaded at this time. Please try again or contact Customer Service at %groupTollFreePhone% for assistance.',
        },
      },
      contentAreaSlug: 'upload-document-error',
    },
  },
  'edit-document-detail-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '26BPxmjS92uqOQOAsAK8gO',
      type: 'Entry',
      createdAt: '2018-05-03T18:29:05.487Z',
      updatedAt: '2018-05-03T18:29:40.310Z',
      publishedVersion: 14,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Update Document Detail - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '7zgwgzhRGEs4iaqWwkEqMY',
          type: 'Entry',
          createdAt: '2018-05-03T18:25:01.788Z',
          updatedAt: '2018-05-29T21:52:50.698Z',
          publishedVersion: 60,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'Update Document Detail - Success - Default',
          content: '## Success!\nYour updates have been saved.',
        },
      },
      contentAreaSlug: 'edit-document-detail-success',
    },
  },
  'dcap-upload-documebnt': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '1atblbVy0maeK2KIkCeqWU',
      type: 'Entry',
      createdAt: '2018-04-30T15:13:03.298Z',
      updatedAt: '2018-04-30T15:13:09.323Z',
      publishedVersion: 15,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'DCAP Upload Document',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1qiPp1fR3eAcEquqeGUySI',
          type: 'Entry',
          createdAt: '2018-04-30T15:09:50.279Z',
          updatedAt: '2019-09-24T21:03:43.763Z',
          publishedVersion: 40,
          revision: 4,
          locale: 'en-US',
        },
        fields: {
          title: 'DCAP Upload Document',
          helpContent:
            'Documentation must include:\n\nA completed claim form signed by the provider or\nA receipt from the provider that includes:\n\n- Provider Name\n- Provider Address\n- Date(s) of Service\n- Amount Charged\n\nYou can attach multiple files in the following formats: JPG, PDF, TIFF, PNG, GIF, or BMP. The total upload size must be less than 5MB. ',
          helpContentSlug: 'dcap-upload-document',
        },
      },
      contentAreaSlug: 'dcap-upload-documebnt',
    },
  },
  'activate-hsa-welcome': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4Xl1twfaQUUoQG0o66sUyC',
      type: 'Entry',
      createdAt: '2018-02-13T17:42:30.412Z',
      updatedAt: '2018-04-24T15:21:19.634Z',
      publishedVersion: 14,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Activate HSA Welcome',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5QnjkGYSjKMuaiOiSyie6Q',
          type: 'Entry',
          createdAt: '2018-02-13T17:41:46.498Z',
          updatedAt: '2018-03-12T11:19:32.510Z',
          publishedVersion: 55,
          revision: 9,
          locale: 'en-US',
        },
        fields: {
          title: 'Activate HSA Welcome - Default',
          content:
            "## Hi %firstName%,\nLet's activate your account. Once your account is activated you will be able to do things like request a debit card, manage the money in your HSA, or get reimbursed for your eligible medical expenses.  ",
        },
      },
      contentAreaSlug: 'activate-hsa-welcome',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '20NuCpx8Gkio0s00EeEIOE',
          type: 'Entry',
          createdAt: '2018-04-24T15:21:04.045Z',
          updatedAt: '2021-04-05T14:19:11.948Z',
          publishedVersion: 14,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Activate HSA Welcome - CareFirst ',
          content:
            "## Welcome %firstName%,\nYou purchased a High-Deductible Health Plan that qualifies you for a Health Savings Account (HSA). An HSA is a tax-advantaged savings account you can use to pay for eligible medical expenses.\n\nOnce you activate your account, you will receive a debit card, can contribute money to your account, pay your claims, and be reimbursed for medical expenses. Now let's activate your account.",
        },
      },
    },
  },
  'submit-hsa-application-public-portal-link': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '1eg9W59JNC06mKweUoGKYO',
      type: 'Entry',
      createdAt: '2018-02-23T22:39:55.959Z',
      updatedAt: '2018-03-29T22:08:05.264Z',
      publishedVersion: 7,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Submit HSA Application - Public Portal Link',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'nDR9AcEIGyEIekWSAaGQ8',
          type: 'Entry',
          createdAt: '2017-09-27T20:41:56.230Z',
          updatedAt: '2018-11-30T21:44:58.539Z',
          publishedVersion: 44,
          revision: 7,
          locale: 'en-US',
        },
        fields: {
          actionDescription: 'SelectAccount Public Link',
          actionNote: 'Further public website link',
          actionValue: 'link="https://www.hellofurther.com/"',
        },
      },
      contentAreaSlug: 'submit-hsa-application-public-portal-link',
    },
  },
  'activate-hsa-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '5Z2l2t4pPi8oOY4s8YmKqS',
      type: 'Entry',
      createdAt: '2018-03-23T19:09:18.353Z',
      updatedAt: '2018-03-23T19:09:18.353Z',
      publishedVersion: 4,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Activate HSA - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4h62JrDTx6OyQkIq4G8wy2',
          type: 'Entry',
          createdAt: '2018-03-23T19:08:55.418Z',
          updatedAt: '2018-03-26T19:09:12.574Z',
          publishedVersion: 47,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'Activate HSA - Success - Default',
          content: '## HSA activated\nYour HSA is now active.',
        },
      },
      contentAreaSlug: 'activate-hsa-success',
    },
  },
  'activate-hsa-error-add-debit-card': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: 'LKTcSl82M8UCYuaIMEo8w',
      type: 'Entry',
      createdAt: '2018-03-23T16:49:13.992Z',
      updatedAt: '2018-03-23T16:49:13.992Z',
      publishedVersion: 7,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Activate HSA - Error - Add Debit Card',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4NRyys1te0A4WQqww0W2UO',
          type: 'Entry',
          createdAt: '2018-03-23T16:47:37.513Z',
          updatedAt: '2018-03-26T19:03:44.998Z',
          publishedVersion: 25,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'Activate HSA - Error - Add Debit Card - Default',
          content:
            '## Unable to add debit card\n\nWe are unable to add a debit card to your profile at this time. Please contact Customer Service at %groupTollFreePhone% for more information.',
        },
      },
      contentAreaSlug: 'activate-hsa-error-add-debit-card',
    },
  },
  'unauthorized-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '62LUYkZ27KOGoaKugMcWQO',
      type: 'Entry',
      createdAt: '2018-03-22T20:27:48.273Z',
      updatedAt: '2018-03-22T20:27:48.273Z',
      publishedVersion: 11,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Unauthorized Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4V0eCgczTOCCsQuUQc6Kce',
          type: 'Entry',
          createdAt: '2018-03-22T20:27:23.910Z',
          updatedAt: '2018-03-22T20:32:35.387Z',
          publishedVersion: 14,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Unauthorized - Error',
          content:
            '# Hello there.\nUnfortunately, we are unable to verify your credentials. You may not have access to this feature.',
        },
      },
      contentAreaSlug: 'unauthorized-error',
    },
  },
  'footer-link-security-policy': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: 'Tjh80jgys06oI4maGCaI0',
      type: 'Entry',
      createdAt: '2018-03-22T19:26:59.037Z',
      updatedAt: '2018-03-22T19:52:12.454Z',
      publishedVersion: 12,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Footer Link - Security Policy',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5LajYa7WesgOQ6IUyyY2C',
          type: 'Entry',
          createdAt: '2018-03-22T19:20:34.018Z',
          updatedAt: '2018-11-07T18:12:08.362Z',
          publishedVersion: 14,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          actionDescription: 'Security Policy - Default',
          actionNote: 'Security policy route',
          actionValue: 'route="securityPolicy"',
        },
      },
      contentAreaSlug: 'footer-link-security-policy',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'MZLJs1vt4Yy6smsgQiS4A',
          type: 'Entry',
          createdAt: '2018-03-22T19:51:53.763Z',
          updatedAt: '2018-11-07T18:17:36.545Z',
          publishedVersion: 20,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          actionDescription: 'Security Policy - CareFirst',
          actionNote: 'Security Policy - CareFirst link',
          actionValue: 'link="a"',
          hidden: true,
        },
      },
    },
  },
  'footer-link-privacy-policy': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: 'BpuuSjAnEyW8g0QSwii2e',
      type: 'Entry',
      createdAt: '2018-03-22T19:26:31.796Z',
      updatedAt: '2018-03-22T19:26:31.796Z',
      publishedVersion: 12,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Footer Link - Privacy Policy',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5XSTDw09Fe0MGWmyUKGuwK',
          type: 'Entry',
          createdAt: '2018-03-22T19:20:12.114Z',
          updatedAt: '2021-10-27T18:41:21.541Z',
          publishedVersion: 21,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          actionDescription: 'Privacy Policy - Default',
          actionNote: 'Privacy policy on public site',
          actionValue: 'link="https://hellofurther.com/privacy-policy/"',
        },
      },
      contentAreaSlug: 'footer-link-privacy-policy',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6LurYiz9WEUicES2m6K4Ao',
          type: 'Entry',
          createdAt: '2018-03-22T19:22:42.579Z',
          updatedAt: '2018-11-07T18:12:58.407Z',
          publishedVersion: 21,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          actionDescription: 'Privacy Policy - CareFirst',
          actionNote: 'CareFirst privacy link',
          actionValue:
            'link="https://member.carefirst.com/members/mandates-policies/members-privacy-policy.page"',
        },
      },
    },
  },
  'footer-link-legal-terms-of-use': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '55PboD7rtS2CeuUuiQsEem',
      type: 'Entry',
      createdAt: '2018-03-22T19:25:39.617Z',
      updatedAt: '2018-03-22T19:25:39.617Z',
      publishedVersion: 15,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Footer Link - Legal Terms of Use',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '2Fv9hhMThm4oc0K0Ey0YwA',
          type: 'Entry',
          createdAt: '2018-03-22T19:19:49.984Z',
          updatedAt: '2018-11-07T18:11:47.086Z',
          publishedVersion: 16,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          actionDescription: 'Legal Terms of Use - Default',
          actionNote: 'Legal terms route',
          actionValue: 'route="legalTermsOfUse"',
        },
      },
      contentAreaSlug: 'footer-link-legal-terms-of-use',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '68vJS3WNhekCaaIm4ackqq',
          type: 'Entry',
          createdAt: '2018-03-22T19:22:09.472Z',
          updatedAt: '2018-11-07T18:12:41.861Z',
          publishedVersion: 28,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          actionDescription: 'Legal Terms of Use - CareFirst',
          actionNote: 'Legal TOU link for CareFirst',
          actionValue:
            'link="https://member.carefirst.com/mos/#/pagecontent/home/%252Fmembers%252Fmandates-policies%252Fterms-of-use.page/Terms%20of%20Use"',
        },
      },
    },
  },
  'footer-link-non-discrimination': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4JJZygZYesgwK0uYAoiCU4',
      type: 'Entry',
      createdAt: '2018-03-22T19:24:59.609Z',
      updatedAt: '2018-03-22T19:24:59.609Z',
      publishedVersion: 18,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Footer Link - Non-Discrimination',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6Kd89TTnSEq0gMMuK6okWO',
          type: 'Entry',
          createdAt: '2018-03-22T19:19:19.686Z',
          updatedAt: '2018-11-07T18:11:21.317Z',
          publishedVersion: 38,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          actionDescription: 'Non-Discrimination - Default',
          actionNote: 'Non-Discrimination route',
          actionValue: 'route="nonDiscrimination"',
        },
      },
      contentAreaSlug: 'footer-link-non-discrimination',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6sepoNRzeoqg00iqwuoW4a',
          type: 'Entry',
          createdAt: '2018-03-22T19:21:46.311Z',
          updatedAt: '2020-02-18T15:23:53.200Z',
          publishedVersion: 32,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          actionDescription: 'Non-Discrimination - CareFirst',
          actionNote: 'CareFirst non-descrimination link',
          actionValue:
            'link="https://member.carefirst.com/members/mandates-policies/nondiscrimination-notice.page"',
        },
      },
    },
  },
  'distribution-reasons': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4qXnhbQw52ecAUy8Kkko6S',
      type: 'Entry',
      createdAt: '2018-03-21T02:44:39.327Z',
      updatedAt: '2018-03-21T02:44:39.327Z',
      publishedVersion: 12,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Distribution Reasons',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '52os4j1fIcESIgygamSeko',
          type: 'Entry',
          createdAt: '2017-11-01T17:16:49.690Z',
          updatedAt: '2018-03-09T12:52:40.567Z',
          publishedVersion: 162,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'Distribution Reasons',
          helpContent:
            '# Purpose of Reimbursement\n\n## Expense reimbursement \n\nChoose this option to request reimbursement for an eligible medical expense.  This option does not apply to excess contributions, death, disability, or a prohibited transaction. \n\n## Excess contribution removal\n\nChoose this option if you contributed more than the IRS annual limit and want to withdraw the excess money and any net income that you received as a result.  \n\n## Disability\n\nChoose this option if a disability prevents you from working and a doctor has determined the condition will last at least 12 months or lead to your death.  Disability distributions may be taxed as normal income.  \n\n## Prohibited Transaction\nparagraph\nChoose this option if you added funds to your account for a prohibited reason and need to take the money out to avoid penalties. \n',
          helpContentSlug: 'get-reimbursed-distribution-reasons',
        },
      },
      contentAreaSlug: 'distribution-reasons',
    },
  },
  'contribution-limits': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4qX4IvxdagEgqWass6oaag',
      type: 'Entry',
      createdAt: '2018-03-21T02:41:59.354Z',
      updatedAt: '2018-03-21T02:41:59.354Z',
      publishedVersion: 11,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Contribution Limits',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '475Pu60ukg4i4Goa26QguG',
          type: 'Entry',
          createdAt: '2017-09-30T23:04:53.495Z',
          updatedAt: '2024-02-20T19:40:57.777Z',
          publishedVersion: 165,
          revision: 13,
          locale: 'en-US',
        },
        fields: {
          title: 'Contribution Limits',
          helpContent:
            '# Current Contribution Limits\nThe table below displays the current HSA contribution limits.  Current contribution information can be found on the U.S. Department of Treasury website at [treas.gov.](https://treas.gov "treas.gov")\n\n| Year | Single    | Family    |\n|------|-----------|-----------|\n| 2024 | $4,150.00 | $8,300.00 |\n| 2023 | $3,850.00 | $7,750.00 |\n\nWhen you reach age 55, you can contribute an additional $1,000 each year through age 65 or until you enroll in Medicare. This is  called a catch-up contribution.',
          helpContentSlug: 'contributionLimits',
        },
      },
      contentAreaSlug: 'contribution-limits',
    },
  },
  'schwab-terms-and-conditions': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '3jHZx8Zy88GagE2WKs8aWS',
      type: 'Entry',
      createdAt: '2018-03-21T02:40:34.148Z',
      updatedAt: '2018-03-21T02:40:34.148Z',
      publishedVersion: 14,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Schwab Terms And Conditions',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4OwPcr95tCewIiUgICcWk0',
          type: 'Entry',
          createdAt: '2018-02-05T18:25:27.383Z',
          updatedAt: '2018-02-05T18:25:27.383Z',
          publishedVersion: 29,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Schwab Terms and Conditions',
          helpContent:
            'Aenean lacinia bibendum nulla sed consectetur. Aenean lacinia bibendum nulla sed consectetur. Donec id elit non mi porta gravida at eget metus. Donec ullamcorper nulla non metus auctor fringilla. Cras mattis consectetur purus sit amet fermentum.\n\nAenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Vestibulum id ligula porta felis euismod semper. Curabitur blandit tempus porttitor. Donec sed odio dui. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Donec ullamcorper nulla non metus auctor fringilla.\n\nPraesent commodo cursus magna, vel scelerisque nisl consectetur et. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec id elit non mi porta gravida at eget metus. Curabitur blandit tempus porttitor. Vestibulum id ligula porta felis euismod semper. Donec id elit non mi porta gravida at eget metus.\n\nFusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Nulla vitae elit libero, a pharetra augue. Nullam quis risus eget urna mollis ornare vel eu leo.',
          helpContentSlug: 'schwab-terms-and-conditions',
        },
      },
      contentAreaSlug: 'schwab-terms-and-conditions',
    },
  },
  'register-privacy-policy': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4dFi9L0VOM0oe0AeOgeyyW',
      type: 'Entry',
      createdAt: '2018-03-21T02:37:28.262Z',
      updatedAt: '2018-03-21T02:37:28.262Z',
      publishedVersion: 14,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Register Privacy Policy',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5vkGrIp4hqQKaIKwK6Wo2S',
          type: 'Entry',
          createdAt: '2017-11-02T14:14:33.451Z',
          updatedAt: '2022-10-25T18:02:26.929Z',
          publishedVersion: 44,
          revision: 7,
          locale: 'en-US',
        },
        fields: {
          title: 'Privacy Policy',
          helpContent:
            '## Notice of Privacy Practices\n\nEffective date: 29 March 2018\n\n### For Your Protection\nFurther is committed to providing you with best in class products and services.  As part of obtaining our products and services, we understand that you provide Further with personal, private information and we take this responsibility seriously. This notice is provided so that you will be aware of the measures we take to protect the privacy of your nonpublic personal information.  It also describes information we collect and how we use this information to conduct our business.  You should know that we are required by law to provide you this notice about our legal duties and privacy practices. We hope that this notice will clarify our responsibilities to you and provide you with a good understanding of your rights. This notice describes how your information may be used and disclosed, and how you can get access to this information. Please review this notice carefully.\n\n### How Further Safeguards Your Protected Health Information\nFurther Compliance has the overall responsibility to implement and enforce privacy policies and procedures to protect your protected health information. You can be assured that every effort is taken to comply with federal and state laws — physically, electronically and procedurally — to safeguard your information. In some situations, where state laws provide greater protection for your privacy, we will follow the provisions of that state law. Further requires all of its employees, business associates, providers and vendors to adhere to federal and state privacy laws. Following are descriptions of how your protected health information is handled throughout our administration of your personal spending account.\n\n### Permitted Handling of Protected Health Information\nAt Further, your protected health information is handled in a number of different ways as we administer your personal spending account. The following examples show you the various uses we are permitted by law to make without your authorization:\n\n__Treatment.__ We can use your health information and share it with professionals who are treating you. This may include information about your visits with health care providers related to your personal spending account claims.\n\n__Payment.__ We can use and disclose your health information as we pay for your health services. This may include information about your financial transactions with us, such as your personal spending account information, your account balance, fees, payments, withdrawals, deposits and payment history.\n\n__Additional uses and disclosures.__ In certain situations, the law permits us to use or disclose your protected health information without your authorization. Learn more.\n\n### Your Rights\nFurther would like you to know that you have additional rights regarding your protected health information. Your additional rights are described below:\n\n__Your right to request restrictions.__ You have the right to request restrictions on the way we handle your protected health information for treatment, payment or health care operations as described in the “Permitted handling of protected health information” section of this notice. The law, however, does not require us to agree to these restrictions. If we do agree to a restriction, we will send you a written confirmation and will not use or disclose your protected health information in violation of that restriction. If we don’t agree, we will notify you in writing.\n\n__Your right to confidential communications.__ We will make every effort to accommodate reasonable requests to communicate with you about your protected health information at an alternative location. For our records, we need your request in writing. It is important that you understand that any payment or payment information may be sent to the original address in our records.\n\n__Your right to access.__ You have the right to receive (or request that a designated person receive), by written request, a copy of your protected health information that is contained in a “designated record set,” (click the link for definition) with some specified exceptions. For example, if your doctor determines that your records are sensitive, we may not give you access to your records. You also have the right to request an electronic copy of protected health information that is maintained electronically.\n\n__Your right to amend your protected health information.__ You have the right to ask us to amend any protected health information that is contained in a “[designated record set.](https://www.hellofurther.com/privacy-policy-what-is-a-designated-record-set/)” (click the link for definition) For our records, your request for an amendment must be in writing. Further will not amend records in the following situations:\n\n- Further does not have the records you want amended\n- Further did not create the records that you want amended\n- Further has determined that the records are accurate and complete\n- The records have been compiled in anticipation of a civil, criminal or administrative action or proceeding\n- If you have requested an amendment under any of these situations, we will notify you in writing that we are denying your request. You have the right to file a written statement of disagreement with us, and we have the right to rebut that statement. Please note that changes of addresses are not required in writing.\n\n__Your right to information about certain disclosures.__ You have the right to request (in writing) information about any times we have disclosed your protected health information for any purpose other than the following exceptions:\n\n- Treatment, payment, or health care operations as described in the “Permitted handling of protected health information” section of this notice\n- Disclosures that you or your personal representative have authorized\n- Certain other disclosures, such as disclosures for military, national security, and presidential protective services purposes.\n\n__Your right to receive notifications of breaches of protected health information.__ In the event of any unauthorized acquisition, use or disclosure of your unsecured protected health information (a “breach”), Further will notify you of such breach, unless there is a low probability that your protected health information has been compromised.\n\n### What Other Personal Information Does Further Gather?\n__Information you give us:__ We receive and store any information you enter on our Web site or give us in any other way ([see examples of what we collect](https://www.hellofurther.com/privacy-policy-examples-of-other-personal-data-our-website-may-collect/)).  You can choose not to provide certain information, but then you might not be able to take advantage of many of our features. We use the information that you provide for such purposes as responding to your requests, improving our services, and communicating with you.\n\n__Automatic Information:__ We receive and store certain types of information whenever you interact with us.  We may also collect certain information your browser sends us, which is used to improve the content of our web services and help us understand how people are using our services. We analyze data generated by your visits to our website to continually improve the value of the materials and services available on our site. Data utilized in such analysis is not personally identifiable, and we make no attempt to link it with the individuals that browse our website. [Learn more](https://www.hellofurther.com/privacy-policy-personal-information-gathered-automatically-by-our-website/).\n\n__Mobile:__ When you download or use apps created by Further, we may receive information about your mobile device, including a unique identifier for your device.\n\n__E-mail Communications:__ We may utilize read-receipt notifications in our e-mail communications with you, as well as collect forwarding statistics from information you copy and paste from our website and send to others.\n\n### Cookies and Other Tracking Technologies\nCookies are unique data identifiers that are assigned to your browser by our web servers and are stored by your device. They enable our systems to recognize your device and to enable website features. We also use cookies for purposes such as maintaining continuity during an online session, gathering data about the use of our site, monitoring online promotions, and anti-fraud and information security purposes. We may also, from time to time, utilize additional technologies such as pixel tags, web beacons, script-based trackers, clear GIFs, and other similar techniques, and may permit our third party service providers to use these technologies. We use these technologies for purposes such as measuring the effectiveness of our advertisements or other communications, determining viewing and response rates, measuring technical performance of our sites and mobile apps, and determining which offers to present to you on our own or on third party sites.\n\nIf you wish to disable cookies, the Help feature on most browsers will tell you how to set configuration options for processing cookies, including disabling cookies altogether. By disabling cookies, be aware that you may also disable certain features and functions normally available when visiting our website.\n\n__Do Not Track disclosure:__ Industry standards are currently evolving and we may not separately respond to or take any action with respect to a “do not track” configuration set in your internet browser. [Click here to learn more](https://www.hellofurther.com/privacy-policy-do-not-track-disclosure/) about how Further complies with privacy laws and Do Not Track settings. Additional information about other methods to opt-out from tracking can be found at [http://www.aboutads.info/choices](http://www.aboutads.info/choices).\n\n### How Does Further Use the Information We Gather?\nWe may use and disclose other personal information gathered as described above unless restricted by this policy or by law; for example:\n\n- Customizing your experience on this website including managing and recording your preferences;\n- Marketing, product development, and research purposes;\n- Tracking resources and data accessed on the website;\n- Developing reports regarding website usage, activity, technical performance, and other statistics;\n- Assisting users experiencing website difficulties;\n- Enabling certain functions and tools on this website;\n- Tracking paths of visitors to this website and within this website.\n\nWe may share information with service providers with whom we work, such as data processors and companies that help us market products and services to you. When permitted or required by law, we may share information with additional third parties for purposes including response to legal process or law enforcement.\n\n### Remarketing\nFurther uses Google Analytics Remarketing to advertise online.  This means we may continue to show ads to visitors who have previously visited our website. Google remarketing helps us tailor ads that we think may be of interest to you. As always, we respect your privacy and do not collect any personally identifiable information through the use of Google’s remarketing system.\n\nFurther and third-party vendors, including Google, use first-party cookies (such as the Google Analytics cookie) and third-party cookies (such as the DoubleClick cookie) together to inform, optimize, and serve ads based on your past visits to our website. It could mean that we advertise to previous visitors who have completed a specific task on the website, for example, downloading a PDF document. We may also tailor advertising based on the specific product pages you viewed on the website. These ads may appear across the internet, including websites on the Google Display Network.\n\nYou may opt out of Google’s use of cookies by visiting [Google Ads Settings](http://www.google.com/settings/ads). You can also learn more about opting-out of [Google Analytics by using the Google Analytics Opt-outBrowser Add On](https://tools.google.com/dlpage/gaoptout/).\n\nOf course, any data collected will be used in accordance with our own privacy policy and Google’s privacy policy.\n\n### Children’s Privacy\nFurther does not knowingly collect personal information from individuals under the age of 13 without obtaining verifiable consent from their parents. We request that such individuals do not provide personal information through the services.\n\nFor more information about the Children’s Online Privacy Protection Act (COPPA), visit the FTC website: [http://www.ftc.gov](http://www.ftc.gov/).\n\n### Future Changes\nAlthough Further follows the privacy practices described in this notice, you should know that under certain circumstances these practices could change in the future. For example, if privacy laws change, we will change our practices to comply with the law. Should this occur:\n\n- We will post a new notice on our website (www.hellofurther.com) by the effective date of the new notice and will also provide a copy of the new notice, or information about the new notice and how to obtain the new notice, in our next annual mailing to members.\n- The changes will apply to all protected health information we have in our possession, including any information created or received before we change the notice.\n\n### Contact Us\nFor more information or to request a copy of this notice please visit [https://www.hellofurther.com](https://www.hellofurther.com) or call us at 1-800-859-2144.\n\nIf you think that your privacy rights may have been violated you may either:\n\n1. Call us at the number listed above\n2. File a written complaint with our privacy officer at the following address: Further Compliance, P.O. Box 14836 Lexington, KY 40511\n3. Contact the Minnesota Department of Commerce at (651) 296-2488 or call toll free at 1-800-657-3602\n4. Contact the Minnesota Department of Health at (651) 282-5600 or toll free 1-800-657-3916\n5. Notify the Secretary of the U.S. Department of Health and Human Services (HHS). Send your complaint to: Office for Civil Rights, U.S. Department of Health and Human Services, 233 N.Michigan Ave., Suite 240, Chicago,, IL 60601; Voice Phone (312) 886-2359 or Fax (312) 886-1807 or TDD (312) 353-5693\n6. Call the HSS Voice Hotline number at 1-800-368-101',
          helpContentSlug: 'privacy-policy',
        },
      },
      contentAreaSlug: 'register-privacy-policy',
    },
  },
  'need-help-link-list-fallback': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2Tu620XCnKWqAo4qssUwA0',
      type: 'Entry',
      createdAt: '2018-03-19T19:02:38.997Z',
      updatedAt: '2018-03-19T19:02:38.997Z',
      publishedVersion: 8,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Need Help Link List - Fallback',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6nUZLPjoreKSI82kieUw8k',
          type: 'Entry',
          createdAt: '2018-03-19T19:02:13.348Z',
          updatedAt: '2018-04-04T19:40:25.150Z',
          publishedVersion: 24,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Need Help Information - Fallback',
          headline: 'Need Help?',
          content:
            '- Call [(800) 859-2144](tel:800-859-2144)\n- Monday thru Thursday 8 AM to 8 PM, Friday 9 AM to 4:30 PM (Central)\n- [customersolutions@hellofurther.com](mailto:customersolutions@hellofurther.com)',
        },
      },
      contentAreaSlug: 'need-help-link-list-fallback',
    },
  },
  t7: {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2UoAl7nRwcGOyeQCwaqAGu',
      type: 'Entry',
      createdAt: '2018-02-17T19:17:56.288Z',
      updatedAt: '2018-03-14T23:03:30.703Z',
      publishedVersion: 11,
      revision: 4,
      locale: 'en-US',
    },
    fields: {
      description: 'T7',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'byoYZ1b26cUgeuqEMQiOk',
          type: 'Entry',
          createdAt: '2018-03-14T15:17:44.280Z',
          updatedAt: '2019-10-31T14:37:10.137Z',
          publishedVersion: 42,
          revision: 9,
          locale: 'en-US',
        },
        fields: {
          taskText:
            'Order a debit card for yourself, a convenient and widely-accepted way to pay for medical expenses with your HSA.  ',
        },
      },
      contentAreaSlug: 't7',
    },
  },
  t5: {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2Yi2ynoeDCWSWYIwWQCWm8',
      type: 'Entry',
      createdAt: '2018-02-17T19:15:14.995Z',
      updatedAt: '2018-03-14T23:00:46.521Z',
      publishedVersion: 9,
      revision: 3,
      locale: 'en-US',
    },
    fields: {
      description: 'T5',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3OfWallYTCs68KkUmGIgiE',
          type: 'Entry',
          createdAt: '2018-02-06T20:54:37.213Z',
          updatedAt: '2018-03-14T15:55:49.107Z',
          publishedVersion: 87,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          taskText:
            'Make sure you have bank accounts set up for receiving reimbursement money from your HSA!',
        },
      },
      contentAreaSlug: 't5',
    },
  },
  'header-logo': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '8sksuOB27uw4Ick4II6Mc',
      type: 'Entry',
      createdAt: '2018-02-20T18:29:24.857Z',
      updatedAt: '2018-03-14T21:35:14.685Z',
      publishedVersion: 16,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Header Logo',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6Lx61kifNCsYKQsE0Uq8qQ',
          type: 'Entry',
          createdAt: '2018-02-20T18:28:06.121Z',
          updatedAt: '2018-02-20T18:28:49.878Z',
          publishedVersion: 9,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          logo: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '6uT4Jaq0Rqa4MS0KY8qkWc',
              type: 'Asset',
              createdAt: '2018-02-20T18:26:01.082Z',
              updatedAt: '2018-02-20T18:26:01.082Z',
              publishedVersion: 6,
              revision: 1,
              locale: 'en-US',
            },
            fields: {
              title: 'Further',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/6uT4Jaq0Rqa4MS0KY8qkWc/01e9f94845b17f47998c9547598c8d09/logo_white.svg',
                details: { size: 8552, image: { width: 339, height: 93 } },
                fileName: 'logo_white.svg',
                contentType: 'image/svg+xml',
              },
            },
          },
          name: 'Further Logo',
        },
      },
      contentAreaSlug: 'header-logo',
      dpc_bccf: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4Ap3PejCr6AU8wGosSQcui',
          type: 'Entry',
          createdAt: '2018-02-20T18:29:07.841Z',
          updatedAt: '2018-02-20T18:29:07.841Z',
          publishedVersion: 5,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          logo: {
            metadata: { tags: [], concepts: [] },
            sys: {
              id: '4zj1ZOfHgQ8oqgaSKm4Qo2',
              type: 'Asset',
              createdAt: '2017-08-07T19:37:10.776Z',
              updatedAt: '2017-08-07T19:37:10.776Z',
              publishedVersion: 2,
              revision: 1,
              locale: 'en-US',
            },
            fields: {
              title: 'Playsam',
              description: 'Brand logo',
              file: {
                url:
                  '//images.ctfassets.net/inbvug17h4y2/4zj1ZOfHgQ8oqgaSKm4Qo2/f052f2a2fd70ff20b972acc44dd60aaa/playsam.jpg',
                details: { size: 7003, image: { width: 100, height: 100 } },
                fileName: 'playsam.jpg',
                contentType: 'image/jpeg',
              },
            },
          },
          name: 'PlaySam',
        },
      },
    },
  },
  'contact-us-email': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2vu5fQwyfW8kcqqY0WMEQi',
      type: 'Entry',
      createdAt: '2018-03-13T17:20:48.567Z',
      updatedAt: '2018-03-13T17:20:48.567Z',
      publishedVersion: 5,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Contact Us - Email',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '2gK7DUnULOUEmUokYOEiOw',
          type: 'Entry',
          createdAt: '2018-03-13T17:18:41.484Z',
          updatedAt: '2018-04-04T19:39:42.597Z',
          publishedVersion: 19,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Contact Us - Email - Default',
          content:
            '[customersolutions@hellofurther.com](mailto:customersolutions@hellofurther.com)',
        },
      },
      contentAreaSlug: 'contact-us-email',
    },
  },
  'contact-us-hours': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2PrVWonyTu4QqmOY8Woa2Q',
      type: 'Entry',
      createdAt: '2018-03-13T17:20:26.026Z',
      updatedAt: '2018-03-13T17:20:26.026Z',
      publishedVersion: 5,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Contact Us - Hours',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '7JAbhig2yIGYQiUqW2G4ua',
          type: 'Entry',
          createdAt: '2018-03-13T17:17:27.426Z',
          updatedAt: '2018-03-13T17:17:27.426Z',
          publishedVersion: 7,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Contact Us - Hours - Default',
          content:
            'Monday thru Thursday 8 AM to 8 PM, Friday 9 AM to 4:30 PM (Central)',
        },
      },
      contentAreaSlug: 'contact-us-hours',
    },
  },
  'add-provider-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4KWajQgAtGUSOUcosOSG2K',
      type: 'Entry',
      createdAt: '2018-02-16T03:09:56.781Z',
      updatedAt: '2018-03-06T19:34:01.026Z',
      publishedVersion: 22,
      revision: 3,
      locale: 'en-US',
    },
    fields: {
      description: 'Add Provider - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6fB3VnZ1BeGwqgsgy2iKkQ',
          type: 'Entry',
          createdAt: '2018-02-16T03:08:21.807Z',
          updatedAt: '2018-03-06T19:33:50.605Z',
          publishedVersion: 74,
          revision: 6,
          locale: 'en-US',
        },
        fields: {
          title: 'Add Provider - Success - Default',
          content:
            '## Success!\nYou have added a new provider to your account.',
        },
      },
      contentAreaSlug: 'add-provider-success',
    },
  },
  'add-ari-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2GylmphaB2aUkmoqgI2Gkw',
      type: 'Entry',
      createdAt: '2018-02-18T18:34:32.522Z',
      updatedAt: '2018-03-06T19:30:37.680Z',
      publishedVersion: 7,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Add ARI - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '7v3fWv3t4WOGeMue6UYYkA',
          type: 'Entry',
          createdAt: '2018-02-18T18:34:06.685Z',
          updatedAt: '2018-03-14T12:10:42.355Z',
          publishedVersion: 153,
          revision: 5,
          locale: 'en-US',
        },
        fields: {
          title: 'Add ARI - Success - Default',
          content:
            '## Success!\nYou have authorized this person to contact customer service on your behalf.\n\n',
        },
      },
      contentAreaSlug: 'add-ari-success',
    },
  },
  'update-ari-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '6TLFhgLE520E0qGMsYqMOA',
      type: 'Entry',
      createdAt: '2018-02-18T18:34:44.692Z',
      updatedAt: '2018-03-06T19:29:12.540Z',
      publishedVersion: 8,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Update ARI - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '2Z53cccB4QYAC8I4c6ieuY',
          type: 'Entry',
          createdAt: '2018-03-06T19:28:43.391Z',
          updatedAt: '2018-03-06T19:28:43.391Z',
          publishedVersion: 2,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Update ARI - Success - Default',
          content:
            '## Success!\nYou have updated your authorization for this person.\n\n',
        },
      },
      contentAreaSlug: 'update-ari-success',
    },
  },
  'view-account-number-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2MKHI5uv3ieKoU0OGAOamU',
      type: 'Entry',
      createdAt: '2018-02-25T00:39:17.938Z',
      updatedAt: '2018-02-25T00:39:17.938Z',
      publishedVersion: 17,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'View Account Number - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6DbJwrX7DU2sWm4g4q4syI',
          type: 'Entry',
          createdAt: '2018-02-25T00:38:14.822Z',
          updatedAt: '2018-03-14T12:20:07.547Z',
          publishedVersion: 88,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'View Account Number - Success',
          content: 'Your full account number is __%accountNumber%__\n\n',
        },
      },
      contentAreaSlug: 'view-account-number-success',
    },
  },
  'password-rules': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2Z1AxuORWgU22YS6iC0wsw',
      type: 'Entry',
      createdAt: '2018-02-24T22:33:34.310Z',
      updatedAt: '2018-02-24T22:33:34.310Z',
      publishedVersion: 9,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Password Rules',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6gnB3FBzMIMy4wSySOWMMm',
          type: 'Entry',
          createdAt: '2018-02-24T22:32:32.652Z',
          updatedAt: '2020-02-14T14:05:17.258Z',
          publishedVersion: 52,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'Password Rules',
          content:
            '__Your password:__\n\n- Must be between 8–30 characters in length\n- Must begin with a letter or number and contain at least one number\n- May use upper and lowercase letters\n- May use the following symbols ^ $ * . [ ] { } ( ) ? - " ! @ # % & / \\ , > < \' ; | _ ~\n- Cannot use any letter, symbol or number more than twice in a row',
        },
      },
      contentAreaSlug: 'password-rules',
    },
  },
  'forgot-password-error-username-not-found': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4FByJpOuFiIq2MkuqoCkQa',
      type: 'Entry',
      createdAt: '2018-02-24T20:52:53.863Z',
      updatedAt: '2018-02-24T20:52:53.863Z',
      publishedVersion: 20,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Forgot Password - Error - Username Not Found',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5zCFQ0AXyEKcuagUeQA4eY',
          type: 'Entry',
          createdAt: '2018-02-24T20:50:46.009Z',
          updatedAt: '2018-03-15T01:06:55.196Z',
          publishedVersion: 109,
          revision: 4,
          locale: 'en-US',
        },
        fields: {
          title: 'Forgot Password - Error - Username Not Found',
          content:
            "We couldn't find this username.  Please make sure you entered it correctly and try again.",
        },
      },
      contentAreaSlug: 'forgot-password-error-username-not-found',
    },
  },
  'token-expired-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2CUo0jWdwUoAOAaqKS0qiC',
      type: 'Entry',
      createdAt: '2018-02-24T17:38:48.948Z',
      updatedAt: '2018-02-24T18:48:32.655Z',
      publishedVersion: 20,
      revision: 3,
      locale: 'en-US',
    },
    fields: {
      description: 'Token Expired Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'MGoLSGYL6gM8YCEwMYS2K',
          type: 'Entry',
          createdAt: '2018-02-24T17:37:57.359Z',
          updatedAt: '2022-05-17T20:56:28.445Z',
          publishedVersion: 61,
          revision: 5,
          locale: 'en-US',
        },
        fields: {
          title: 'Expired Token - Error - Default',
          content:
            '## Invalid Token\n\nThe token provided is no longer valid or was entered incorrectly. Please try again and use the new token provided.',
        },
      },
      contentAreaSlug: 'token-expired-error',
    },
  },
  'forgot-password-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '6piHMQqEBGKOSCc4GiGegY',
      type: 'Entry',
      createdAt: '2018-02-24T18:30:04.723Z',
      updatedAt: '2018-02-24T18:45:27.239Z',
      publishedVersion: 18,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Forgot Password - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5qxzWL5MiIgEIKoImkooss',
          type: 'Entry',
          createdAt: '2018-02-24T18:13:03.998Z',
          updatedAt: '2018-03-27T16:30:42.009Z',
          publishedVersion: 100,
          revision: 6,
          locale: 'en-US',
        },
        fields: {
          title: 'Forgot Password - Success',
          content: '# Success! \nYou have reset your password.',
        },
      },
      contentAreaSlug: 'forgot-password-success',
    },
  },
  'forgot-password-error-same-as-current-password': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2EEjfhvFLKqecSE4Ka28w6',
      type: 'Entry',
      createdAt: '2018-02-24T18:28:47.888Z',
      updatedAt: '2018-02-24T18:45:27.221Z',
      publishedVersion: 27,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Forgot Password - Error - Same as Current Password',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '14ngAI2PXmUocC4Y6aMoqG',
          type: 'Entry',
          createdAt: '2018-02-24T18:13:25.387Z',
          updatedAt: '2018-03-13T16:41:23.142Z',
          publishedVersion: 31,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'Forgot Password - Error - Same as Current Password',
          content:
            '## Choose a new password\nYour new password cannot be the same as your current password.',
        },
      },
      contentAreaSlug: 'forgot-password-error-same-as-current-password',
    },
  },
  'forgot-username-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '5GAUBRXje8EcG6AYKggiuO',
      type: 'Entry',
      createdAt: '2018-02-24T18:28:06.863Z',
      updatedAt: '2018-02-24T18:45:27.206Z',
      publishedVersion: 13,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Forgot Username - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'lMa8hF8QdqOgyCMCCCq8U',
          type: 'Entry',
          createdAt: '2018-02-24T18:12:43.337Z',
          updatedAt: '2020-02-07T19:27:58.266Z',
          publishedVersion: 23,
          revision: 4,
          locale: 'en-US',
        },
        fields: {
          title: 'Forgot Username - Success',
          content:
            "We've sent a message with your username to the email address in your member profile.",
        },
      },
      contentAreaSlug: 'forgot-username-success',
    },
  },
  'register-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '1WK0Y8662oSoQcso4wocC2',
      type: 'Entry',
      createdAt: '2018-02-24T18:24:45.471Z',
      updatedAt: '2018-02-24T18:45:26.240Z',
      publishedVersion: 8,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Register - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5dzcwCgx0QMgSIGIycMowo',
          type: 'Entry',
          createdAt: '2018-02-24T18:10:41.992Z',
          updatedAt: '2018-03-27T14:51:11.051Z',
          publishedVersion: 38,
          revision: 5,
          locale: 'en-US',
        },
        fields: {
          title: 'Register - Success',
          content:
            '# Success! \nYour member portal account has been created. \n\nSign in now to start using the member portal to view your latest transactions, check your balance, or update your information.',
        },
      },
      contentAreaSlug: 'register-success',
    },
  },
  'register-error-username-in-use': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2l1LkyyA2E8iwIoIg6S2Yu',
      type: 'Entry',
      createdAt: '2018-02-24T18:22:10.619Z',
      updatedAt: '2018-02-24T18:45:26.227Z',
      publishedVersion: 10,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Register - Error - Username in Use',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4txh4VrJmgwkwmgoyCcq6S',
          type: 'Entry',
          createdAt: '2018-02-24T18:07:27.497Z',
          updatedAt: '2018-03-20T19:41:51.021Z',
          publishedVersion: 18,
          revision: 4,
          locale: 'en-US',
        },
        fields: {
          title: 'Register - Error - Username in Use',
          content:
            '## Username already in use\n\nThis username requested is already in use.  Please try again.',
        },
      },
      contentAreaSlug: 'register-error-username-in-use',
    },
  },
  'register-error-already-registered': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: 'au8mVnLaDugOSskYyk446',
      type: 'Entry',
      createdAt: '2018-02-24T18:21:35.324Z',
      updatedAt: '2018-02-24T18:45:26.218Z',
      publishedVersion: 20,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Register - Error - Already Registered',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3eBxChkjUcQqeoc6qq6CmS',
          type: 'Entry',
          createdAt: '2018-02-24T18:06:58.063Z',
          updatedAt: '2018-03-14T20:52:07.270Z',
          publishedVersion: 137,
          revision: 5,
          locale: 'en-US',
        },
        fields: {
          title: 'Register - Error - Already Registered',
          content:
            '## You already registered\n\nOur records show that you are already a registered portal user. Contact Customer Service at (800)859-2144 for more information.',
        },
      },
      contentAreaSlug: 'register-error-already-registered',
    },
  },
  'register-blocked': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '9BKWsfR0kw4604y00ukqI',
      type: 'Entry',
      createdAt: '2018-02-24T18:24:16.970Z',
      updatedAt: '2018-02-24T18:45:26.212Z',
      publishedVersion: 9,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Register - Blocked',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '66NWjSsSeQE4Sy6ieMgIu0',
          type: 'Entry',
          createdAt: '2018-02-24T18:09:59.050Z',
          updatedAt: '2018-02-24T18:45:25.333Z',
          publishedVersion: 17,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'Register - Blocked',
          content:
            'Unfortunately, based on some information you gave us, you do not have access to register here. Sign in as you normally would from within your health plan portal experience to access you spending account data.',
        },
      },
      contentAreaSlug: 'register-blocked',
    },
  },
  'forgot-username-error-no-email-address-on-file': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '147tg4vQewUGyAAECOieQU',
      type: 'Entry',
      createdAt: '2018-02-24T18:25:41.941Z',
      updatedAt: '2018-02-24T18:45:26.210Z',
      publishedVersion: 30,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Forgot Username - Error - No Email Address on File ',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3bARmO8vTaOSs8YCGiQa2s',
          type: 'Entry',
          createdAt: '2018-02-24T18:12:02.768Z',
          updatedAt: '2018-03-20T19:40:55.510Z',
          publishedVersion: 40,
          revision: 6,
          locale: 'en-US',
        },
        fields: {
          title: 'Forgot Username - Error - No Email Address on File',
          content:
            '## No email address found\nYou do not have an email address on file. Please contact Customer Service at (800) 859-2144 for assistance.',
        },
      },
      contentAreaSlug: 'forgot-username-error-no-email-address-on-file',
    },
  },
  'submit-hsa-application-personal-information-description': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '17rZkk7VVKek0iKC88qCW2',
      type: 'Entry',
      createdAt: '2018-02-23T23:27:24.834Z',
      updatedAt: '2018-02-23T23:27:24.834Z',
      publishedVersion: 18,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Submit HSA Application - Personal Information Description',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3duODDe8AMaOEyGkSmoQeC',
          type: 'Entry',
          createdAt: '2018-02-23T23:27:00.041Z',
          updatedAt: '2018-03-09T20:03:50.212Z',
          publishedVersion: 87,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title:
            'Submit HSA Application - Personal Information Description - Default',
          content:
            'Enter your personal information to apply for a Health Savings Account.',
        },
      },
      contentAreaSlug:
        'submit-hsa-application-personal-information-description',
    },
  },
  'submit-hsa-application-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: 'UU6PWemteSQ6646Mw8AYc',
      type: 'Entry',
      createdAt: '2018-02-23T22:26:37.443Z',
      updatedAt: '2018-02-23T22:26:37.443Z',
      publishedVersion: 6,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Submit HSA Application - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3oWeiY8VdYc4myMYCoU4gy',
          type: 'Entry',
          createdAt: '2018-02-23T19:31:17.696Z',
          updatedAt: '2018-03-06T12:29:29.659Z',
          publishedVersion: 191,
          revision: 9,
          locale: 'en-US',
        },
        fields: {
          title: 'Submit HSA Application - Success - Default',
          content:
            '## Success!\nYou have opened an HSA account!\n\n#### SA ID: %applicantMemberId%\n\nYou can also register for the online portal to access to your account at any time and on any device with online access.\n\nYou can always register for the portal later.\n\n',
        },
      },
      contentAreaSlug: 'submit-hsa-application-success',
    },
  },
  'submit-hsa-application-error-add-hsa-applicant': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '65GrXgVSDKwOMuUm4qgOuE',
      type: 'Entry',
      createdAt: '2018-02-23T19:26:37.927Z',
      updatedAt: '2018-02-23T19:26:37.927Z',
      publishedVersion: 4,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Submit HSA Application - Error - Add HSA Applicant ',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'Y4K58Wq4wwsKq0WseyycM',
          type: 'Entry',
          createdAt: '2018-02-23T19:26:14.645Z',
          updatedAt: '2018-03-21T15:35:19.132Z',
          publishedVersion: 33,
          revision: 4,
          locale: 'en-US',
        },
        fields: {
          title: 'Submit HSA Application - Error - Add HSA Applicant - Default',
          content:
            '## Unable to process request\nWe are unable to process your request at this time. Please try again or contact Customer Service at (800) 859-2144.',
        },
      },
      contentAreaSlug: 'submit-hsa-application-error-add-hsa-applicant',
    },
  },
  'update-password-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '3AufOe2f5uYYcCS8OwaOua',
      type: 'Entry',
      createdAt: '2018-02-23T17:35:34.929Z',
      updatedAt: '2018-02-23T17:35:34.929Z',
      publishedVersion: 6,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Update Password - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '14hz4RE0RSUqwAUsGmwOkG',
          type: 'Entry',
          createdAt: '2018-02-23T17:34:38.116Z',
          updatedAt: '2018-03-13T18:06:09.764Z',
          publishedVersion: 65,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Update Password - Error - Default',
          content:
            '## An error has occurred\nThe system experienced an error. Please try again.',
        },
      },
      contentAreaSlug: 'update-password-error',
    },
  },
  'update-password-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2my0RPWD6wus24g0m8oAMe',
      type: 'Entry',
      createdAt: '2018-02-23T17:35:20.444Z',
      updatedAt: '2018-02-23T17:35:20.444Z',
      publishedVersion: 12,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Update Password - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5D8Z5o984MMiSAKCCMEo60',
          type: 'Entry',
          createdAt: '2018-02-23T17:34:15.298Z',
          updatedAt: '2018-03-14T12:20:43.443Z',
          publishedVersion: 29,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Update Password - Success - Default',
          content: '## Success!\nYou have reset your password.',
        },
      },
      contentAreaSlug: 'update-password-success',
    },
  },
  'submit-hsa-application-error-validate-contact-information': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2TijbiLSw0UGWMGGsqQqIi',
      type: 'Entry',
      createdAt: '2018-02-21T23:29:01.313Z',
      updatedAt: '2018-02-21T23:29:34.939Z',
      publishedVersion: 8,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description:
        'Submit HSA Application - Error - Validate Contact Information',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3eZus5w0buEG2MkgkkkyOs',
          type: 'Entry',
          createdAt: '2018-02-21T23:29:20.992Z',
          updatedAt: '2018-03-21T15:34:46.908Z',
          publishedVersion: 49,
          revision: 4,
          locale: 'en-US',
        },
        fields: {
          title:
            'Submit HSA Application - Error - Validate Contact Information - Default',
          content:
            '## Unable to process application\nWe are unable to process your application at this time. Please contact Customer Service at (800) 859-2144.',
        },
      },
      contentAreaSlug:
        'submit-hsa-application-error-validate-contact-information',
    },
  },
  'submit-hsa-application-fine-print': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '3UdgoDA0zCCOeYYOyYgwac',
      type: 'Entry',
      createdAt: '2018-02-21T01:44:00.409Z',
      updatedAt: '2018-02-21T01:44:00.409Z',
      publishedVersion: 7,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Submit HSA Application - Fine Print',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3o6h5doK9aUSk2Kaaou8Ma',
          type: 'Entry',
          createdAt: '2018-02-21T01:43:38.710Z',
          updatedAt: '2021-11-01T17:01:03.904Z',
          publishedVersion: 39,
          revision: 6,
          locale: 'en-US',
        },
        fields: {
          title: 'Submit HSA Application - Fine Print - Default',
          content:
            '### Opening a new Account?\nFederal law requires us to obtain, verify, and record information that identifies each person that opens an account. When you open an account, we will ask you for your name, a street address, date of birth and a form of identification that will allow us to identify you.\n### Non-Bank Trustee Status\nFurther is an IRS-approved HSA non-bank trustee. To view our approval letter from the IRS, [click here](link="https://healthequity.com/doclib/general/irs-nbt.pdf").',
        },
      },
      contentAreaSlug: 'submit-hsa-application-fine-print',
    },
  },
  'submit-hsa-application-information-needed': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '3zdhk7VP20ye4S4ieGWg6w',
      type: 'Entry',
      createdAt: '2018-02-21T01:37:20.563Z',
      updatedAt: '2018-02-21T01:37:20.563Z',
      publishedVersion: 4,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Submit HSA Application - Information Needed',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4ba2TC4lQkYMuI0uiiSM8I',
          type: 'Entry',
          createdAt: '2018-02-21T01:37:02.222Z',
          updatedAt: '2018-03-09T20:03:31.477Z',
          publishedVersion: 294,
          revision: 11,
          locale: 'en-US',
        },
        fields: {
          title: 'Submit HSA Application - Information Needed - Default',
          content:
            '## Are you qualified? \n[See IRS Publication 969](link="http://www.irs.gov/publications/p969/ar02.html#en_US_2011_publink1000204025") to learm more about qualifying for an HSA.\n\n## What you\'ll need...\n\n### Information about your health insurance plan\n- Specifically, the effective date, coverage type (single or family), and your deductible\n\n### Your Social Security Number (SSN)\n\n### Your banking information\n- You\'ll need this to set up your account and for reimbursements and deposits related to medical expenses.',
        },
      },
      contentAreaSlug: 'submit-hsa-application-information-needed',
    },
  },
  'task-list-questions-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '1YbFIKP9CcmEA26aEksiC',
      type: 'Entry',
      createdAt: '2018-02-19T23:25:16.763Z',
      updatedAt: '2018-02-19T23:25:16.763Z',
      publishedVersion: 5,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Task List Questions - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'task-list-questions-error',
    },
  },
  'task-list-questions-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '12tPbU0zo0SSoUqGMy6MIm',
      type: 'Entry',
      createdAt: '2018-02-19T23:17:39.278Z',
      updatedAt: '2018-02-19T23:17:39.278Z',
      publishedVersion: 17,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Task List Questions - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '2H24CMSYGAssioGEAWcG2O',
          type: 'Entry',
          createdAt: '2018-02-19T23:17:19.238Z',
          updatedAt: '2018-03-14T12:07:07.059Z',
          publishedVersion: 67,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Task List Questions - Success - Default',
          content:
            "## Thanks for completing our survey\nBased on your answers, we've created a list of recommended tasks to help you make the most of your account.  \n\nYou'll find this list on the **Accounts** page under the **My Tasks** heading.",
        },
      },
      contentAreaSlug: 'task-list-questions-success',
    },
  },
  'investment-transfer-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '6kd9xbr7iM2EaMUc8SS8uo',
      type: 'Entry',
      createdAt: '2018-02-19T23:04:16.757Z',
      updatedAt: '2018-02-19T23:04:16.757Z',
      publishedVersion: 17,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Investment Transfer - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '7sVudRNAd2Y4ISks8IGKG8',
          type: 'Entry',
          createdAt: '2018-02-19T23:03:49.088Z',
          updatedAt: '2018-03-27T14:49:11.502Z',
          publishedVersion: 48,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'Investment Transfer - Success - Default',
          content:
            '## Success!\nWe have received your transfer request.  \n\nThis transaction may take up to 5 business days to process. You can see the status of your request under Recent Activity on the Accounts screen.',
        },
      },
      contentAreaSlug: 'investment-transfer-success',
    },
  },
  'activate-hsa-error-closed-account': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4LJywHEDwQ08I8imsUyG2W',
      type: 'Entry',
      createdAt: '2018-02-19T22:36:08.807Z',
      updatedAt: '2018-02-19T22:36:08.807Z',
      publishedVersion: 6,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Activate HSA - Error - Closed Account',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'activate-hsa-error-closed-account',
    },
  },
  'beneficiaries-sidebar-content': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2gpBqHCycEM8aKKYicSkaS',
      type: 'Entry',
      createdAt: '2018-02-19T22:13:31.303Z',
      updatedAt: '2018-02-19T22:13:31.303Z',
      publishedVersion: 8,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Beneficiaries Sidebar Content',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4SvU2CpZvqmgOM4WA2o0gq',
          type: 'Entry',
          createdAt: '2018-02-19T22:13:07.447Z',
          updatedAt: '2018-02-19T22:13:07.447Z',
          publishedVersion: 7,
          revision: 1,
          locale: 'en-US',
        },
        fields: { title: 'Default Beneficiaries Sidebar' },
      },
      contentAreaSlug: 'beneficiaries-sidebar-content',
    },
  },
  'update-beneficiaries-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '5N3NnVx1iEuiMuiQOkyEg0',
      type: 'Entry',
      createdAt: '2018-02-19T22:05:10.864Z',
      updatedAt: '2018-02-19T22:05:10.864Z',
      publishedVersion: 7,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Update Beneficiaries - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3HbNmFsy0UCwG2MMcuSsCO',
          type: 'Entry',
          createdAt: '2018-02-19T22:04:23.991Z',
          updatedAt: '2018-03-06T13:02:00.402Z',
          publishedVersion: 93,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Update Beneficiaries - Success - Default',
          content:
            '## Success!\nYou have updated the beneficiary information for your account. ',
        },
      },
      contentAreaSlug: 'update-beneficiaries-success',
    },
  },
  'add-claim-note-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '5TQtgx1kFaoQCG40m0cCCm',
      type: 'Entry',
      createdAt: '2018-02-19T20:07:23.102Z',
      updatedAt: '2018-02-19T20:07:23.102Z',
      publishedVersion: 6,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Add Claim Note - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1eh0XAK7ryK4w4Aa68MGIS',
          type: 'Entry',
          createdAt: '2018-02-19T20:06:14.009Z',
          updatedAt: '2018-03-06T12:38:08.583Z',
          publishedVersion: 41,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Add Claim Note - Success - Default',
          content: '## Success!\nYour note has been saved.',
        },
      },
      contentAreaSlug: 'add-claim-note-success',
    },
  },
  'add-claim-note-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: 'FhHzqWDXQkgygWUS88iIQ',
      type: 'Entry',
      createdAt: '2018-02-19T20:07:08.353Z',
      updatedAt: '2018-02-19T20:07:08.353Z',
      publishedVersion: 7,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Add Claim Note - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '2uIZUYzYpCoe2OuWGQsEgo',
          type: 'Entry',
          createdAt: '2018-02-16T02:47:26.697Z',
          updatedAt: '2018-03-14T16:20:11.249Z',
          publishedVersion: 107,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'Attach Documents - Error - Default',
          content:
            '## Unable to save file\n\nWe are unable to save the file you uploaded at this time. Please try again or contact Customer Service at %groupTollFreePhone% for assistance.',
        },
      },
      contentAreaSlug: 'add-claim-note-error',
    },
  },
  'make-deposit-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4IkbFxEm0we62YcGGa0y8a',
      type: 'Entry',
      createdAt: '2018-02-18T20:37:39.272Z',
      updatedAt: '2018-02-18T20:37:39.272Z',
      publishedVersion: 4,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Make Deposit - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4g5ceMQLTaOcECsWsYu4G6',
          type: 'Entry',
          createdAt: '2018-02-18T20:37:22.987Z',
          updatedAt: '2018-03-27T14:43:37.397Z',
          publishedVersion: 32,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'Make Deposit - Success - Default',
          content:
            '## Success!\nWe’ve received your deposit request.  \n\nThis transaction may take up to 5 business days to process. You can see the status of your request under Recent Activity on the Accounts screen.',
        },
      },
      contentAreaSlug: 'make-deposit-success',
    },
  },
  'update-scheduled-deposit-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '3NcRk7nckMq0su4aSue6qe',
      type: 'Entry',
      createdAt: '2018-02-18T19:46:46.904Z',
      updatedAt: '2018-02-18T19:46:46.904Z',
      publishedVersion: 5,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Update Scheduled Deposit - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '2U0pJbFgfug22KgmS2GeWU',
          type: 'Entry',
          createdAt: '2018-02-18T19:46:30.687Z',
          updatedAt: '2018-03-27T14:44:15.105Z',
          publishedVersion: 36,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Update Scheduled Deposit - Success - Default',
          content:
            '## Success!\nYour scheduled deposit request has been updated.',
        },
      },
      contentAreaSlug: 'update-scheduled-deposit-success',
    },
  },
  'cancel-scheduled-deposit-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: 'lqL4cN2xuSWC0C8gQy2C8',
      type: 'Entry',
      createdAt: '2018-02-18T19:40:30.994Z',
      updatedAt: '2018-02-18T19:40:30.994Z',
      publishedVersion: 10,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Cancel Scheduled Deposit - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '9YI1uxPgzuIS28meYg4YU',
          type: 'Entry',
          createdAt: '2018-02-18T19:40:12.723Z',
          updatedAt: '2018-03-06T12:34:21.248Z',
          publishedVersion: 18,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Cancel Scheduled Deposit - Success - Default ',
          content:
            '## Success!\nYou have successfully canceled your scheduled deposit.',
        },
      },
      contentAreaSlug: 'cancel-scheduled-deposit-success',
    },
  },
  'cancel-scheduled-deposit-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: 'OgC8bs2hkkoIQeW2QmaoQ',
      type: 'Entry',
      createdAt: '2018-02-18T19:39:56.700Z',
      updatedAt: '2018-02-18T19:39:56.700Z',
      publishedVersion: 8,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Cancel Scheduled Deposit - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'cancel-scheduled-deposit-error',
    },
  },
  'cancel-pending-reimbursement-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4WCYewqdZeSaEU2iY8ee86',
      type: 'Entry',
      createdAt: '2018-02-18T19:29:00.392Z',
      updatedAt: '2018-02-18T19:29:00.392Z',
      publishedVersion: 6,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Cancel Pending Reimbursement - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6b9btBk5OgE8WuuW6SeoiM',
          type: 'Entry',
          createdAt: '2018-02-16T03:15:24.517Z',
          updatedAt: '2018-03-21T15:34:57.447Z',
          publishedVersion: 61,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Global - Error - Default',
          content:
            '## An error occurred\nWe are unable to process information at this time. Please try again or contact Customer Service at (800) 859-2144 for more information. ',
        },
      },
      contentAreaSlug: 'cancel-pending-reimbursement-error',
    },
  },
  'cancel-pending-reimbursement-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '6R7qizKq9qiCWqCkISo8G8',
      type: 'Entry',
      createdAt: '2018-02-18T19:28:43.856Z',
      updatedAt: '2018-02-18T19:28:43.856Z',
      publishedVersion: 10,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Cancel Pending Reimbursement - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '72eK3Tx4womCWo6wmsiQ4G',
          type: 'Entry',
          createdAt: '2018-02-18T19:27:24.606Z',
          updatedAt: '2018-03-06T12:44:54.443Z',
          publishedVersion: 46,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Cancel Pending Reimbursement - Success - Default',
          content: '## Success!\nYou have canceled your reimbursement request.',
        },
      },
      contentAreaSlug: 'cancel-pending-reimbursement-success',
    },
  },
  'cancel-pending-investment-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '3auFhNkF4Q6cwI8oIKw8qO',
      type: 'Entry',
      createdAt: '2018-02-18T19:28:16.088Z',
      updatedAt: '2018-02-18T19:28:16.088Z',
      publishedVersion: 8,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Cancel Pending Investment - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '778gduSHvyewgqA8gCUygW',
          type: 'Entry',
          createdAt: '2018-02-18T19:27:03.099Z',
          updatedAt: '2018-03-06T12:35:08.746Z',
          publishedVersion: 41,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Cancel Pending Investment - Success - Default',
          content:
            '## Success!\nYou have successfully canceled the pending investment.',
        },
      },
      contentAreaSlug: 'cancel-pending-investment-success',
    },
  },
  'cancel-pending-claim-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4OLeI2gOxGwqKo46giIgOi',
      type: 'Entry',
      createdAt: '2018-02-18T19:14:49.182Z',
      updatedAt: '2018-02-18T19:14:49.182Z',
      publishedVersion: 5,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Cancel Pending Claim - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'DQmBCddh0kywmMmkoqIIu',
          type: 'Entry',
          createdAt: '2018-02-18T19:14:23.552Z',
          updatedAt: '2018-03-06T12:35:39.339Z',
          publishedVersion: 22,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Cancel Pending Claim - Success - Default',
          content:
            '## Success!\nYou have successfully canceled the pending claim.',
        },
      },
      contentAreaSlug: 'cancel-pending-claim-success',
    },
  },
  'remove-ari-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4j61kBdnHGE8WgOkC60ooe',
      type: 'Entry',
      createdAt: '2018-02-18T19:00:35.952Z',
      updatedAt: '2018-02-18T19:00:35.952Z',
      publishedVersion: 6,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Remove ARI - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '19QuSuseRgY2ASwgiEiGg8',
          type: 'Entry',
          createdAt: '2018-02-18T18:59:50.180Z',
          updatedAt: '2018-03-06T13:26:56.432Z',
          publishedVersion: 40,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Remove ARI - Success - Default',
          content:
            '## Success!\nThis person is no longer authorized to contact customer service on your behalf.',
        },
      },
      contentAreaSlug: 'remove-ari-success',
    },
  },
  'update-coverage-tier-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '541K1Q73tmwIOUiekgQQKM',
      type: 'Entry',
      createdAt: '2018-02-18T18:13:09.131Z',
      updatedAt: '2018-02-18T18:13:09.131Z',
      publishedVersion: 9,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Update Coverage Tier - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1LTbbmRbGEM6gyeieuAgmK',
          type: 'Entry',
          createdAt: '2018-02-18T18:12:52.763Z',
          updatedAt: '2019-11-26T20:53:25.285Z',
          publishedVersion: 173,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'Update Coverage Tier - Success - Default',
          content:
            '## Success!\nYou have updated your health plan coverage information for our files. We will use this to warn you if you try to enter a contribution that would put you over the IRS contribution limit set for your coverage type.\n\nPlease note, this does not update your actual coverage. To make health plan coverage changes, please contact your benefits administrator.',
        },
      },
      contentAreaSlug: 'update-coverage-tier-success',
    },
  },
  'update-plan-type-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '1dK6tgnU3aokYW8kGAYoaK',
      type: 'Entry',
      createdAt: '2018-02-18T18:07:29.524Z',
      updatedAt: '2018-02-18T18:07:29.524Z',
      publishedVersion: 7,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Update Plan Type - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '7peB3JmlTqWqkO6qGYEGgo',
          type: 'Entry',
          createdAt: '2018-02-18T18:07:12.311Z',
          updatedAt: '2018-03-06T13:10:35.388Z',
          publishedVersion: 34,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Update Plan Type - Success - Default',
          content: '## Success!\nYou have updated your health plan type.',
        },
      },
      contentAreaSlug: 'update-plan-type-success',
    },
  },
  'update-account-hold-success-set-inactive': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '67mR5NTagMiWS6s0OcUaa8',
      type: 'Entry',
      createdAt: '2018-02-18T17:45:04.680Z',
      updatedAt: '2018-02-18T17:45:04.680Z',
      publishedVersion: 6,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Update Account Hold - Success - Set Inactive',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1JtA0m3PsMosaOImGQ4AYe',
          type: 'Entry',
          createdAt: '2018-02-18T17:44:22.942Z',
          updatedAt: '2018-03-06T13:08:21.045Z',
          publishedVersion: 29,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Update Account Hold - Success - Set Inactive - Default',
          content: '## Success!\nYou have placed your account on hold. ',
        },
      },
      contentAreaSlug: 'update-account-hold-success-set-inactive',
    },
  },
  'update-account-hold-success-set-active': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2SeSW8FxC0yUsYi4sm6gMU',
      type: 'Entry',
      createdAt: '2018-02-18T17:44:50.639Z',
      updatedAt: '2018-02-18T17:44:50.639Z',
      publishedVersion: 7,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Update Account Hold - Success - Set Active',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5K2ZWENWOQyWK2aA4G4gmM',
          type: 'Entry',
          createdAt: '2018-02-18T17:44:01.623Z',
          updatedAt: '2018-03-06T13:08:49.095Z',
          publishedVersion: 59,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'Update Account Hold - Success - Set Active - Default',
          content: '## Success!\nYou have removed the hold from your account. ',
        },
      },
      contentAreaSlug: 'update-account-hold-success-set-active',
    },
  },
  'update-phone-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4LRzLcp9zigGwaaGWYKsgE',
      type: 'Entry',
      createdAt: '2018-02-18T17:12:42.262Z',
      updatedAt: '2018-02-18T17:12:42.262Z',
      publishedVersion: 5,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Update Phone - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '51H3hhjTHaeiw4KUAuEwaw',
          type: 'Entry',
          createdAt: '2018-02-18T17:12:15.002Z',
          updatedAt: '2018-03-06T13:07:10.374Z',
          publishedVersion: 22,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Update Phone - Success - Default',
          content: '## Success!\nYou have updated your phone number.',
        },
      },
      contentAreaSlug: 'update-phone-success',
    },
  },
  'update-email-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '1z1PlYSKXCICU08iUGSGcQ',
      type: 'Entry',
      createdAt: '2018-02-18T16:59:09.642Z',
      updatedAt: '2018-02-18T16:59:09.642Z',
      publishedVersion: 5,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Update Email - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4nh8utAENi0acs4YCOmocg',
          type: 'Entry',
          createdAt: '2018-02-18T16:58:51.840Z',
          updatedAt: '2018-03-06T13:04:34.008Z',
          publishedVersion: 20,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Update Email - Success - Default',
          content: '## Success!\nYou have updated your email address.',
        },
      },
      contentAreaSlug: 'update-email-success',
    },
  },
  'update-address-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '26KW4caLi4o4Ua8QIcaeKy',
      type: 'Entry',
      createdAt: '2018-02-18T16:37:50.502Z',
      updatedAt: '2018-02-18T16:37:50.502Z',
      publishedVersion: 12,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Update Address - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1Crcr0w7dWU6euec46Km4a',
          type: 'Entry',
          createdAt: '2018-02-18T16:37:33.373Z',
          updatedAt: '2018-03-06T13:03:32.871Z',
          publishedVersion: 50,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Update Address - Success - Default',
          content: '## Success!\nYou have updated your address. ',
        },
      },
      contentAreaSlug: 'update-address-success',
    },
  },
  'manage-crossover-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4WVTLbSk1aK0OCUiI6M2Ee',
      type: 'Entry',
      createdAt: '2018-02-18T00:30:36.814Z',
      updatedAt: '2018-02-18T00:30:36.814Z',
      publishedVersion: 6,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Manage Crossover - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1eO4Ou8Sw2OAKOIyquKeqU',
          type: 'Entry',
          createdAt: '2018-02-18T00:29:55.272Z',
          updatedAt: '2018-03-27T14:48:42.974Z',
          publishedVersion: 81,
          revision: 4,
          locale: 'en-US',
        },
        fields: {
          title: 'Manage Crossover - Success - Default',
          content:
            '## Success!\nYou have updated your Automatic Claim Payment settings. ',
        },
      },
      contentAreaSlug: 'manage-crossover-success',
    },
  },
  'cancel-debit-card-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '3f75OOBab6A8wEMeWWOqM',
      type: 'Entry',
      createdAt: '2018-02-17T23:13:04.317Z',
      updatedAt: '2018-02-17T23:13:04.317Z',
      publishedVersion: 6,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Cancel Debit Card - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6nRkhaYfCwGiYyueyywGqY',
          type: 'Entry',
          createdAt: '2018-02-17T23:12:18.307Z',
          updatedAt: '2018-03-27T14:50:13.108Z',
          publishedVersion: 41,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'Cancel Debit Card - Success - Default',
          content:
            '## Success!\nYou have canceled this debit card. \n\nYou can request a new debit card from the Payment and Banking screen.',
        },
      },
      contentAreaSlug: 'cancel-debit-card-success',
    },
  },
  'cancel-all-debit-cards-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: 'nWq1CZZ8NqSoaOokeY4Og',
      type: 'Entry',
      createdAt: '2018-02-17T23:12:31.661Z',
      updatedAt: '2018-02-17T23:12:31.661Z',
      publishedVersion: 17,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Cancel All Debit Cards - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5qeyEF1dteAQK4YiWS4qwW',
          type: 'Entry',
          createdAt: '2018-02-17T23:11:48.832Z',
          updatedAt: '2018-03-27T14:50:45.476Z',
          publishedVersion: 89,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'Cancel All Debit Cards - Success - Default',
          content:
            '## Success!\nYou have canceled all cards associated with your account. \n\nYou can still pay bills and get reimbursed for eligible expenses using the member portal.',
        },
      },
      contentAreaSlug: 'cancel-all-debit-cards-success',
    },
  },
  'add-debit-card-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2jwNMDal1yEE0wMMQ2aeY4',
      type: 'Entry',
      createdAt: '2018-02-17T22:35:13.046Z',
      updatedAt: '2018-02-17T22:35:13.046Z',
      publishedVersion: 13,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Add Debit Card - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1tynEGC9EkM4goEmeUgg8W',
          type: 'Entry',
          createdAt: '2018-02-17T22:34:50.290Z',
          updatedAt: '2018-04-30T11:42:21.377Z',
          publishedVersion: 61,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'Add Debit Card - Success - Default',
          content:
            '## Success!\nYou have added a debit card to your account.\n\nYour new card should arrive in the mail in 7 to 10 business days.',
        },
      },
      contentAreaSlug: 'add-debit-card-success',
    },
  },
  t9: {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '6CrtIs35za8ks6UukWgQeY',
      type: 'Entry',
      createdAt: '2018-02-17T19:19:02.375Z',
      updatedAt: '2018-02-17T19:19:02.375Z',
      publishedVersion: 4,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'T9',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '4125K11dj2QI4OAuo6GO8M',
          type: 'Entry',
          createdAt: '2018-02-06T21:02:47.687Z',
          updatedAt: '2018-03-14T15:55:26.985Z',
          publishedVersion: 116,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          taskText:
            'Add providers to your account for easily paying medical bills online.',
        },
      },
      contentAreaSlug: 't9',
    },
  },
  'activate-hsa-error-schedule-deposit': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4eoTeXgvZuo8u82Mm4kEUE',
      type: 'Entry',
      createdAt: '2018-02-17T16:18:22.733Z',
      updatedAt: '2018-02-17T16:18:22.733Z',
      publishedVersion: 9,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Activate HSA - Error - Schedule Deposit',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '5wWsEYHHbOKSU8iW80CIg8',
          type: 'Entry',
          createdAt: '2018-02-17T16:18:11.907Z',
          updatedAt: '2018-03-14T16:21:35.112Z',
          publishedVersion: 62,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'Activate HSA - Error - Schedule Deposit - Default',
          content:
            "## Unable to complete deposit\nWe're unable to complete your deposit at this time. Please contact Customer Service at %groupTollFreePhone%for more information.",
        },
      },
      contentAreaSlug: 'activate-hsa-error-schedule-deposit',
    },
  },
  'activate-hsa-error-add-bank-account': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '5GRjPGRMHuMSYi8KYM8wqq',
      type: 'Entry',
      createdAt: '2018-02-17T16:16:04.345Z',
      updatedAt: '2018-02-17T16:16:04.345Z',
      publishedVersion: 4,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Activate HSA - Error - Add Bank Account',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '2Ee7PCMvdOE8QuMKgsECsk',
          type: 'Entry',
          createdAt: '2018-02-17T16:15:41.642Z',
          updatedAt: '2018-03-14T16:21:10.699Z',
          publishedVersion: 55,
          revision: 4,
          locale: 'en-US',
        },
        fields: {
          title: 'Activate HSA - Error - Add Bank Account - Default',
          content:
            '## Unable to add bank account\n\nWe are unable to add your bank account to your profile at this time. Please contact Customer Service at %groupTollFreePhone% for more information.',
        },
      },
      contentAreaSlug: 'activate-hsa-error-add-bank-account',
    },
  },
  'activate-hsa-success-closed-account': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '3tUBVu0ZryU68Sggu2siKY',
      type: 'Entry',
      createdAt: '2018-02-17T16:13:14.974Z',
      updatedAt: '2018-02-17T16:13:14.974Z',
      publishedVersion: 20,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Activate HSA - Success - Closed Account',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6eN1A0hqNy2Es0AqswUiUU',
          type: 'Entry',
          createdAt: '2018-02-17T16:12:22.225Z',
          updatedAt: '2018-03-12T11:25:34.466Z',
          publishedVersion: 170,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'Activate HSA - Success - Closed Account - Default',
          content:
            "## Account closed\nYou have closed your account. \n\nWe're sorry to see you go. You can reactivate your account at any time by calling us at 1-800-859-2144.",
        },
      },
      contentAreaSlug: 'activate-hsa-success-closed-account',
    },
  },
  'remove-bank-account-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '6B9fAGJceAqwQguQqSMGWc',
      type: 'Entry',
      createdAt: '2018-02-16T18:22:00.251Z',
      updatedAt: '2018-02-16T18:22:00.251Z',
      publishedVersion: 15,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Remove Bank Account - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3U3PzwpRzy8GOcagwESwKY',
          type: 'Entry',
          createdAt: '2018-02-16T18:21:37.854Z',
          updatedAt: '2018-03-27T14:49:49.060Z',
          publishedVersion: 53,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'Remove Bank Account - Success - Default',
          content:
            '## Success!\nYou have removed this banking account from your profile. ',
        },
      },
      contentAreaSlug: 'remove-bank-account-success',
    },
  },
  'add-bank-account-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4kbL40CQj60WagWUgY8sge',
      type: 'Entry',
      createdAt: '2018-02-16T18:20:06.530Z',
      updatedAt: '2018-02-16T18:20:06.530Z',
      publishedVersion: 15,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Add Bank Account - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'YJGZFYYYiQm0GMyUiOUaS',
          type: 'Entry',
          createdAt: '2018-02-16T03:24:05.195Z',
          updatedAt: '2018-03-06T12:51:16.778Z',
          publishedVersion: 66,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Add Bank Account - Success - Default',
          content:
            '## Success!\nYou have added this banking account to your profile.',
        },
      },
      contentAreaSlug: 'add-bank-account-success',
    },
  },
  'make-primary-bank-account-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '5n8DEnUu2Iowua6Guws4Uo',
      type: 'Entry',
      createdAt: '2018-02-16T18:14:42.250Z',
      updatedAt: '2018-02-16T18:14:42.250Z',
      publishedVersion: 4,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Make Primary Bank Account - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1cDvFRCvDeSGSC6s2gumcE',
          type: 'Entry',
          createdAt: '2018-02-16T18:13:59.343Z',
          updatedAt: '2018-03-27T14:50:01.966Z',
          publishedVersion: 78,
          revision: 4,
          locale: 'en-US',
        },
        fields: {
          title: 'Make Primary Bank Account - Success - Default',
          content:
            '## Success!\nYou have updated your bank account information. ',
        },
      },
      contentAreaSlug: 'make-primary-bank-account-success',
    },
  },
  'submit-claim-error-bad-file': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '7pKwxJ5fLayyY2s22aMSik',
      type: 'Entry',
      createdAt: '2018-02-16T17:22:26.363Z',
      updatedAt: '2018-02-16T17:22:26.363Z',
      publishedVersion: 5,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Submit Claim - Error Bad File',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'aag79QAVgcEmaYo6Iw8O2',
          type: 'Entry',
          createdAt: '2018-02-16T02:47:06.315Z',
          updatedAt: '2018-03-14T16:19:40.710Z',
          publishedVersion: 86,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'Attach Documents - Error Bad File - Default',
          content:
            "## Unable to read file\nWe're unable to read the file you uploaded. Please try again or contact Customer Service at %groupTollFreePhone% for assistance. ",
        },
      },
      contentAreaSlug: 'submit-claim-error-bad-file',
    },
  },
  'submit-claim-error-encrypted-pdf': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '37b35G9uti8UKMecKmgWIe',
      type: 'Entry',
      createdAt: '2018-02-16T17:17:36.219Z',
      updatedAt: '2018-02-16T17:17:36.219Z',
      publishedVersion: 5,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Submit Claim - Error Encrypted PDF',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6bmbzLCxJScyqkyoAKwoaE',
          type: 'Entry',
          createdAt: '2018-02-16T02:46:41.657Z',
          updatedAt: '2018-03-13T18:18:04.773Z',
          publishedVersion: 114,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Attach Documents - Error Encrypted PDF - Default',
          content:
            "## File is a password-protected PDF\n\nWe couldn't read this PDF because it's password protected. Please upload a PDF that isn't password protected.",
        },
      },
      contentAreaSlug: 'submit-claim-error-encrypted-pdf',
    },
  },
  'submit-claim-success-pay-bill': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '2BxB06D6dKAuosyeOqeO2U',
      type: 'Entry',
      createdAt: '2018-02-16T17:01:04.181Z',
      updatedAt: '2018-02-16T17:01:04.181Z',
      publishedVersion: 7,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Submit Claim - Success Pay Bill',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '7gyDRgZidqWCcyoIgKkWa4',
          type: 'Entry',
          createdAt: '2018-02-16T16:59:28.098Z',
          updatedAt: '2018-03-27T14:50:58.124Z',
          publishedVersion: 16,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'Submit Claim - Success - Pay Bill Flow - Default',
          content:
            '## Success!\nWe have received your payment request. \n\nThis transaction may take up to 5 business days to process. You can see the status of your request under Recent Activity on the Accounts screen.',
        },
      },
      contentAreaSlug: 'submit-claim-success-pay-bill',
    },
  },
  'submit-claim-success-get-reimbursed': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '6DbIOoMY9im4YkIwu6IeaG',
      type: 'Entry',
      createdAt: '2018-02-16T16:59:59.628Z',
      updatedAt: '2018-02-16T16:59:59.628Z',
      publishedVersion: 19,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Submit Claim - Success Get Reimbursed',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'BiNua5hwZMWiUQkiiO0CG',
          type: 'Entry',
          createdAt: '2018-02-16T16:59:11.321Z',
          updatedAt: '2018-03-27T14:46:31.611Z',
          publishedVersion: 56,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'Submit Claim - Success - Get Reimbursed Flow - Default',
          content:
            '## Success!\nWe have received your reimbursement request. \n\nThis transaction may take up to 5 business days to process. You can see the status of your request under Recent Activity on the Accounts screen.',
        },
      },
      contentAreaSlug: 'submit-claim-success-get-reimbursed',
    },
  },
  'remove-provider-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '1w4LJreHv2wGEwEsS46GCk',
      type: 'Entry',
      createdAt: '2018-02-16T03:17:10.135Z',
      updatedAt: '2018-02-16T03:17:10.135Z',
      publishedVersion: 14,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Remove Provider - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1uZ3I1rxtmMGewigeO0woW',
          type: 'Entry',
          createdAt: '2018-02-16T03:14:52.177Z',
          updatedAt: '2018-03-27T14:49:31.312Z',
          publishedVersion: 54,
          revision: 4,
          locale: 'en-US',
        },
        fields: {
          title: 'Remove Provider - Success - Default',
          content:
            '## Success!\nYou have removed this provider from your profile. ',
        },
      },
      contentAreaSlug: 'remove-provider-success',
    },
  },
  'attach-documents-error': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '6ejHxyqB9Yy6WumkW4qgYw',
      type: 'Entry',
      createdAt: '2018-02-16T02:52:46.115Z',
      updatedAt: '2018-02-16T02:52:46.115Z',
      publishedVersion: 5,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Attach Documents - Error',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '2uIZUYzYpCoe2OuWGQsEgo',
          type: 'Entry',
          createdAt: '2018-02-16T02:47:26.697Z',
          updatedAt: '2018-03-14T16:20:11.249Z',
          publishedVersion: 107,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'Attach Documents - Error - Default',
          content:
            '## Unable to save file\n\nWe are unable to save the file you uploaded at this time. Please try again or contact Customer Service at %groupTollFreePhone% for assistance.',
        },
      },
      contentAreaSlug: 'attach-documents-error',
    },
  },
  'attach-documents-error-bad-file': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: 'If3uOa82ysmO02q8OAEqW',
      type: 'Entry',
      createdAt: '2018-02-16T02:52:09.641Z',
      updatedAt: '2018-02-16T02:52:09.641Z',
      publishedVersion: 5,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Attach Documents - Error Bad File',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'aag79QAVgcEmaYo6Iw8O2',
          type: 'Entry',
          createdAt: '2018-02-16T02:47:06.315Z',
          updatedAt: '2018-03-14T16:19:40.710Z',
          publishedVersion: 86,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'Attach Documents - Error Bad File - Default',
          content:
            "## Unable to read file\nWe're unable to read the file you uploaded. Please try again or contact Customer Service at %groupTollFreePhone% for assistance. ",
        },
      },
      contentAreaSlug: 'attach-documents-error-bad-file',
    },
  },
  'attach-documents-error-encrypted-pdf': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: 'jILxsEeaeAgo66U2OuI00',
      type: 'Entry',
      createdAt: '2018-02-16T02:50:23.764Z',
      updatedAt: '2018-02-16T02:50:23.764Z',
      publishedVersion: 4,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Attach Documents - Error Encrypted PDF',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6bmbzLCxJScyqkyoAKwoaE',
          type: 'Entry',
          createdAt: '2018-02-16T02:46:41.657Z',
          updatedAt: '2018-03-13T18:18:04.773Z',
          publishedVersion: 114,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Attach Documents - Error Encrypted PDF - Default',
          content:
            "## File is a password-protected PDF\n\nWe couldn't read this PDF because it's password protected. Please upload a PDF that isn't password protected.",
        },
      },
      contentAreaSlug: 'attach-documents-error-encrypted-pdf',
    },
  },
  'attach-documents-success': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '4hLBbRbs3KqugoEQMMq8ss',
      type: 'Entry',
      createdAt: '2018-02-16T02:48:17.922Z',
      updatedAt: '2018-02-16T02:48:17.922Z',
      publishedVersion: 4,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Attach Documents - Success',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '29NRcYEbgsewsugwiqiaE6',
          type: 'Entry',
          createdAt: '2018-02-16T02:45:52.233Z',
          updatedAt: '2020-02-07T19:28:38.478Z',
          publishedVersion: 46,
          revision: 3,
          locale: 'en-US',
        },
        fields: {
          title: 'Attach Documents - Success - Default',
          content: '## Success!\nYour file was successfully attached.',
        },
      },
      contentAreaSlug: 'attach-documents-success',
    },
  },
  'explanation-of-payment-appeal-rights': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '10TXLjDSiYgAuW4a2GyOIy',
      type: 'Entry',
      createdAt: '2018-02-16T02:23:17.354Z',
      updatedAt: '2018-02-16T02:23:17.354Z',
      publishedVersion: 21,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Explanation of Payment Appeal Rights',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '54JQk0xadGCAckIs6qce0w',
          type: 'Entry',
          createdAt: '2018-02-16T02:22:51.952Z',
          updatedAt: '2018-03-19T18:38:00.046Z',
          publishedVersion: 140,
          revision: 8,
          locale: 'en-US',
        },
        fields: {
          title: 'Appeal Rights',
          content:
            'If you have questions on how your claim was processed, please click the Important Information button below to review your important claims processing information and your complaint/appeal filing rights.',
        },
      },
      contentAreaSlug: 'explanation-of-payment-appeal-rights',
    },
  },
  'activate-hsa-terms-and-conditions': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '3Gs5Xt6WhqUwAEGiywOUWq',
      type: 'Entry',
      createdAt: '2018-02-16T00:05:17.202Z',
      updatedAt: '2018-02-16T00:05:17.202Z',
      publishedVersion: 9,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Activate HSA Terms & Conditions',
      contentAreaSlug: 'activate-hsa-terms-and-conditions',
    },
  },
  'account-holder-signature-text-pra': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '1bvlGOua3YsskEM8kaMOkW',
      type: 'Entry',
      createdAt: '2018-02-12T15:44:06.097Z',
      updatedAt: '2018-02-12T15:44:06.097Z',
      publishedVersion: 17,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Account Holder Signature Text - PRA',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '6eZBeTCt0WGywwesKmYCMo',
          type: 'Entry',
          createdAt: '2018-02-11T22:30:07.845Z',
          updatedAt: '2018-02-11T22:30:07.845Z',
          publishedVersion: 4,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Account Holder Signature Guidelines - PRA',
          content:
            'I certify that the expenses listed above have been incurred by me and/or my eligible dependents and qualify for reimbursement. These expenses have not been reimbursed and I will not seek reimbursement elsewhere. I understand that the expense for which I am reimbursed may not be used to claim any Federal income tax deduction or credit.',
        },
      },
      contentAreaSlug: 'account-holder-signature-text-pra',
    },
  },
  'account-holder-signature-text-dcap': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: 'js1yPwOK3YoyYimA6WY2A',
      type: 'Entry',
      createdAt: '2018-02-12T15:43:39.309Z',
      updatedAt: '2018-02-12T15:43:39.309Z',
      publishedVersion: 19,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Account Holder Signature Text - DCAP',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '10HMjtqqd4yKkuI0UY8CQ0',
          type: 'Entry',
          createdAt: '2018-02-11T22:30:58.531Z',
          updatedAt: '2018-02-11T22:30:58.531Z',
          publishedVersion: 11,
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'Account Holder Signature Guidelines - DCAP',
          content:
            'I authorize the above expenses to be reimbursed from my Dependent Care Reimbursement Account. To the best of my knowledge, my statements in this form are complete and true.\n\nI certify all of the following:\n- Dependent is eligible and under the age of 13 or dependent is incapable of taking care of themselves\n- Expenses qualify as valid work related Dependent Care Expenses (ineligible expenses include field trips, lunches, food items, school expenses including Kindergarten)\n- Expenses have not previously been reimbursed under the Dependent Care Reimbursement Account and I will not seek reimbursement under any other plan\n- The amount of reimbursement on this form added to the reimbursements I have received to date, does not exceed the statutory limits\n\nI understand the expenses reimbursed may not be used to claim any federal income tax deduction or credit (such as the Dependent Care Tax Credit).\n\nI agree to file Form 2441 with my tax return and provide any required taxpayer identification number.\n\nI have read, understand and make the certifications contained in the Daycare Expenses Reimbursement Claim for above.\n',
        },
      },
      contentAreaSlug: 'account-holder-signature-text-dcap',
    },
  },
  'account-holder-signature-text-fsa-hra-veba-or-hia': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '1FT964i1XOyYk4uo0SgKo0',
      type: 'Entry',
      createdAt: '2018-02-12T15:43:12.466Z',
      updatedAt: '2018-02-12T15:43:12.466Z',
      publishedVersion: 22,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Account Holder Signature Text - FSA, HRA, VEBA, or HIA',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1dXUWiNVxuM4GYGSQ8UGa6',
          type: 'Entry',
          createdAt: '2018-02-11T22:29:44.957Z',
          updatedAt: '2018-02-11T22:30:14.404Z',
          publishedVersion: 34,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Account Holder Signature Guidelines - FSA, HRA, VEBA, or HIA',
          content:
            'I certify that the expenses listed below have been incurred by me and/or my eligible dependents and qualify as valid medical expenses according to my Summary Plan Description. These expenses have not been reimbursed and I will not seek reimbursement under my medical plan or any other health plan, such as an individual policy or my spouse’s or dependent’s health plan or a flexible spending account plan. I understand that the expense for which I am reimbursed may not be used to claim any Federal income tax deduction or credit. I also understand that I may be asked to provide further details about some expenses (e.g., a statement from a medical practitioner that the expense is to treat a specific medical condition or a more detailed certification from me).',
        },
      },
      contentAreaSlug: 'account-holder-signature-text-fsa-hra-veba-or-hia',
    },
  },
  'attach-documents-guidelines': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: 'wqUjbdkJVIMi0UmmuAGEK',
      type: 'Entry',
      createdAt: '2018-01-30T23:08:01.609Z',
      updatedAt: '2018-01-30T23:08:01.609Z',
      publishedVersion: 15,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Attach Documents Guidelines',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'iYq1Ls8UTKkUuE6Qqcgka',
          type: 'Entry',
          createdAt: '2018-01-30T23:06:37.783Z',
          updatedAt: '2019-09-24T21:03:43.745Z',
          publishedVersion: 527,
          revision: 9,
          locale: 'en-US',
        },
        fields: {
          title: 'Attach Documents Guidelines',
          content:
            'Records to support a reimbursement or payment should include:\n\n- Date of service or purchase\n- Name of the person who received service or supplies\n- Name of the service or supply provider\n- Type of service or supplies you purchased\n- The amount you were charged for service or supplies, or the amount that was not reimbursed by your insurance provider\n\nYou can attach multiple files in the following formats: JPG, PDF, TIFF, PNG, GIF, or BMP. The total upload size must be less than 5MB. ',
        },
      },
      contentAreaSlug: 'attach-documents-guidelines',
    },
  },
  'default-contact-us-page-content': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '1nOB6gULwIeKY40i8cSMcC',
      type: 'Entry',
      createdAt: '2018-01-19T21:44:17.355Z',
      updatedAt: '2018-01-19T21:44:30.411Z',
      publishedVersion: 20,
      revision: 2,
      locale: 'en-US',
    },
    fields: {
      description: 'Contact Us Page Content',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '11PN9wZgucgQ2GScAo2UiC',
          type: 'Entry',
          createdAt: '2018-01-19T21:43:49.120Z',
          updatedAt: '2018-01-19T21:44:49.188Z',
          publishedVersion: 20,
          revision: 2,
          locale: 'en-US',
        },
        fields: { title: 'Contact Us', content: 'Contact Information' },
      },
      contentAreaSlug: 'default-contact-us-page-content',
    },
  },
  'security-policy-page-content': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '3hv66uWPmMUeWgU0uOcAoe',
      type: 'Entry',
      createdAt: '2017-12-19T20:59:17.453Z',
      updatedAt: '2017-12-19T20:59:17.453Z',
      publishedVersion: 14,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Security Policy Page Content',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '3J3Ji52Mo0AuM0kuMeMEym',
          type: 'Entry',
          createdAt: '2017-12-19T20:52:53.396Z',
          updatedAt: '2018-04-04T15:47:31.981Z',
          publishedVersion: 28,
          revision: 2,
          locale: 'en-US',
        },
        fields: {
          title: 'Security Policy',
          content:
            '## Security Policy\nProtecting the security of individuals’ private and sensitive member information is extremely important to us. Further maintains a robust security program consistent with the federal standard requirements for ethics of privacy and confidentiality.\n\nSecurity is not a one-time event. Good security is not simple. It is our job to understand, select, and deploy a variety of risk mitigation safeguards. We use a complex set of interacting networks, application and operating system safeguards include: Firewalls, Intrusion Detection, Monitoring Alarms, Encryption, ID codes, Passwords, Digital Certificates, Authentication, Secure Messaging, Audits and Security Tests. When software security improvements are available, we promptly apply them as needed. When new threats are discovered, we evaluate and act. We have significant resources dedicated to Privacy, Integrity & Security Compliance Services. We work directly with law enforcement officials to pursue any individuals who either fraudulently access or attempt to access or use information.\n\nWe strive to maintain the highest standards of decency, fairness, and integrity in our operations. On the internet, we take a number of measures to authenticate your identity when you access our services. We also take steps to protect sensitive information as it traverses the internet to and from your desktop. We make sure sensitive information is as secure as possible against unauthorized access and use. We also review our security measures periodically. We remain strongly committed to safeguarding customer information.\n\n## ID and Password Authentication\nWe use different pieces of information, collectively known as a personal identifier, to properly identify and authenticate you before allowing you secure access to sensitive information. The first piece of information is an initial User ID that is created from personal information.\n\nFor further security, we store your User ID and password on an encrypted database that is isolated from the internet.\n\n## Encryption and Security\nOur site uses the highest levels of Internet security. We require the use of a secure browser and take full advantage of its features such as data encryption-using Secure Sockets Layer (SSL) protocol, user names, passwords, digital certificates and other industry-recognized encryption standards.\n\nPlease do not disclose your Further internet access information to anyone. If you feel your account login information has been compromised or you need to report known incidents of unauthorized account access, please contactFurther Customer Service immediately.',
        },
      },
      contentAreaSlug: 'security-policy-page-content',
    },
  },
  'legal-terms-of-use-page-content': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '78AOuoLMtOWaec0SgsyYkO',
      type: 'Entry',
      createdAt: '2017-12-19T20:54:10.903Z',
      updatedAt: '2017-12-19T20:54:10.903Z',
      publishedVersion: 17,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Legal Terms of Use Page Content',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: 'xAk29plmScIYSQ8s02mug',
          type: 'Entry',
          createdAt: '2017-12-19T20:04:00.904Z',
          updatedAt: '2022-10-25T18:02:27.103Z',
          publishedVersion: 155,
          revision: 7,
          locale: 'en-US',
        },
        fields: {
          title: 'Legal Terms of Use',
          content:
            '## Legal Terms of Use\nPlease read the following legal terms and conditions relating to your use of our website carefully. By using our Web site, you agree to these Legal Terms and Conditions (“Legal Terms and Conditions”). We reserve the right, in our sole discretion, to change, modify, add or remove portions of these Legal Terms and Conditions at any time. Your use of our Web site following any such revisions will be deemed your acceptance of such revisions. You should periodically visit the Web site to review the current Legal Terms and Conditions to which you are bound. If you do not agree to these Legal Terms and Conditions, you should not use our Web Site and, if applicable, you should arrange to cancel your registered user account with us.\n\n## Copyright\nThe content of this Web site, including, without limitation, text, graphics, images and other material, including software developed and licensed by us, which permits the access and use of this Web site (collectively the “Content”), is protected by intellectual property laws, including copyright laws. All rights, title and interest in and to the Content remains vested in us and shall not pass to you or any other user.\n\n## Trademarks and Service Marks\nThe trade names, trademarks, service marks, logos, and slogans contained in this Web site that are the trade names, trademarks, service marks, logos and slogans of Further Operations, LLC (each a “Mark” and collectively the “Marks”). You are not authorized to use any Mark in any advertisement, publicity or in any other commercial manner without our prior written consent.\n\n## Warranty Disclaimer\nWhile efforts have been made to keep the information and Content on this Web site as accurate as possible, the information and Content may contain inaccuracies. Therefore, we do not guarantee the reliability, accuracy, completeness or appropriateness of any information or Content on this Web Site or make any representations about the results that may be obtained from the use of the information and/or Content on this Web site. The use of the information and Content on this Web site is at your own risk. The information and Content of this Web site is provided “AS IS” WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT.\n\n## Limitation of Liability\nWe shall not under any circumstances be liable to any person or entity for any special, incidental, indirect or consequential damages, including, without limitation, damages resulting from use of OR RELIANCE ON the information and Content on this Web site, loss of profits or revenues or costs of replacement products, even if informed in advance or otherwise aware of the possibility of such damages.\n\n## Information Cannot Be Construed as Advice\nThe information and content on this website is designed for your convenience to provide general information about Further Operations, LLC and its products and services. Further Operations, LLC cannot provide tax or investment advice. For specific tax filing questions, please consult your professional tax advisor. For investment advice, please consult your professional investment advisor.\n\n## Online Communications Security\nWe have taken precautionary measures to make all information from and to our online visitors as secure as possible against unauthorized access and use. However, no guarantee of 100% communications security can be made. You are also responsible for maintaining this security by taking reasonable measures such as keeping your ID and password private. If you believe your online security has been compromised or your communication is in regards to matters of a confidential nature, please contact Further directly by telephone at 800-859-2144 or write us at Further, P.O. Box 14836 Lexington, KY 40511.\n\n## Disclaimer of Endorsement\nReferences in this Web site to any third party products, services, processes, hypertext links to third parties or other information by trade name, trademark, manufacturer, supplier or otherwise does not necessarily constitute or imply its endorsement, sponsorship or recommendation by Further. Similarly, the fact that other third party sites may provide information about Further and/or provide links to this Web site does not necessarily constitute or imply the endorsement of such other third parties, their products or services by Further. We may also make forums, message boards and news groups available to you. Please understand that any information that is disclosed in these areas could become public information. We have no control over its use and you should exercise caution when deciding to disclose any personal information.\n\n## Links to Other Sites\nThis Web site and Content may contain links to web sites operated by third parties with or without single sign-on capability. These links are provided solely for convenience and reference purposes only. Please know that when you choose to use any of the links provided, you will be leaving this Web site and going to a new Web site. The inclusion of any such link does not imply that we endorse the content of any web site to which this Web site provides a link, nor are we liable for your reliance on or use of any information or materials contained in their site. By clicking on these links to access these services, users must be aware that they are entering into a business relationship that is wholly independent from Further, governed by the terms and conditions and privacy and other policies of the third-party. Where single sign-on capability is provided for convenience, Further only transmits limited data elements sufficient to uniquely identify the user; for example: first and last name, or account ID.  Further has no control over and makes no representations as to the privacy policies and practices of such third parties. When you click on links to outside sites and buy products, we may earn money from qualifying purchases.\n\n## Governing Law and Forum for Disputes\nBy accessing, transmitting or viewing any information on this Web site, you agree to be subject to personal jurisdiction in the State of Utah. Any claim or dispute arising out of accessing, transmitting or viewing any information on this Web site shall be venued in Salt Lake County, Utah and governed by the laws of the State of Utah.',
        },
      },
      contentAreaSlug: 'legal-terms-of-use-page-content',
    },
  },
  'non-discrimination-page-content': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: 'RWUxTKrrSoOKi0uyM0u4U',
      type: 'Entry',
      createdAt: '2017-12-19T19:25:09.112Z',
      updatedAt: '2017-12-19T19:25:09.112Z',
      publishedVersion: 15,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Non-Discrimination Page Content',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1CI6K9iKB6Cy6qoGkaAA8O',
          type: 'Entry',
          createdAt: '2017-12-19T19:23:49.788Z',
          updatedAt: '2022-10-25T18:02:27.135Z',
          publishedVersion: 116,
          revision: 5,
          locale: 'en-US',
        },
        fields: {
          title: 'Non-Discrimination',
          content:
            "## Notice Of Rights About Nondiscrimination and Accessibility\n\nEffective July 18, 2016\nUpdated November 1, 2021\n\nFurther Operations, LLC complies with applicable Federal civil rights laws and does not discriminate on the basis of race, color, national origin, age, disability, or gender. Further does not exclude people or treat them differently because of race, color, national origin, age, disability, or gender.\n\nFurther provides resources to access information in alternative formats and languages:\n\n- Auxiliary aids and services, such as qualified interpreters and written information available in other formats, are available free of charge to people with disabilities to assist in communicating with us.\n- Language services, such as qualified interpreters and information written in other languages, are available free of charge to people whose primary language is not English.\n\nIf you need these services, contact Further Customer Service at 1-800-859-2144, M-F, 7 am to 8 pm Central Time. TTY users call 711.\n\nIf you believe that Further has failed to provide these services or discriminated in another way on the basis of race, color, national origin, age, disability, or gender, you can file a grievance with the Further Compliance Officer\n\n- by email at: Further.Compliance.Officer@hellofurther.com\n- by mail at: Further Compliance Officer\n\nFurther Operations, LLC\nP.O. Box 14836\nLexington, KY 40511\n\n- or by phone at: 1-800-859-2144\n- or by fax at : 1-866-231-0214\n\nGrievance forms are available by contacting us at the contacts listed above, by calling\n1-800-382-2000. TTY users call 711. If you need help filing a grievance, assistance is available by contacting us at the number listed above.\n\nYou can also file a civil rights complaint with the U.S. Department of Health and Human Services, Office for Civil Rights\n\n- electronically through the Office for Civil Rights Complaint Portal, available at:\nhttps://ocrportal.hhs.gov/ocr/portal/lobby.jsf\n- by phone at: 1-800-368-1019 or 1-800-537-7697 (TDD)\n- or by mail at:\nU.S. Department of Health and Human Services\n200 Independence Avenue SW\nRoom 509F\nHHH Building\nWashington, DC 20201\n\nComplaint forms are available at [http://www.hhs.gov/ocr/office/file/index.html](http://www.hhs.gov/ocr/office/file/index.html).\n\nThis information is available in other languages. Free language assistance services are available by calling the toll free number below. For TTY, call 711.\n\nSi habla español, tiene a su disposición servicios gratuitos de asistencia lingüística. Llame al 1-800-859-2144 (TTY: 711).\n\n如果您使用繁體中文，您可以免費獲得語言援助服務。請致電 1-800-859-2144 (TTY: 711)。\n\nNếu bạn nói Tiếng Việt, có các dịch vụ hỗ trợ ngôn ngữ miễn phí dành cho bạn. Gọi số 1-800-859-2144 (TTY: 711).\n\n한국어를 사용하시는 경우, 언어 지원 서비스를 무료로 이용하실 수 있습니다. 1-800-859-2144 (TTY: 711)번으로 전화해 주십시오.\n\nKung nagsasalita ka ng Tagalog, maaari kang gumamit ng mga serbisyo ng tulong sa wika nang walang bayad. Tumawag sa 1-800-859-2144 (TTY: 711)\n\nملحوظة: إذا كنت تتحدث اذكر اللغة، فإن خدمات المساعدة اللغوية تتوافر لك بالمجان. اتصل برقم 1- 1-800-859-2144 (رقم هاتف الصم والبكم: 1-711).\n\nSi w pale Kreyòl Ayisyen, gen sèvis èd pou lang ki disponib gratis pou ou. Rele 1-800-859-2144 (TTY: 711).\n\nSi vous parlez français, des services d'aide linguistique vous sont proposés gratuitement. Appelez le 1-800-859-2144 (ATS : 711).\n\nJeżeli mówisz po polsku, możesz skorzystać z bezpłatnej pomocy językowej. Zadzwoń pod numer 1-800-859-2144 (TTY: 711).\n\nSe fala português, encontram-se disponíveis serviços linguísticos, grátis. Ligue para 1-800-859-2144 (TTY: 711).\n\nIn caso la lingua parlata sia l'italiano, sono disponibili servizi di assistenza linguistica gratuiti. Chiamare il numero 1-800-859-2144 (TTY: 711).\n\nWenn Sie Deutsch sprechen, stehen Ihnen kostenlos sprachliche Hilfsdienstleistungen zur Verfügung. Rufnummer: 1-800-859-2144 (TTY: 711).\n\n日本語を話される場合、無料の言語支援をご利用いただけます。1-800-859-2144 (TTY:711）まで、お電話にてご連絡ください。\n\nتوجه: اگر به زبان فارسی گفتگو می کنید، تسهیلات زبانی بصورت رایگان برای شما فراهم می باشد. با 1-800-859-2144 (TTY: 711) تماس بگیرید.",
        },
      },
      contentAreaSlug: 'non-discrimination-page-content',
    },
  },
  'need-help-link-list': {
    metadata: { tags: [], concepts: [] },
    sys: {
      id: '5Fs5niSfSwOWk6Gei4oKoM',
      type: 'Entry',
      createdAt: '2017-12-19T17:43:59.011Z',
      updatedAt: '2017-12-19T17:43:59.011Z',
      publishedVersion: 10,
      revision: 1,
      locale: 'en-US',
    },
    fields: {
      description: 'Need Help Link List',
      default_content: {
        metadata: { tags: [], concepts: [] },
        sys: {
          id: '1Glp4v5aNeUQSGsgW0Q0o2',
          type: 'Entry',
          createdAt: '2017-12-18T21:58:57.212Z',
          updatedAt: '2018-03-21T16:45:10.057Z',
          publishedVersion: 165,
          revision: 14,
          locale: 'en-US',
        },
        fields: {
          title: 'Need Help Information',
          headline: 'Need Help?',
          content: '[Contact Us](route="contactUs")',
        },
      },
      contentAreaSlug: 'need-help-link-list',
    },
  },
};
